webpackJsonp([3],{

/***/ 522:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(844);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1cabe6b2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(850);
var normalizeComponent = __webpack_require__(7)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1cabe6b2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 530:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze__);

var defaultMapFunction = function defaultMapFunction(data) {
  return { value: data, label: data };
};

/* harmony default export */ __webpack_exports__["a"] = ({
  make: function make(dataArray, mapFunction) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze___default()(dataArray.map(
    // Use the default map function if no mapFunction is provided
    typeof mapFunction === 'function' ? mapFunction : defaultMapFunction));
  }
});

/***/ }),

/***/ 531:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze__);

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze___default()(['Singapore', 'Malaysia', 'Taiwan', 'South Korea', 'Hong Kong', 'Philippines', 'Thailand', 'Vietnam', 'Indonesia', 'Japan', 'Afghanistan', 'Albania', 'Algeria', 'American Samoa', 'Andorra', 'Angola', 'Anguilla', 'Antarctica', 'Antigua and Barbuda', 'Argentina', 'Armenia', 'Aruba', 'Australia', 'Austria', 'Azerbaijan', 'Bahamas', 'Bahrain', 'Bangladesh', 'Barbados', 'Belarus', 'Belgium', 'Belize', 'Benin', 'Bermuda', 'Bhutan', 'Bolivia', 'Bosnia and Herzegovina', 'Botswana', 'Bouvet Island', 'Brazil', 'British Indian Ocean Territory', 'Brunei Darussalam', 'Bulgaria', 'Burkina Faso', 'Burundi', 'Cambodia', 'Cameroon', 'Canada', 'Cape Verde', 'Cayman Islands', 'Central African Republic', 'Chad', 'Chile', 'China', 'Christmas Island', 'Cocos Islands', 'Colombia', 'Comoros', 'Congo', 'Congo, Democratic Republic of the', 'Cook Islands', 'Costa Rica', 'Cote d\'Ivoire', 'Croatia', 'Cuba', 'Cyprus', 'Czech Republic', 'Denmark', 'Djibouti', 'Dominica', 'Dominican Republic', 'Ecuador', 'Egypt', 'El Salvador', 'Equatorial Guinea', 'Eritrea', 'Estonia', 'Ethiopia', 'Falkland Islands', 'Faroe Islands', 'Fiji', 'Finland', 'France', 'French Guiana', 'French Polynesia', 'Gabon', 'Gambia', 'Georgia', 'Germany', 'Ghana', 'Gibraltar', 'Greece', 'Greenland', 'Grenada', 'Guadeloupe', 'Guam', 'Guatemala', 'Guinea', 'Guinea-Bissau', 'Guyana', 'Haiti', 'Heard Island and McDonald Islands', 'Honduras', 'Hungary', 'Iceland', 'India', 'Iran', 'Iraq', 'Ireland', 'Israel', 'Italy', 'Jamaica', 'Jordan', 'Kazakhstan', 'Kenya', 'Kiribati', 'Kuwait', 'Kyrgyzstan', 'Laos', 'Latvia', 'Lebanon', 'Lesotho', 'Liberia', 'Libya', 'Liechtenstein', 'Lithuania', 'Luxembourg', 'Macao', 'Madagascar', 'Malawi', 'Maldives', 'Mali', 'Malta', 'Marshall Islands', 'Martinique', 'Mauritania', 'Mauritius', 'Mayotte', 'Mexico', 'Micronesia', 'Moldova', 'Monaco', 'Mongolia', 'Montenegro', 'Montserrat', 'Morocco', 'Mozambique', 'Myanmar', 'Namibia', 'Nauru', 'Nepal', 'Netherlands', 'Netherlands Antilles', 'New Caledonia', 'New Zealand', 'Nicaragua', 'Niger', 'Nigeria', 'Norfolk Island', 'North Korea', 'Norway', 'Oman', 'Pakistan', 'Palau', 'Palestinian Territory', 'Panama', 'Papua New Guinea', 'Paraguay', 'Peru', 'Pitcairn', 'Poland', 'Portugal', 'Puerto Rico', 'Qatar', 'Romania', 'Russian Federation', 'Rwanda', 'Saint Helena', 'Saint Kitts and Nevis', 'Saint Lucia', 'Saint Pierre and Miquelon', 'Saint Vincent and the Grenadines', 'Samoa', 'San Marino', 'Sao Tome and Principe', 'Saudi Arabia', 'Senegal', 'Serbia', 'Seychelles', 'Sierra Leone', 'Slovakia', 'Slovenia', 'Solomon Islands', 'Somalia', 'South Africa', 'South Georgia', 'Spain', 'Sri Lanka', 'Sudan', 'Suriname', 'Svalbard and Jan Mayen', 'Swaziland', 'Sweden', 'Switzerland', 'Syrian Arab Republic', 'Tajikistan', 'Tanzania', 'The Former Yugoslav Republic of Macedonia', 'Timor-Leste', 'Togo', 'Tokelau', 'Tonga', 'Trinidad and Tobago', 'Tunisia', 'Turkey', 'Turkmenistan', 'Tuvalu', 'Uganda', 'Ukraine', 'United Arab Emirates', 'United Kingdom', 'United States', 'United States Minor Outlying Islands', 'Uruguay', 'Uzbekistan', 'Vanuatu', 'Vatican City', 'Venezuela', 'Virgin Islands, British', 'Virgin Islands, U.S', 'Wallis and Futuna', 'Western Sahara', 'Yemen', 'Zambia', 'Zimbabwe']));

/***/ }),

/***/ 532:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);

var formValidationMixin = {
  methods: {
    validate: function validate(prop) {
      var forms = [];
      if (Array.isArray(this.$refs.form)) {
        forms = this.$refs.form;
      } else {
        forms.push(this.$refs.form);
      }

      var promises = forms.map(function (formC) {
        return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
          if (prop) {
            formC.validateField(prop, function (errorMessage) {
              if (!errorMessage) resolve();else reject(new Error(errorMessage));
            });
          } else {
            formC.validate(function (valid) {
              if (valid) resolve();else reject(formC);
            });
          }
        });
      });
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(promises);
    }
  },
  mounted: function mounted() {
    // Require updateForm to exist
    if (!this.$refs.form) throw new Error('formValidationMixin require a reference to `form`.');
  }
};

/* harmony default export */ __webpack_exports__["a"] = (formValidationMixin);

/***/ }),

/***/ 538:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CollaboratorTable_vue__ = __webpack_require__(550);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0bf0aa3e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CollaboratorTable_vue__ = __webpack_require__(559);
function injectStyle (ssrContext) {
  __webpack_require__(548)
}
var normalizeComponent = __webpack_require__(7)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CollaboratorTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0bf0aa3e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CollaboratorTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 539:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FilmmakerDetailsForm_vue__ = __webpack_require__(542);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f2c72ce_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FilmmakerDetailsForm_vue__ = __webpack_require__(543);
function injectStyle (ssrContext) {
  __webpack_require__(540)
}
var normalizeComponent = __webpack_require__(7)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5f2c72ce"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FilmmakerDetailsForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f2c72ce_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FilmmakerDetailsForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 540:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(541);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(512)("56e2b31f", content, true);

/***/ }),

/***/ 541:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(511)(true);
// imports


// module
exports.push([module.i, ".el-select[data-v-5f2c72ce]{display:block}", "", {"version":3,"sources":["/app/src/components/Profile/FilmmakerDetailsForm.vue"],"names":[],"mappings":"AAoHA,4BACE,aAAe,CAChB","file":"FilmmakerDetailsForm.vue","sourcesContent":["/* Transition\n-------------------------- */\n/* Colors\n-------------------------- */\n/* Font\n-------------------------- */\n/* Element Chalk Variables */\n/* Transition\n-------------------------- */\n/* Colors\n-------------------------- */\n/* 53a8ff */\n/* 66b1ff */\n/* 79bbff */\n/* 8cc5ff */\n/* a0cfff */\n/* b3d8ff */\n/* c6e2ff */\n/* d9ecff */\n/* ecf5ff */\n/* Link\n-------------------------- */\n/* Background\n-------------------------- */\n/* Border\n-------------------------- */\n/* Box-shadow\n-------------------------- */\n/* Fill\n-------------------------- */\n/* Font\n-------------------------- */\n/* Size\n-------------------------- */\n/* z-index\n-------------------------- */\n/* Disable base\n-------------------------- */\n/* Icon\n-------------------------- */\n/* Checkbox\n-------------------------- */\n/* Radio\n-------------------------- */\n/* Select\n-------------------------- */\n/* Alert\n-------------------------- */\n/* Message Box\n-------------------------- */\n/* Message\n-------------------------- */\n/* Notification\n-------------------------- */\n/* Input\n-------------------------- */\n/* Cascader\n-------------------------- */\n/* Group\n-------------------------- */\n/* Tab\n-------------------------- */\n/* Button\n-------------------------- */\n/* cascader\n-------------------------- */\n/* Switch\n-------------------------- */\n/* Dialog\n-------------------------- */\n/* Table\n-------------------------- */\n/* Pagination\n-------------------------- */\n/* Popover\n-------------------------- */\n/* Tooltip\n-------------------------- */\n/* Tag\n-------------------------- */\n/* Tree\n-------------------------- */\n/* Dropdown\n-------------------------- */\n/* Badge\n-------------------------- */\n/* Card\n--------------------------*/\n/* Slider\n--------------------------*/\n/* Steps\n--------------------------*/\n/* Menu\n--------------------------*/\n/* Rate\n--------------------------*/\n/* DatePicker\n--------------------------*/\n/* Loading\n--------------------------*/\n/* Scrollbar\n--------------------------*/\n/* Carousel\n--------------------------*/\n/* Collapse\n--------------------------*/\n/* Transfer\n--------------------------*/\n/* Header\n  --------------------------*/\n/* Footer\n--------------------------*/\n/* Main\n--------------------------*/\n/* Break-point\n--------------------------*/\n.el-select[data-v-5f2c72ce] {\n  display: block;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 542:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_formValidationMixin__ = __webpack_require__(532);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_selectorDataMaker__ = __webpack_require__(530);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_data_countries__ = __webpack_require__(531);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// Data


/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_formValidationMixin__["a" /* default */]],
  props: {
    value: {},
    editable: {
      type: Boolean,
      default: true
    },
    showReferral: {
      type: Boolean,
      default: true
    },
    showEmail: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      form: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.value),
      rules: {
        name: [{ required: true, trigger: 'change' }],
        email: [{ type: 'email', trigger: 'blur' }, { required: true, trigger: 'change' }],
        contact_number: [{ required: true, trigger: 'change', message: 'contact number is required' }, { min: 6, trigger: 'blur', message: 'contact number is required' }],
        address: [{ required: true, trigger: 'change' }],
        city: [{ required: true, trigger: 'change' }],
        postal_code: [{ required: true, trigger: 'change' }],
        country: [{ required: true, trigger: 'change' }],
        company_name: []
      },
      countries: __WEBPACK_IMPORTED_MODULE_2__utils_selectorDataMaker__["a" /* default */].make(__WEBPACK_IMPORTED_MODULE_3__assets_data_countries__["a" /* default */])
    };
  },

  methods: {
    input: function input() {
      this.$emit('input', this.form);
    }
  }
});

/***/ }),

/***/ 543:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-form',{ref:"form",attrs:{"label-position":"top","model":_vm.form,"rules":_vm.rules}},[_c('el-row',{attrs:{"gutter":20}},[_c('el-col',{attrs:{"xs":24,"sm":_vm.showEmail ? 24 : 12}},[_c('el-form-item',{attrs:{"label":"Full name of rights holder","prop":"name"}},[_c('el-input',{attrs:{"auto-complete":"name","disabled":!_vm.editable},on:{"input":_vm.input},model:{value:(_vm.form.name),callback:function ($$v) {_vm.$set(_vm.form, "name", $$v)},expression:"form.name"}})],1)],1),_vm._v(" "),(_vm.showEmail)?_c('el-col',{attrs:{"xs":24,"sm":12}},[_c('el-form-item',{attrs:{"label":"Email","prop":"email"}},[_c('el-input',{attrs:{"auto-complete":"email","disabled":!_vm.editable},on:{"input":_vm.input},model:{value:(_vm.form.email),callback:function ($$v) {_vm.$set(_vm.form, "email", $$v)},expression:"form.email"}})],1)],1):_vm._e(),_vm._v(" "),_c('el-col',{attrs:{"xs":24,"sm":12}},[_c('el-form-item',{attrs:{"label":"Contact number","prop":"contact_number"}},[_c('sh-el-tel-input',{attrs:{"disabled":!_vm.editable},model:{value:(_vm.form.contact_number),callback:function ($$v) {_vm.$set(_vm.form, "contact_number", $$v)},expression:"form.contact_number"}}),_vm._v(" "),_c('el-input',{staticStyle:{"display":"none"},attrs:{"value":_vm.form.contact_number}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"xs":24,"sm":12}},[_c('el-form-item',{attrs:{"label":"Address","prop":"address"}},[_c('el-input',{attrs:{"auto-complete":"address-line1","disabled":!_vm.editable},on:{"input":_vm.input},model:{value:(_vm.form.address),callback:function ($$v) {_vm.$set(_vm.form, "address", $$v)},expression:"form.address"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"xs":24,"sm":6}},[_c('el-form-item',{attrs:{"label":"City","prop":"city"}},[_c('el-input',{attrs:{"auto-complete":"address-level2","disabled":!_vm.editable},on:{"input":_vm.input},model:{value:(_vm.form.city),callback:function ($$v) {_vm.$set(_vm.form, "city", $$v)},expression:"form.city"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"xs":24,"sm":6}},[_c('el-form-item',{attrs:{"label":"Postal Code","prop":"postal_code"}},[_c('el-input',{attrs:{"auto-complete":"postal-code","disabled":!_vm.editable},on:{"input":_vm.input},model:{value:(_vm.form.postal_code),callback:function ($$v) {_vm.$set(_vm.form, "postal_code", $$v)},expression:"form.postal_code"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"xs":24,"sm":12}},[_c('el-form-item',{attrs:{"label":"Country","prop":"country"}},[_c('el-select',{attrs:{"disabled":!_vm.editable,"filterable":""},on:{"input":_vm.input},model:{value:(_vm.form.country),callback:function ($$v) {_vm.$set(_vm.form, "country", $$v)},expression:"form.country"}},_vm._l((_vm.countries),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}))],1)],1),_vm._v(" "),_c('el-col',{attrs:{"xs":24,"sm":12}},[_c('el-form-item',{attrs:{"label":"Company name","prop":"company_name"}},[_c('el-input',{attrs:{"auto-complete":"off","disabled":!_vm.editable},on:{"input":_vm.input},model:{value:(_vm.form.company_name),callback:function ($$v) {_vm.$set(_vm.form, "company_name", $$v)},expression:"form.company_name"}})],1)],1),_vm._v(" "),(_vm.showReferral)?_c('el-col',{attrs:{"xs":24,"sm":12}},[_c('el-form-item',{attrs:{"label":"Referral","prop":"referral"}},[_c('p',{staticClass:"instruction"},[_vm._v("\n          Film festival or curator who recommended you to Viddsee\n        ")]),_vm._v(" "),_c('el-input',{attrs:{"auto-complete":"off"},on:{"input":_vm.input},model:{value:(_vm.form.referral),callback:function ($$v) {_vm.$set(_vm.form, "referral", $$v)},expression:"form.referral"}})],1)],1):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 544:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Clause */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Agreement; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__clauseRenderNode__ = __webpack_require__(601);

// @ts-check


/**
 *
 * @param {string | null} value
 * @returns {null | Date}
 */
var normalizeDateTime = function normalizeDateTime(value) {
  return value == null ? null : new Date(value);
};
/**
 * @param {string} value
 * @returns {Date}
 */
var normalizeRequiredDateTime = function normalizeRequiredDateTime(value) {
  return new Date(value);
};

var Clause = function Clause(clause) {
  var _this = this;

  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Clause);

  this.id = clause.id;
  this.supplementaryAgreementId = clause.supplementary_agreement_id;
  this.code = clause.code;
  this.isRequired = !!clause.is_required;
  this.initialValues = Array.isArray(clause.initial_values) && clause.initial_values.length > 0 ? clause.initial_values : [];

  this.layoutPdf = clause.layout_pdf;
  this.type = clause.type;
  this.createdAt = normalizeRequiredDateTime(clause.created_at);
  this.updatedAt = normalizeRequiredDateTime(clause.updated_at);
  this.permittedValues = clause.permitted_values;

  this.layoutWeb = (clause.layout_web || []).map(function (node) {
    return __WEBPACK_IMPORTED_MODULE_1__clauseRenderNode__["a" /* ClauseNode */].create(node, _this);
  });
};

var Agreement = function Agreement(agreement) {
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Agreement);

  this.id = agreement.id;
  this.code = agreement.code;
  this.title = agreement.title;
  this.description = agreement.description;
  this.startDate = normalizeDateTime(agreement.start_date);
  this.endDate = normalizeDateTime(agreement.end_date);
  this.validityDurationDays = agreement.validity_duration_days;
  this.createdAt = normalizeRequiredDateTime(agreement.created_at);
  this.updatedAt = normalizeRequiredDateTime(agreement.updated_at);

  /**
   * @type {Clause[]}
   */
  this.clauses = (agreement.clauses || []).map(function (clause) {
    return new Clause(clause);
  });
};

/***/ }),

/***/ 545:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
// @ts-check


/**
 * @type {() => import('@/classes/agreement').Clause}
 */
var ClauseObjectType = Object;

/**
 * @typedef {import('@/classes/clauseRenderNode').ClauseNodeValues} ClauseNodeValues
 */
/**
 * @type {() => ClauseNodeValues}
 */
var ValueArrayType = Array;

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
  props: {
    clause: {
      type: ClauseObjectType,
      required: true
    },

    value: {
      type: ValueArrayType,
      required: true
    }
  },

  render: function render(h) {
    var _this = this;

    /**
     * @type {ReturnType<typeof ClauseObjectType>}
     */
    var clause = this.clause;

    var children = clause.layoutWeb.map(function (node) {
      return node.render(h, _this.renderContext);
    });

    return h('div', children);
  },


  computed: {
    /**
     * @return {import('@/classes/clauseRenderNode').ClauseNodeRenderContext}
     */
    renderContext: function renderContext() {
      /**
       * @type {ClauseNodeValues}
       */
      var value = this.value;

      return {
        props: {
          value: value
        },
        on: {
          input: this.onInputHandler
        }
      };
    }
  },

  methods: {
    /**
     *
     * @param {ClauseNodeValues} data
     */
    onInputHandler: function onInputHandler(data) {
      this.$emit('input', data);
    }
  }
}));

/***/ }),

/***/ 548:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(549);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(512)("050f9e1e", content, true);

/***/ }),

/***/ 549:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(511)(true);
// imports


// module
exports.push([module.i, ".collaborator-table{-webkit-box-shadow:0 0 16px 0 rgba(0,0,0,.05);box-shadow:0 0 16px 0 rgba(0,0,0,.05)}", "", {"version":3,"sources":["/app/src/components/Submission/steps/CollaboratorDetails/CollaboratorItem/CollaboratorTable.vue"],"names":[],"mappings":"AACA,oBACE,8CAAsD,AAC9C,qCAA8C,CACvD","file":"CollaboratorTable.vue","sourcesContent":["\n.collaborator-table {\n  -webkit-box-shadow: 0px 0px 16px 0px rgba(0,0,0,0.05);\n          box-shadow: 0px 0px 16px 0px rgba(0,0,0,0.05);\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 550:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_table__ = __webpack_require__(551);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_table_column__ = __webpack_require__(552);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_table_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_table_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config_notify_constants__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_data_viddsee_collaboratorRoles__ = __webpack_require__(553);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__EditView__ = __webpack_require__(554);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
  * Current modification to the cell of this component will directly modify the
  * parent value. Because of this, Create, Update and Delete method is by
  * default not required.
  *
  * If this is not desirable, we may need to relook into the data flow
  * of this module.
 */








__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_table___default.a);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_table_column___default.a);

var roles = __WEBPACK_IMPORTED_MODULE_6__assets_data_viddsee_collaboratorRoles__["a" /* COLLABORATOR_ROLES */].filter(function (role) {
  return role !== 'Director';
}).map(function (role) {
  return {
    label: role,
    value: role.toLowerCase()
  };
});

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    EditView: __WEBPACK_IMPORTED_MODULE_7__EditView__["a" /* default */]
  },
  props: {
    // Values
    value: {
      type: Array,
      required: true
    },
    defaultRole: {},

    // UI State
    disabled: {
      type: Boolean,
      default: false
    },
    showAction: {
      type: Boolean,
      default: true
    },
    isTemporary: {
      type: Boolean,
      default: false
    },
    showHeader: {
      type: Boolean,
      default: true
    },

    // Methods
    updateFn: {
      type: Function,
      default: function _default(humanId, human) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve({ data: human });
      }
    },
    createFn: {
      type: Function,
      default: function _default(human) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve({ data: human });
      }
    },
    removeFn: {
      type: Function,
      default: function _default() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve();
      }
    },
    enableTyping: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      roles: roles,
      buffer: [],
      hasUnsaved: false
    };
  },

  computed: {
    humans: function humans() {
      return this.value;
    }
  },
  watch: {
    humans: function humans() {
      this.updateUnsavedStatus();
    }
  },
  methods: {
    cancelEdit: function cancelEdit(index) {
      __WEBPACK_IMPORTED_MODULE_2_vue__["default"].set(this.humans[index], 'editable', false);

      if (this.buffer[index]) {
        __WEBPACK_IMPORTED_MODULE_2_vue__["default"].set(this.humans, index, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.buffer[index]));
      } else {
        __WEBPACK_IMPORTED_MODULE_2_vue__["default"].delete(this.humans, index);
      }
    },
    editCollaborator: function editCollaborator(index) {
      // TODO: Ideally speaking, this component should keep a local copy of the array,
      //       so that the original data is not modified.
      //       For now, the collaborator component will always grab the network copy on mounted.
      //       Do a shallow copy first.
      this.buffer[index] = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.humans[index]);
      __WEBPACK_IMPORTED_MODULE_2_vue__["default"].set(this.humans[index], 'editable', true);
    },
    verifyCollaborator: function verifyCollaborator(index) {
      var human = this.humans[index];
      var notDirectorOtherwiseNeedEmail = human.role !== 'director' || human.email;

      var rules = [{
        prop: human.first_name,
        message: 'First name is required'
      }, {
        prop: human.last_name,
        message: 'Last name is required'
      }, {
        prop: human.role,
        message: 'Role is required'
      }, {
        prop: notDirectorOtherwiseNeedEmail,
        message: 'Email is required for director'
      }];

      var hasError = rules.find(function (rule) {
        return !rule.prop;
      });

      return hasError;
    },
    saveCollaborator: function saveCollaborator(index) {
      var _this = this;

      var collaboratorError = this.verifyCollaborator(index);
      if (collaboratorError) {
        this.$notify.error({
          title: 'Error',
          message: collaboratorError.message,
          duration: __WEBPACK_IMPORTED_MODULE_5__config_notify_constants__["a" /* default */].DURATION.MEDIUM
        });
        return;
      }

      var human = this.humans[index];
      var promise = human.id == null ? this.createFn(human, this.humans) : this.updateFn(human.id, human, this.humans);
      __WEBPACK_IMPORTED_MODULE_2_vue__["default"].set(this.humans[index], 'editable', false);

      promise.then(function (_ref) {
        var data = _ref.data;

        __WEBPACK_IMPORTED_MODULE_2_vue__["default"].set(_this.humans, index, data);
      })
      // TODO: Handle network errro
      .catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_2_vue__["default"].set(_this.humans[index], 'editable', false);
        throw error;
      }).then(function () {
        _this.$emit('change', _this.humans);
      });
    },
    removeCollaborator: function removeCollaborator(index) {
      var _this2 = this;

      var human = this.humans[index];
      this.removeFn(human.id, this.humans).then(function () {
        __WEBPACK_IMPORTED_MODULE_2_vue__["default"].delete(_this2.humans, index);
      })
      // TODO: Handle network error
      .catch(function (error) {
        throw error;
      }).then(function () {
        _this2.$emit('change', _this2.humans);
      });
    },
    updateUnsavedStatus: function updateUnsavedStatus() {
      var _this3 = this;

      var hasUnsaved = this.humans.some(function (humanObj) {
        if (humanObj.editable) {
          if (_this3.buffer.length === 0) {
            return (humanObj.first_name || '').trim() || (humanObj.last_name || '').trim() || (humanObj.email || '').trim();
          }
          return true;
        } else {
          return false;
        }
      });
      if (hasUnsaved !== this.hasUnsaved) {
        this.hasUnsaved = hasUnsaved;
        this.$emit('editing', hasUnsaved);
      }
    }
  }
});

/***/ }),

/***/ 551:
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 183);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file.
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate

    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),

/***/ 10:
/***/ (function(module, exports) {

module.exports = __webpack_require__(102);

/***/ }),

/***/ 12:
/***/ (function(module, exports) {

module.exports = __webpack_require__(71);

/***/ }),

/***/ 16:
/***/ (function(module, exports) {

module.exports = __webpack_require__(181);

/***/ }),

/***/ 17:
/***/ (function(module, exports) {

module.exports = __webpack_require__(43);

/***/ }),

/***/ 183:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(184);


/***/ }),

/***/ 184:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _table = __webpack_require__(185);

var _table2 = _interopRequireDefault(_table);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
_table2.default.install = function (Vue) {
  Vue.component(_table2.default.name, _table2.default);
};

exports.default = _table2.default;

/***/ }),

/***/ 185:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_table_vue__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_table_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_table_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_271dac46_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_table_vue__ = __webpack_require__(196);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_table_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_271dac46_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_table_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 186:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _checkbox = __webpack_require__(16);

var _checkbox2 = _interopRequireDefault(_checkbox);

var _throttle = __webpack_require__(36);

var _throttle2 = _interopRequireDefault(_throttle);

var _debounce = __webpack_require__(12);

var _debounce2 = _interopRequireDefault(_debounce);

var _resizeEvent = __webpack_require__(19);

var _locale = __webpack_require__(4);

var _locale2 = _interopRequireDefault(_locale);

var _migrating = __webpack_require__(7);

var _migrating2 = _interopRequireDefault(_migrating);

var _tableStore = __webpack_require__(187);

var _tableStore2 = _interopRequireDefault(_tableStore);

var _tableLayout = __webpack_require__(188);

var _tableLayout2 = _interopRequireDefault(_tableLayout);

var _tableBody = __webpack_require__(189);

var _tableBody2 = _interopRequireDefault(_tableBody);

var _tableHeader = __webpack_require__(190);

var _tableHeader2 = _interopRequireDefault(_tableHeader);

var _tableFooter = __webpack_require__(195);

var _tableFooter2 = _interopRequireDefault(_tableFooter);

var _util = __webpack_require__(37);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var tableIdSeed = 1;

exports.default = {
  name: 'ElTable',

  mixins: [_locale2.default, _migrating2.default],

  props: {
    data: {
      type: Array,
      default: function _default() {
        return [];
      }
    },

    size: String,

    width: [String, Number],

    height: [String, Number],

    maxHeight: [String, Number],

    fit: {
      type: Boolean,
      default: true
    },

    stripe: Boolean,

    border: Boolean,

    rowKey: [String, Function],

    context: {},

    showHeader: {
      type: Boolean,
      default: true
    },

    showSummary: Boolean,

    sumText: String,

    summaryMethod: Function,

    rowClassName: [String, Function],

    rowStyle: [Object, Function],

    cellClassName: [String, Function],

    cellStyle: [Object, Function],

    headerRowClassName: [String, Function],

    headerRowStyle: [Object, Function],

    headerCellClassName: [String, Function],

    headerCellStyle: [Object, Function],

    highlightCurrentRow: Boolean,

    currentRowKey: [String, Number],

    emptyText: String,

    expandRowKeys: Array,

    defaultExpandAll: Boolean,

    defaultSort: Object,

    tooltipEffect: String,

    spanMethod: Function
  },

  components: {
    TableHeader: _tableHeader2.default,
    TableFooter: _tableFooter2.default,
    TableBody: _tableBody2.default,
    ElCheckbox: _checkbox2.default
  },

  methods: {
    getMigratingConfig: function getMigratingConfig() {
      return {
        events: {
          expand: 'expand is renamed to expand-change'
        }
      };
    },
    setCurrentRow: function setCurrentRow(row) {
      this.store.commit('setCurrentRow', row);
    },
    toggleRowSelection: function toggleRowSelection(row, selected) {
      this.store.toggleRowSelection(row, selected);
      this.store.updateAllSelected();
    },
    toggleRowExpansion: function toggleRowExpansion(row, expanded) {
      this.store.toggleRowExpansion(row, expanded);
    },
    clearSelection: function clearSelection() {
      this.store.clearSelection();
    },
    clearFilter: function clearFilter() {
      this.store.clearFilter();
    },
    clearSort: function clearSort() {
      this.store.clearSort();
    },
    handleMouseLeave: function handleMouseLeave() {
      this.store.commit('setHoverRow', null);
      if (this.hoverState) this.hoverState = null;
    },
    updateScrollY: function updateScrollY() {
      this.layout.updateScrollY();
    },
    bindEvents: function bindEvents() {
      var _this = this;

      var _$refs = this.$refs,
          headerWrapper = _$refs.headerWrapper,
          footerWrapper = _$refs.footerWrapper;

      var refs = this.$refs;
      var self = this;
      this.bodyWrapper.addEventListener('scroll', function () {
        if (headerWrapper) headerWrapper.scrollLeft = this.scrollLeft;
        if (footerWrapper) footerWrapper.scrollLeft = this.scrollLeft;
        if (refs.fixedBodyWrapper) refs.fixedBodyWrapper.scrollTop = this.scrollTop;
        if (refs.rightFixedBodyWrapper) refs.rightFixedBodyWrapper.scrollTop = this.scrollTop;
        var maxScrollLeftPosition = this.scrollWidth - this.offsetWidth - 1;
        var scrollLeft = this.scrollLeft;
        if (scrollLeft >= maxScrollLeftPosition) {
          self.scrollPosition = 'right';
        } else if (scrollLeft === 0) {
          self.scrollPosition = 'left';
        } else {
          self.scrollPosition = 'middle';
        }
      });

      var scrollBodyWrapper = function scrollBodyWrapper(event) {
        var deltaX = event.deltaX,
            deltaY = event.deltaY;


        if (Math.abs(deltaX) < Math.abs(deltaY)) return;

        if (deltaX > 0) {
          _this.bodyWrapper.scrollLeft += 10;
        } else if (deltaX < 0) {
          _this.bodyWrapper.scrollLeft -= 10;
        }
      };
      if (headerWrapper) {
        (0, _util.mousewheel)(headerWrapper, (0, _throttle2.default)(16, scrollBodyWrapper));
      }
      if (footerWrapper) {
        (0, _util.mousewheel)(footerWrapper, (0, _throttle2.default)(16, scrollBodyWrapper));
      }

      if (this.fit) {
        this.windowResizeListener = (0, _throttle2.default)(50, function () {
          if (_this.$ready) _this.doLayout();
        });
        (0, _resizeEvent.addResizeListener)(this.$el, this.windowResizeListener);
      }
    },
    doLayout: function doLayout() {
      var _this2 = this;

      this.store.updateColumns();
      this.updateScrollY();
      this.layout.update();
      this.$nextTick(function () {
        if (_this2.height) {
          _this2.layout.setHeight(_this2.height);
        } else if (_this2.maxHeight) {
          _this2.layout.setMaxHeight(_this2.maxHeight);
        } else if (_this2.shouldUpdateHeight) {
          _this2.layout.updateHeight();
        }
      });
    }
  },

  created: function created() {
    var _this3 = this;

    this.tableId = 'el-table_' + tableIdSeed + '_';
    this.debouncedLayout = (0, _debounce2.default)(50, function () {
      return _this3.doLayout();
    });
  },


  computed: {
    tableSize: function tableSize() {
      return this.size || (this.$ELEMENT || {}).size;
    },
    bodyWrapper: function bodyWrapper() {
      return this.$refs.bodyWrapper;
    },
    shouldUpdateHeight: function shouldUpdateHeight() {
      return typeof this.height === 'number' || this.fixedColumns.length > 0 || this.rightFixedColumns.length > 0;
    },
    selection: function selection() {
      return this.store.states.selection;
    },
    columns: function columns() {
      return this.store.states.columns;
    },
    tableData: function tableData() {
      return this.store.states.data;
    },
    fixedColumns: function fixedColumns() {
      return this.store.states.fixedColumns;
    },
    rightFixedColumns: function rightFixedColumns() {
      return this.store.states.rightFixedColumns;
    },
    bodyHeight: function bodyHeight() {
      var style = {};

      if (this.height) {
        style = {
          height: this.layout.bodyHeight ? this.layout.bodyHeight + 'px' : ''
        };
      } else if (this.maxHeight) {
        style = {
          'max-height': (this.showHeader ? this.maxHeight - this.layout.headerHeight - this.layout.footerHeight : this.maxHeight - this.layout.footerHeight) + 'px'
        };
      }

      return style;
    },
    bodyWidth: function bodyWidth() {
      var _layout = this.layout,
          bodyWidth = _layout.bodyWidth,
          scrollY = _layout.scrollY,
          gutterWidth = _layout.gutterWidth;

      return bodyWidth ? bodyWidth - (scrollY ? gutterWidth : 0) + 'px' : '';
    },
    fixedBodyHeight: function fixedBodyHeight() {
      var style = {};

      if (this.height) {
        style = {
          height: this.layout.fixedBodyHeight ? this.layout.fixedBodyHeight + 'px' : ''
        };
      } else if (this.maxHeight) {
        var maxHeight = this.layout.scrollX ? this.maxHeight - this.layout.gutterWidth : this.maxHeight;

        if (this.showHeader) {
          maxHeight -= this.layout.headerHeight;
        }

        maxHeight -= this.layout.footerHeight;

        style = {
          'max-height': maxHeight + 'px'
        };
      }

      return style;
    },
    fixedHeight: function fixedHeight() {
      var style = {};

      if (this.maxHeight) {
        style = {
          bottom: this.layout.scrollX && this.data.length ? this.layout.gutterWidth + 'px' : ''
        };
      } else {
        style = {
          height: this.layout.viewportHeight ? this.layout.viewportHeight + 'px' : ''
        };
      }

      return style;
    }
  },

  watch: {
    height: function height(value) {
      this.layout.setHeight(value);
    },
    maxHeight: function maxHeight(value) {
      this.layout.setMaxHeight(value);
    },
    currentRowKey: function currentRowKey(newVal) {
      this.store.setCurrentRowKey(newVal);
    },


    data: {
      immediate: true,
      handler: function handler(val) {
        var _this4 = this;

        this.store.commit('setData', val);
        if (this.$ready) {
          this.$nextTick(function () {
            _this4.doLayout();
          });
        }
      }
    },

    expandRowKeys: {
      immediate: true,
      handler: function handler(newVal) {
        if (newVal) {
          this.store.setExpandRowKeys(newVal);
        }
      }
    }
  },

  destroyed: function destroyed() {
    if (this.windowResizeListener) (0, _resizeEvent.removeResizeListener)(this.$el, this.windowResizeListener);
  },
  mounted: function mounted() {
    var _this5 = this;

    this.bindEvents();
    this.doLayout();

    // init filters
    this.store.states.columns.forEach(function (column) {
      if (column.filteredValue && column.filteredValue.length) {
        _this5.store.commit('filterChange', {
          column: column,
          values: column.filteredValue,
          silent: true
        });
      }
    });

    this.$ready = true;
  },
  data: function data() {
    var store = new _tableStore2.default(this, {
      rowKey: this.rowKey,
      defaultExpandAll: this.defaultExpandAll
    });
    var layout = new _tableLayout2.default({
      store: store,
      table: this,
      fit: this.fit,
      showHeader: this.showHeader
    });
    return {
      store: store,
      layout: layout,
      isHidden: false,
      renderExpanded: null,
      resizeProxyVisible: false,
      // 是否拥有多级表头
      isGroup: false,
      scrollPosition: 'left'
    };
  }
};

/***/ }),

/***/ 187:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _vue = __webpack_require__(5);

var _vue2 = _interopRequireDefault(_vue);

var _debounce = __webpack_require__(12);

var _debounce2 = _interopRequireDefault(_debounce);

var _merge = __webpack_require__(9);

var _merge2 = _interopRequireDefault(_merge);

var _util = __webpack_require__(37);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var sortData = function sortData(data, states) {
  var sortingColumn = states.sortingColumn;
  if (!sortingColumn || typeof sortingColumn.sortable === 'string') {
    return data;
  }
  return (0, _util.orderBy)(data, states.sortProp, states.sortOrder, sortingColumn.sortMethod, sortingColumn.sortBy);
};

var getKeysMap = function getKeysMap(array, rowKey) {
  var arrayMap = {};
  (array || []).forEach(function (row, index) {
    arrayMap[(0, _util.getRowIdentity)(row, rowKey)] = { row: row, index: index };
  });
  return arrayMap;
};

var toggleRowSelection = function toggleRowSelection(states, row, selected) {
  var changed = false;
  var selection = states.selection;
  var index = selection.indexOf(row);
  if (typeof selected === 'undefined') {
    if (index === -1) {
      selection.push(row);
      changed = true;
    } else {
      selection.splice(index, 1);
      changed = true;
    }
  } else {
    if (selected && index === -1) {
      selection.push(row);
      changed = true;
    } else if (!selected && index > -1) {
      selection.splice(index, 1);
      changed = true;
    }
  }

  return changed;
};

var toggleRowExpansion = function toggleRowExpansion(states, row, expanded) {
  var changed = false;
  var expandRows = states.expandRows;
  if (typeof expanded !== 'undefined') {
    var index = expandRows.indexOf(row);
    if (expanded) {
      if (index === -1) {
        expandRows.push(row);
        changed = true;
      }
    } else {
      if (index !== -1) {
        expandRows.splice(index, 1);
        changed = true;
      }
    }
  } else {
    var _index = expandRows.indexOf(row);
    if (_index === -1) {
      expandRows.push(row);
      changed = true;
    } else {
      expandRows.splice(_index, 1);
      changed = true;
    }
  }

  return changed;
};

var TableStore = function TableStore(table) {
  var initialState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (!table) {
    throw new Error('Table is required.');
  }
  this.table = table;

  this.states = {
    rowKey: null,
    _columns: [],
    originColumns: [],
    columns: [],
    fixedColumns: [],
    rightFixedColumns: [],
    leafColumns: [],
    fixedLeafColumns: [],
    rightFixedLeafColumns: [],
    isComplex: false,
    _data: null,
    filteredData: null,
    data: null,
    sortingColumn: null,
    sortProp: null,
    sortOrder: null,
    isAllSelected: false,
    selection: [],
    reserveSelection: false,
    selectable: null,
    currentRow: null,
    hoverRow: null,
    filters: {},
    expandRows: [],
    defaultExpandAll: false
  };

  for (var prop in initialState) {
    if (initialState.hasOwnProperty(prop) && this.states.hasOwnProperty(prop)) {
      this.states[prop] = initialState[prop];
    }
  }
};

TableStore.prototype.mutations = {
  setData: function setData(states, data) {
    var _this = this;

    var dataInstanceChanged = states._data !== data;
    states._data = data;

    Object.keys(states.filters).forEach(function (columnId) {
      var values = states.filters[columnId];
      if (!values || values.length === 0) return;
      var column = (0, _util.getColumnById)(_this.states, columnId);
      if (column && column.filterMethod) {
        data = data.filter(function (row) {
          return values.some(function (value) {
            return column.filterMethod.call(null, value, row);
          });
        });
      }
    });

    states.filteredData = data;
    states.data = sortData(data || [], states);

    // states.data.forEach((item) => {
    //   if (!item.$extra) {
    //     Object.defineProperty(item, '$extra', {
    //       value: {},
    //       enumerable: false
    //     });
    //   }
    // });

    this.updateCurrentRow();

    if (!states.reserveSelection) {
      if (dataInstanceChanged) {
        this.clearSelection();
      } else {
        this.cleanSelection();
      }
      this.updateAllSelected();
    } else {
      (function () {
        var rowKey = states.rowKey;
        if (rowKey) {
          (function () {
            var selection = states.selection;
            var selectedMap = getKeysMap(selection, rowKey);

            states.data.forEach(function (row) {
              var rowId = (0, _util.getRowIdentity)(row, rowKey);
              var rowInfo = selectedMap[rowId];
              if (rowInfo) {
                selection[rowInfo.index] = row;
              }
            });

            _this.updateAllSelected();
          })();
        } else {
          console.warn('WARN: rowKey is required when reserve-selection is enabled.');
        }
      })();
    }

    var defaultExpandAll = states.defaultExpandAll;
    if (defaultExpandAll) {
      this.states.expandRows = (states.data || []).slice(0);
    }

    _vue2.default.nextTick(function () {
      return _this.table.updateScrollY();
    });
  },
  changeSortCondition: function changeSortCondition(states, options) {
    var _this2 = this;

    states.data = sortData(states.filteredData || states._data || [], states);

    if (!options || !options.silent) {
      this.table.$emit('sort-change', {
        column: this.states.sortingColumn,
        prop: this.states.sortProp,
        order: this.states.sortOrder
      });
    }

    _vue2.default.nextTick(function () {
      return _this2.table.updateScrollY();
    });
  },
  filterChange: function filterChange(states, options) {
    var _this3 = this;

    var column = options.column,
        values = options.values,
        silent = options.silent;

    if (values && !Array.isArray(values)) {
      values = [values];
    }

    var prop = column.property;
    var filters = {};

    if (prop) {
      states.filters[column.id] = values;
      filters[column.columnKey || column.id] = values;
    }

    var data = states._data;

    Object.keys(states.filters).forEach(function (columnId) {
      var values = states.filters[columnId];
      if (!values || values.length === 0) return;
      var column = (0, _util.getColumnById)(_this3.states, columnId);
      if (column && column.filterMethod) {
        data = data.filter(function (row) {
          return values.some(function (value) {
            return column.filterMethod.call(null, value, row);
          });
        });
      }
    });

    states.filteredData = data;
    states.data = sortData(data, states);

    if (!silent) {
      this.table.$emit('filter-change', filters);
    }

    _vue2.default.nextTick(function () {
      return _this3.table.updateScrollY();
    });
  },
  insertColumn: function insertColumn(states, column, index, parent) {
    var array = states._columns;
    if (parent) {
      array = parent.children;
      if (!array) array = parent.children = [];
    }

    if (typeof index !== 'undefined') {
      array.splice(index, 0, column);
    } else {
      array.push(column);
    }

    if (column.type === 'selection') {
      states.selectable = column.selectable;
      states.reserveSelection = column.reserveSelection;
    }

    this.updateColumns(); // hack for dynamics insert column
    this.scheduleLayout();
  },
  removeColumn: function removeColumn(states, column) {
    var _columns = states._columns;
    if (_columns) {
      _columns.splice(_columns.indexOf(column), 1);
    }

    this.updateColumns(); // hack for dynamics remove column
    this.scheduleLayout();
  },
  setHoverRow: function setHoverRow(states, row) {
    states.hoverRow = row;
  },
  setCurrentRow: function setCurrentRow(states, row) {
    var oldCurrentRow = states.currentRow;
    states.currentRow = row;

    if (oldCurrentRow !== row) {
      this.table.$emit('current-change', row, oldCurrentRow);
    }
  },
  rowSelectedChanged: function rowSelectedChanged(states, row) {
    var changed = toggleRowSelection(states, row);
    var selection = states.selection;

    if (changed) {
      var table = this.table;
      table.$emit('selection-change', selection);
      table.$emit('select', selection, row);
    }

    this.updateAllSelected();
  },


  toggleAllSelection: (0, _debounce2.default)(10, function (states) {
    var data = states.data || [];
    var value = !states.isAllSelected;
    var selection = this.states.selection;
    var selectionChanged = false;

    data.forEach(function (item, index) {
      if (states.selectable) {
        if (states.selectable.call(null, item, index) && toggleRowSelection(states, item, value)) {
          selectionChanged = true;
        }
      } else {
        if (toggleRowSelection(states, item, value)) {
          selectionChanged = true;
        }
      }
    });

    var table = this.table;
    if (selectionChanged) {
      table.$emit('selection-change', selection);
    }
    table.$emit('select-all', selection);
    states.isAllSelected = value;
  })
};

var doFlattenColumns = function doFlattenColumns(columns) {
  var result = [];
  columns.forEach(function (column) {
    if (column.children) {
      result.push.apply(result, doFlattenColumns(column.children));
    } else {
      result.push(column);
    }
  });
  return result;
};

TableStore.prototype.updateColumns = function () {
  var states = this.states;
  var _columns = states._columns || [];
  states.fixedColumns = _columns.filter(function (column) {
    return column.fixed === true || column.fixed === 'left';
  });
  states.rightFixedColumns = _columns.filter(function (column) {
    return column.fixed === 'right';
  });

  if (states.fixedColumns.length > 0 && _columns[0] && _columns[0].type === 'selection' && !_columns[0].fixed) {
    _columns[0].fixed = true;
    states.fixedColumns.unshift(_columns[0]);
  }

  var notFixedColumns = _columns.filter(function (column) {
    return !column.fixed;
  });
  states.originColumns = [].concat(states.fixedColumns).concat(notFixedColumns).concat(states.rightFixedColumns);

  var leafColumns = doFlattenColumns(notFixedColumns);
  var fixedLeafColumns = doFlattenColumns(states.fixedColumns);
  var rightFixedLeafColumns = doFlattenColumns(states.rightFixedColumns);

  states.leafColumnsLength = leafColumns.length;
  states.fixedLeafColumnsLength = fixedLeafColumns.length;
  states.rightFixedLeafColumnsLength = rightFixedLeafColumns.length;

  states.columns = [].concat(fixedLeafColumns).concat(leafColumns).concat(rightFixedLeafColumns);
  states.isComplex = states.fixedColumns.length > 0 || states.rightFixedColumns.length > 0;
};

TableStore.prototype.isSelected = function (row) {
  return (this.states.selection || []).indexOf(row) > -1;
};

TableStore.prototype.clearSelection = function () {
  var states = this.states;
  states.isAllSelected = false;
  var oldSelection = states.selection;
  states.selection = [];
  if (oldSelection.length > 0) {
    this.table.$emit('selection-change', states.selection);
  }
};

TableStore.prototype.setExpandRowKeys = function (rowKeys) {
  var expandRows = [];
  var data = this.states.data;
  var rowKey = this.states.rowKey;
  if (!rowKey) throw new Error('[Table] prop row-key should not be empty.');
  var keysMap = getKeysMap(data, rowKey);
  rowKeys.forEach(function (key) {
    var info = keysMap[key];
    if (info) {
      expandRows.push(info.row);
    }
  });

  this.states.expandRows = expandRows;
};

TableStore.prototype.toggleRowSelection = function (row, selected) {
  var changed = toggleRowSelection(this.states, row, selected);
  if (changed) {
    this.table.$emit('selection-change', this.states.selection);
  }
};

TableStore.prototype.toggleRowExpansion = function (row, expanded) {
  var changed = toggleRowExpansion(this.states, row, expanded);
  if (changed) {
    this.table.$emit('expand-change', row, this.states.expandRows);
  }
};

TableStore.prototype.cleanSelection = function () {
  var selection = this.states.selection || [];
  var data = this.states.data;
  var rowKey = this.states.rowKey;
  var deleted = void 0;
  if (rowKey) {
    deleted = [];
    var selectedMap = getKeysMap(selection, rowKey);
    var dataMap = getKeysMap(data, rowKey);
    for (var key in selectedMap) {
      if (selectedMap.hasOwnProperty(key) && !dataMap[key]) {
        deleted.push(selectedMap[key].row);
      }
    }
  } else {
    deleted = selection.filter(function (item) {
      return data.indexOf(item) === -1;
    });
  }

  deleted.forEach(function (deletedItem) {
    selection.splice(selection.indexOf(deletedItem), 1);
  });

  if (deleted.length) {
    this.table.$emit('selection-change', selection);
  }
};

TableStore.prototype.clearFilter = function () {
  var states = this.states;
  var _table$$refs = this.table.$refs,
      tableHeader = _table$$refs.tableHeader,
      fixedTableHeader = _table$$refs.fixedTableHeader,
      rightFixedTableHeader = _table$$refs.rightFixedTableHeader;

  var panels = {};

  if (tableHeader) panels = (0, _merge2.default)(panels, tableHeader.filterPanels);
  if (fixedTableHeader) panels = (0, _merge2.default)(panels, fixedTableHeader.filterPanels);
  if (rightFixedTableHeader) panels = (0, _merge2.default)(panels, rightFixedTableHeader.filterPanels);

  var keys = Object.keys(panels);
  if (!keys.length) return;

  keys.forEach(function (key) {
    panels[key].filteredValue = [];
  });

  states.filters = {};

  this.commit('filterChange', {
    column: {},
    values: [],
    silent: true
  });
};

TableStore.prototype.clearSort = function () {
  var states = this.states;
  if (!states.sortingColumn) return;
  states.sortingColumn.order = null;
  states.sortProp = null;
  states.sortOrder = null;

  this.commit('changeSortCondition', {
    silent: true
  });
};

TableStore.prototype.updateAllSelected = function () {
  var states = this.states;
  var selection = states.selection,
      rowKey = states.rowKey,
      selectable = states.selectable,
      data = states.data;

  if (!data || data.length === 0) {
    states.isAllSelected = false;
    return;
  }

  var selectedMap = void 0;
  if (rowKey) {
    selectedMap = getKeysMap(states.selection, rowKey);
  }

  var isSelected = function isSelected(row) {
    if (selectedMap) {
      return !!selectedMap[(0, _util.getRowIdentity)(row, rowKey)];
    } else {
      return selection.indexOf(row) !== -1;
    }
  };

  var isAllSelected = true;
  var selectedCount = 0;
  for (var i = 0, j = data.length; i < j; i++) {
    var item = data[i];
    if (selectable) {
      var isRowSelectable = selectable.call(null, item, i);
      if (isRowSelectable) {
        if (!isSelected(item)) {
          isAllSelected = false;
          break;
        } else {
          selectedCount++;
        }
      }
    } else {
      if (!isSelected(item)) {
        isAllSelected = false;
        break;
      } else {
        selectedCount++;
      }
    }
  }

  if (selectedCount === 0) isAllSelected = false;

  states.isAllSelected = isAllSelected;
};

TableStore.prototype.scheduleLayout = function () {
  this.table.debouncedLayout();
};

TableStore.prototype.setCurrentRowKey = function (key) {
  var states = this.states;
  var rowKey = states.rowKey;
  if (!rowKey) throw new Error('[Table] row-key should not be empty.');
  var data = states.data || [];
  var keysMap = getKeysMap(data, rowKey);
  var info = keysMap[key];
  if (info) {
    states.currentRow = info.row;
  }
};

TableStore.prototype.updateCurrentRow = function () {
  var states = this.states;
  var table = this.table;
  var data = states.data || [];
  var oldCurrentRow = states.currentRow;

  if (data.indexOf(oldCurrentRow) === -1) {
    states.currentRow = null;

    if (states.currentRow !== oldCurrentRow) {
      table.$emit('current-change', null, oldCurrentRow);
    }
  }
};

TableStore.prototype.commit = function (name) {
  var mutations = this.mutations;
  if (mutations[name]) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    mutations[name].apply(this, [this.states].concat(args));
  } else {
    throw new Error('Action not found: ' + name);
  }
};

exports.default = TableStore;

/***/ }),

/***/ 188:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _scrollbarWidth = __webpack_require__(38);

var _scrollbarWidth2 = _interopRequireDefault(_scrollbarWidth);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TableLayout = function () {
  function TableLayout(options) {
    _classCallCheck(this, TableLayout);

    this.table = null;
    this.store = null;
    this.columns = null;
    this.fit = true;
    this.showHeader = true;

    this.height = null;
    this.scrollX = false;
    this.scrollY = false;
    this.bodyWidth = null;
    this.fixedWidth = null;
    this.rightFixedWidth = null;
    this.tableHeight = null;
    this.headerHeight = 44; // Table Header Height
    this.appendHeight = 0; // Append Slot Height
    this.footerHeight = 44; // Table Footer Height
    this.viewportHeight = null; // Table Height - Scroll Bar Height
    this.bodyHeight = null; // Table Height - Table Header Height
    this.fixedBodyHeight = null; // Table Height - Table Header Height - Scroll Bar Height
    this.gutterWidth = (0, _scrollbarWidth2.default)();

    for (var name in options) {
      if (options.hasOwnProperty(name)) {
        this[name] = options[name];
      }
    }

    if (!this.table) {
      throw new Error('table is required for Table Layout');
    }
    if (!this.store) {
      throw new Error('store is required for Table Layout');
    }
  }

  TableLayout.prototype.updateScrollY = function updateScrollY() {
    var height = this.height;
    if (typeof height !== 'string' && typeof height !== 'number') return;
    var bodyWrapper = this.table.bodyWrapper;
    if (this.table.$el && bodyWrapper) {
      var body = bodyWrapper.querySelector('.el-table__body');
      this.scrollY = body.offsetHeight > bodyWrapper.offsetHeight;
    }
  };

  TableLayout.prototype.setHeight = function setHeight(value) {
    var prop = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'height';

    var el = this.table.$el;
    if (typeof value === 'string' && /^\d+$/.test(value)) {
      value = Number(value);
    }

    this.height = value;

    if (!el) return;
    if (typeof value === 'number') {
      el.style[prop] = value + 'px';

      this.updateHeight();
    } else if (typeof value === 'string') {
      if (value === '') {
        el.style[prop] = '';
      }
      this.updateHeight();
    }
  };

  TableLayout.prototype.setMaxHeight = function setMaxHeight(value) {
    return this.setHeight(value, 'max-height');
  };

  TableLayout.prototype.updateHeight = function updateHeight() {
    var height = this.tableHeight = this.table.$el.clientHeight;
    var noData = !this.table.data || this.table.data.length === 0;
    var _table$$refs = this.table.$refs,
        headerWrapper = _table$$refs.headerWrapper,
        appendWrapper = _table$$refs.appendWrapper,
        footerWrapper = _table$$refs.footerWrapper;

    var footerHeight = this.footerHeight = footerWrapper ? footerWrapper.offsetHeight : 0;
    this.appendHeight = appendWrapper ? appendWrapper.offsetHeight : 0;
    if (this.showHeader && !headerWrapper) return;
    if (!this.showHeader) {
      this.headerHeight = 0;
      if (this.height !== null && (!isNaN(this.height) || typeof this.height === 'string')) {
        this.bodyHeight = height - footerHeight + (footerWrapper ? 1 : 0);
      }
      this.fixedBodyHeight = this.scrollX ? height - this.gutterWidth : height;
    } else {
      var headerHeight = this.headerHeight = headerWrapper.offsetHeight;
      var bodyHeight = height - headerHeight - footerHeight + (footerWrapper ? 1 : 0);
      if (this.height !== null && (!isNaN(this.height) || typeof this.height === 'string')) {
        this.bodyHeight = bodyHeight;
      }
      this.fixedBodyHeight = this.scrollX ? bodyHeight - this.gutterWidth : bodyHeight;
    }
    this.viewportHeight = this.scrollX ? height - (noData ? 0 : this.gutterWidth) : height;
  };

  TableLayout.prototype.update = function update() {
    var fit = this.fit;
    var columns = this.table.columns;
    var bodyWidth = this.table.$el.clientWidth;
    var bodyMinWidth = 0;

    var flattenColumns = [];
    columns.forEach(function (column) {
      if (column.isColumnGroup) {
        flattenColumns.push.apply(flattenColumns, column.columns);
      } else {
        flattenColumns.push(column);
      }
    });

    var flexColumns = flattenColumns.filter(function (column) {
      return typeof column.width !== 'number';
    });

    if (flexColumns.length > 0 && fit) {
      flattenColumns.forEach(function (column) {
        bodyMinWidth += column.width || column.minWidth || 80;
      });

      var scrollYWidth = this.scrollY ? this.gutterWidth : 0;

      if (bodyMinWidth <= bodyWidth - scrollYWidth) {
        // DON'T HAVE SCROLL BAR
        this.scrollX = false;

        var totalFlexWidth = bodyWidth - scrollYWidth - bodyMinWidth;

        if (flexColumns.length === 1) {
          flexColumns[0].realWidth = (flexColumns[0].minWidth || 80) + totalFlexWidth;
        } else {
          (function () {
            var allColumnsWidth = flexColumns.reduce(function (prev, column) {
              return prev + (column.minWidth || 80);
            }, 0);
            var flexWidthPerPixel = totalFlexWidth / allColumnsWidth;
            var noneFirstWidth = 0;

            flexColumns.forEach(function (column, index) {
              if (index === 0) return;
              var flexWidth = Math.floor((column.minWidth || 80) * flexWidthPerPixel);
              noneFirstWidth += flexWidth;
              column.realWidth = (column.minWidth || 80) + flexWidth;
            });

            flexColumns[0].realWidth = (flexColumns[0].minWidth || 80) + totalFlexWidth - noneFirstWidth;
          })();
        }
      } else {
        // HAVE HORIZONTAL SCROLL BAR
        this.scrollX = true;
        flexColumns.forEach(function (column) {
          column.realWidth = column.minWidth;
        });
      }

      this.bodyWidth = Math.max(bodyMinWidth, bodyWidth);
    } else {
      flattenColumns.forEach(function (column) {
        if (!column.width && !column.minWidth) {
          column.realWidth = 80;
        } else {
          column.realWidth = column.width || column.minWidth;
        }

        bodyMinWidth += column.realWidth;
      });
      this.scrollX = bodyMinWidth > bodyWidth;

      this.bodyWidth = bodyMinWidth;
    }

    var fixedColumns = this.store.states.fixedColumns;

    if (fixedColumns.length > 0) {
      var fixedWidth = 0;
      fixedColumns.forEach(function (column) {
        fixedWidth += column.realWidth;
      });

      this.fixedWidth = fixedWidth;
    }

    var rightFixedColumns = this.store.states.rightFixedColumns;
    if (rightFixedColumns.length > 0) {
      var rightFixedWidth = 0;
      rightFixedColumns.forEach(function (column) {
        rightFixedWidth += column.realWidth;
      });

      this.rightFixedWidth = rightFixedWidth;
    }
  };

  return TableLayout;
}();

exports.default = TableLayout;

/***/ }),

/***/ 189:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _util = __webpack_require__(37);

var _dom = __webpack_require__(2);

var _checkbox = __webpack_require__(16);

var _checkbox2 = _interopRequireDefault(_checkbox);

var _tooltip = __webpack_require__(22);

var _tooltip2 = _interopRequireDefault(_tooltip);

var _debounce = __webpack_require__(12);

var _debounce2 = _interopRequireDefault(_debounce);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    ElCheckbox: _checkbox2.default,
    ElTooltip: _tooltip2.default
  },

  props: {
    store: {
      required: true
    },
    stripe: Boolean,
    context: {},
    layout: {
      required: true
    },
    rowClassName: [String, Function],
    rowStyle: [Object, Function],
    fixed: String,
    highlight: Boolean
  },

  render: function render(h) {
    var _this = this;

    var columnsHidden = this.columns.map(function (column, index) {
      return _this.isColumnHidden(index);
    });
    return h(
      'table',
      {
        'class': 'el-table__body',
        attrs: { cellspacing: '0',
          cellpadding: '0',
          border: '0' }
      },
      [h(
        'colgroup',
        null,
        [this._l(this.columns, function (column) {
          return h(
            'col',
            {
              attrs: {
                name: column.id,
                width: column.realWidth || column.width
              }
            },
            []
          );
        })]
      ), h(
        'tbody',
        null,
        [this._l(this.data, function (row, $index) {
          return [h(
            'tr',
            {
              style: _this.rowStyle ? _this.getRowStyle(row, $index) : null,
              key: _this.table.rowKey ? _this.getKeyOfRow(row, $index) : $index,
              on: {
                'dblclick': function dblclick($event) {
                  return _this.handleDoubleClick($event, row);
                },
                'click': function click($event) {
                  return _this.handleClick($event, row);
                },
                'contextmenu': function contextmenu($event) {
                  return _this.handleContextMenu($event, row);
                },
                'mouseenter': function mouseenter(_) {
                  return _this.handleMouseEnter($index);
                },
                'mouseleave': function mouseleave(_) {
                  return _this.handleMouseLeave();
                }
              },

              'class': [_this.getRowClass(row, $index)] },
            [_this._l(_this.columns, function (column, cellIndex) {
              var _getSpan = _this.getSpan(row, column, $index, cellIndex),
                  rowspan = _getSpan.rowspan,
                  colspan = _getSpan.colspan;

              if (!rowspan || !colspan) {
                return '';
              } else {
                if (rowspan === 1 && colspan === 1) {
                  return h(
                    'td',
                    {
                      style: _this.getCellStyle($index, cellIndex, row, column),
                      'class': _this.getCellClass($index, cellIndex, row, column),
                      on: {
                        'mouseenter': function mouseenter($event) {
                          return _this.handleCellMouseEnter($event, row);
                        },
                        'mouseleave': _this.handleCellMouseLeave
                      }
                    },
                    [column.renderCell.call(_this._renderProxy, h, {
                      row: row,
                      column: column,
                      $index: $index,
                      store: _this.store,
                      _self: _this.context || _this.table.$vnode.context
                    }, columnsHidden[cellIndex])]
                  );
                } else {
                  return h(
                    'td',
                    {
                      style: _this.getCellStyle($index, cellIndex, row, column),
                      'class': _this.getCellClass($index, cellIndex, row, column),
                      attrs: { rowspan: rowspan,
                        colspan: colspan
                      },
                      on: {
                        'mouseenter': function mouseenter($event) {
                          return _this.handleCellMouseEnter($event, row);
                        },
                        'mouseleave': _this.handleCellMouseLeave
                      }
                    },
                    [column.renderCell.call(_this._renderProxy, h, {
                      row: row,
                      column: column,
                      $index: $index,
                      store: _this.store,
                      _self: _this.context || _this.table.$vnode.context
                    }, columnsHidden[cellIndex])]
                  );
                }
              }
            }), !_this.fixed && _this.layout.scrollY && _this.layout.gutterWidth ? h(
              'td',
              { 'class': 'gutter' },
              []
            ) : '']
          ), _this.store.states.expandRows.indexOf(row) > -1 ? h(
            'tr',
            null,
            [h(
              'td',
              {
                attrs: { colspan: _this.columns.length },
                'class': 'el-table__expanded-cell' },
              [_this.table.renderExpanded ? _this.table.renderExpanded(h, { row: row, $index: $index, store: _this.store }) : '']
            )]
          ) : ''];
        }).concat(h(
          'el-tooltip',
          {
            attrs: { effect: this.table.tooltipEffect, placement: 'top', content: this.tooltipContent },
            ref: 'tooltip' },
          []
        ))]
      )]
    );
  },


  watch: {
    'store.states.hoverRow': function storeStatesHoverRow(newVal, oldVal) {
      if (!this.store.states.isComplex) return;
      var el = this.$el;
      if (!el) return;
      var tr = el.querySelector('tbody').children;
      var rows = [].filter.call(tr, function (row) {
        return (0, _dom.hasClass)(row, 'el-table__row');
      });
      var oldRow = rows[oldVal];
      var newRow = rows[newVal];
      if (oldRow) {
        (0, _dom.removeClass)(oldRow, 'hover-row');
      }
      if (newRow) {
        (0, _dom.addClass)(newRow, 'hover-row');
      }
    },
    'store.states.currentRow': function storeStatesCurrentRow(newVal, oldVal) {
      if (!this.highlight) return;
      var el = this.$el;
      if (!el) return;
      var data = this.store.states.data;
      var tr = el.querySelector('tbody').children;
      var rows = [].filter.call(tr, function (row) {
        return (0, _dom.hasClass)(row, 'el-table__row');
      });
      var oldRow = rows[data.indexOf(oldVal)];
      var newRow = rows[data.indexOf(newVal)];
      if (oldRow) {
        (0, _dom.removeClass)(oldRow, 'current-row');
      } else if (rows) {
        [].forEach.call(rows, function (row) {
          return (0, _dom.removeClass)(row, 'current-row');
        });
      }
      if (newRow) {
        (0, _dom.addClass)(newRow, 'current-row');
      }
    }
  },

  computed: {
    table: function table() {
      return this.$parent;
    },
    data: function data() {
      return this.store.states.data;
    },
    columnsCount: function columnsCount() {
      return this.store.states.columns.length;
    },
    leftFixedLeafCount: function leftFixedLeafCount() {
      return this.store.states.fixedLeafColumnsLength;
    },
    rightFixedLeafCount: function rightFixedLeafCount() {
      return this.store.states.rightFixedLeafColumnsLength;
    },
    leftFixedCount: function leftFixedCount() {
      return this.store.states.fixedColumns.length;
    },
    rightFixedCount: function rightFixedCount() {
      return this.store.states.rightFixedColumns.length;
    },
    columns: function columns() {
      return this.store.states.columns;
    }
  },

  data: function data() {
    return {
      tooltipContent: ''
    };
  },
  created: function created() {
    this.activateTooltip = (0, _debounce2.default)(50, function (tooltip) {
      return tooltip.handleShowPopper();
    });
  },


  methods: {
    getKeyOfRow: function getKeyOfRow(row, index) {
      var rowKey = this.table.rowKey;
      if (rowKey) {
        return (0, _util.getRowIdentity)(row, rowKey);
      }
      return index;
    },
    isColumnHidden: function isColumnHidden(index) {
      if (this.fixed === true || this.fixed === 'left') {
        return index >= this.leftFixedLeafCount;
      } else if (this.fixed === 'right') {
        return index < this.columnsCount - this.rightFixedLeafCount;
      } else {
        return index < this.leftFixedLeafCount || index >= this.columnsCount - this.rightFixedLeafCount;
      }
    },
    getSpan: function getSpan(row, column, rowIndex, columnIndex) {
      var rowspan = 1;
      var colspan = 1;

      var fn = this.table.spanMethod;
      if (typeof fn === 'function') {
        var result = fn({
          row: row,
          column: column,
          rowIndex: rowIndex,
          columnIndex: columnIndex
        });

        if (Array.isArray(result)) {
          rowspan = result[0];
          colspan = result[1];
        } else if ((typeof result === 'undefined' ? 'undefined' : _typeof(result)) === 'object') {
          rowspan = result.rowspan;
          colspan = result.colspan;
        }
      }

      return {
        rowspan: rowspan,
        colspan: colspan
      };
    },
    getRowStyle: function getRowStyle(row, rowIndex) {
      var rowStyle = this.table.rowStyle;
      if (typeof rowStyle === 'function') {
        return rowStyle.call(null, {
          row: row,
          rowIndex: rowIndex
        });
      }
      return rowStyle;
    },
    getRowClass: function getRowClass(row, rowIndex) {
      var classes = ['el-table__row'];

      if (this.stripe && rowIndex % 2 === 1) {
        classes.push('el-table__row--striped');
      }
      var rowClassName = this.table.rowClassName;
      if (typeof rowClassName === 'string') {
        classes.push(rowClassName);
      } else if (typeof rowClassName === 'function') {
        classes.push(rowClassName.call(null, {
          row: row,
          rowIndex: rowIndex
        }));
      }

      if (this.store.states.expandRows.indexOf(row) > -1) {
        classes.push('expanded');
      }

      return classes.join(' ');
    },
    getCellStyle: function getCellStyle(rowIndex, columnIndex, row, column) {
      var cellStyle = this.table.cellStyle;
      if (typeof cellStyle === 'function') {
        return cellStyle.call(null, {
          rowIndex: rowIndex,
          columnIndex: columnIndex,
          row: row,
          column: column
        });
      }
      return cellStyle;
    },
    getCellClass: function getCellClass(rowIndex, columnIndex, row, column) {
      var classes = [column.id, column.align, column.className];

      if (this.isColumnHidden(columnIndex)) {
        classes.push('is-hidden');
      }

      var cellClassName = this.table.cellClassName;
      if (typeof cellClassName === 'string') {
        classes.push(cellClassName);
      } else if (typeof cellClassName === 'function') {
        classes.push(cellClassName.call(null, {
          rowIndex: rowIndex,
          columnIndex: columnIndex,
          row: row,
          column: column
        }));
      }

      return classes.join(' ');
    },
    handleCellMouseEnter: function handleCellMouseEnter(event, row) {
      var table = this.table;
      var cell = (0, _util.getCell)(event);

      if (cell) {
        var column = (0, _util.getColumnByCell)(table, cell);
        var hoverState = table.hoverState = { cell: cell, column: column, row: row };
        table.$emit('cell-mouse-enter', hoverState.row, hoverState.column, hoverState.cell, event);
      }

      // 判断是否text-overflow, 如果是就显示tooltip
      var cellChild = event.target.querySelector('.cell');

      if ((0, _dom.hasClass)(cellChild, 'el-tooltip') && cellChild.scrollWidth > cellChild.offsetWidth && this.$refs.tooltip) {
        var tooltip = this.$refs.tooltip;

        this.tooltipContent = cell.textContent || cell.innerText;
        tooltip.referenceElm = cell;
        tooltip.$refs.popper && (tooltip.$refs.popper.style.display = 'none');
        tooltip.doDestroy();
        tooltip.setExpectedState(true);
        this.activateTooltip(tooltip);
      }
    },
    handleCellMouseLeave: function handleCellMouseLeave(event) {
      var tooltip = this.$refs.tooltip;
      if (tooltip) {
        tooltip.setExpectedState(false);
        tooltip.handleClosePopper();
      }
      var cell = (0, _util.getCell)(event);
      if (!cell) return;

      var oldHoverState = this.table.hoverState;
      this.table.$emit('cell-mouse-leave', oldHoverState.row, oldHoverState.column, oldHoverState.cell, event);
    },
    handleMouseEnter: function handleMouseEnter(index) {
      this.store.commit('setHoverRow', index);
    },
    handleMouseLeave: function handleMouseLeave() {
      this.store.commit('setHoverRow', null);
    },
    handleContextMenu: function handleContextMenu(event, row) {
      this.handleEvent(event, row, 'contextmenu');
    },
    handleDoubleClick: function handleDoubleClick(event, row) {
      this.handleEvent(event, row, 'dblclick');
    },
    handleClick: function handleClick(event, row) {
      this.store.commit('setCurrentRow', row);
      this.handleEvent(event, row, 'click');
    },
    handleEvent: function handleEvent(event, row, name) {
      var table = this.table;
      var cell = (0, _util.getCell)(event);
      var column = void 0;
      if (cell) {
        column = (0, _util.getColumnByCell)(table, cell);
        if (column) {
          table.$emit('cell-' + name, row, column, cell, event);
        }
      }
      table.$emit('row-' + name, row, event, column);
    },
    handleExpandClick: function handleExpandClick(row) {
      this.store.toggleRowExpansion(row);
    }
  }
};

/***/ }),

/***/ 19:
/***/ (function(module, exports) {

module.exports = __webpack_require__(72);

/***/ }),

/***/ 190:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _dom = __webpack_require__(2);

var _checkbox = __webpack_require__(16);

var _checkbox2 = _interopRequireDefault(_checkbox);

var _tag = __webpack_require__(24);

var _tag2 = _interopRequireDefault(_tag);

var _vue = __webpack_require__(5);

var _vue2 = _interopRequireDefault(_vue);

var _filterPanel = __webpack_require__(191);

var _filterPanel2 = _interopRequireDefault(_filterPanel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getAllColumns = function getAllColumns(columns) {
  var result = [];
  columns.forEach(function (column) {
    if (column.children) {
      result.push(column);
      result.push.apply(result, getAllColumns(column.children));
    } else {
      result.push(column);
    }
  });
  return result;
};

var convertToRows = function convertToRows(originColumns) {
  var maxLevel = 1;
  var traverse = function traverse(column, parent) {
    if (parent) {
      column.level = parent.level + 1;
      if (maxLevel < column.level) {
        maxLevel = column.level;
      }
    }
    if (column.children) {
      var colSpan = 0;
      column.children.forEach(function (subColumn) {
        traverse(subColumn, column);
        colSpan += subColumn.colSpan;
      });
      column.colSpan = colSpan;
    } else {
      column.colSpan = 1;
    }
  };

  originColumns.forEach(function (column) {
    column.level = 1;
    traverse(column);
  });

  var rows = [];
  for (var i = 0; i < maxLevel; i++) {
    rows.push([]);
  }

  var allColumns = getAllColumns(originColumns);

  allColumns.forEach(function (column) {
    if (!column.children) {
      column.rowSpan = maxLevel - column.level + 1;
    } else {
      column.rowSpan = 1;
    }
    rows[column.level - 1].push(column);
  });

  return rows;
};

exports.default = {
  name: 'ElTableHeader',

  render: function render(h) {
    var _this = this;

    var originColumns = this.store.states.originColumns;
    var columnRows = convertToRows(originColumns, this.columns);
    // 是否拥有多级表头
    var isGroup = columnRows.length > 1;
    if (isGroup) this.$parent.isGroup = true;

    return h(
      'table',
      {
        'class': 'el-table__header',
        attrs: { cellspacing: '0',
          cellpadding: '0',
          border: '0' }
      },
      [h(
        'colgroup',
        null,
        [this._l(this.columns, function (column) {
          return h(
            'col',
            {
              attrs: {
                name: column.id,
                width: column.realWidth || column.width
              }
            },
            []
          );
        }), !this.fixed && this.layout.gutterWidth ? h(
          'col',
          {
            attrs: { name: 'gutter', width: this.layout.scrollY ? this.layout.gutterWidth : '' }
          },
          []
        ) : '']
      ), h(
        'thead',
        { 'class': [{ 'is-group': isGroup, 'has-gutter': this.hasGutter }] },
        [this._l(columnRows, function (columns, rowIndex) {
          return h(
            'tr',
            {
              style: _this.getHeaderRowStyle(rowIndex),
              'class': _this.getHeaderRowClass(rowIndex)
            },
            [_this._l(columns, function (column, cellIndex) {
              return h(
                'th',
                {
                  attrs: {
                    colspan: column.colSpan,
                    rowspan: column.rowSpan
                  },
                  on: {
                    'mousemove': function mousemove($event) {
                      return _this.handleMouseMove($event, column);
                    },
                    'mouseout': _this.handleMouseOut,
                    'mousedown': function mousedown($event) {
                      return _this.handleMouseDown($event, column);
                    },
                    'click': function click($event) {
                      return _this.handleHeaderClick($event, column);
                    }
                  },

                  style: _this.getHeaderCellStyle(rowIndex, cellIndex, columns, column),
                  'class': _this.getHeaderCellClass(rowIndex, cellIndex, columns, column) },
                [h(
                  'div',
                  { 'class': ['cell', column.filteredValue && column.filteredValue.length > 0 ? 'highlight' : '', column.labelClassName] },
                  [column.renderHeader ? column.renderHeader.call(_this._renderProxy, h, { column: column, $index: cellIndex, store: _this.store, _self: _this.$parent.$vnode.context }) : column.label, column.sortable ? h(
                    'span',
                    { 'class': 'caret-wrapper', on: {
                        'click': function click($event) {
                          return _this.handleSortClick($event, column);
                        }
                      }
                    },
                    [h(
                      'i',
                      { 'class': 'sort-caret ascending', on: {
                          'click': function click($event) {
                            return _this.handleSortClick($event, column, 'ascending');
                          }
                        }
                      },
                      []
                    ), h(
                      'i',
                      { 'class': 'sort-caret descending', on: {
                          'click': function click($event) {
                            return _this.handleSortClick($event, column, 'descending');
                          }
                        }
                      },
                      []
                    )]
                  ) : '', column.filterable ? h(
                    'span',
                    { 'class': 'el-table__column-filter-trigger', on: {
                        'click': function click($event) {
                          return _this.handleFilterClick($event, column);
                        }
                      }
                    },
                    [h(
                      'i',
                      { 'class': ['el-icon-arrow-down', column.filterOpened ? 'el-icon-arrow-up' : ''] },
                      []
                    )]
                  ) : '']
                )]
              );
            }), _this.hasGutter ? h(
              'th',
              { 'class': 'gutter', style: { width: _this.layout.scrollY ? _this.layout.gutterWidth + 'px' : '0' } },
              []
            ) : '']
          );
        })]
      )]
    );
  },


  props: {
    fixed: String,
    store: {
      required: true
    },
    layout: {
      required: true
    },
    border: Boolean,
    defaultSort: {
      type: Object,
      default: function _default() {
        return {
          prop: '',
          order: ''
        };
      }
    }
  },

  components: {
    ElCheckbox: _checkbox2.default,
    ElTag: _tag2.default
  },

  computed: {
    table: function table() {
      return this.$parent;
    },
    isAllSelected: function isAllSelected() {
      return this.store.states.isAllSelected;
    },
    columnsCount: function columnsCount() {
      return this.store.states.columns.length;
    },
    leftFixedCount: function leftFixedCount() {
      return this.store.states.fixedColumns.length;
    },
    rightFixedCount: function rightFixedCount() {
      return this.store.states.rightFixedColumns.length;
    },
    leftFixedLeafCount: function leftFixedLeafCount() {
      return this.store.states.fixedLeafColumnsLength;
    },
    rightFixedLeafCount: function rightFixedLeafCount() {
      return this.store.states.rightFixedLeafColumnsLength;
    },
    columns: function columns() {
      return this.store.states.columns;
    },
    hasGutter: function hasGutter() {
      return !this.fixed && this.layout.gutterWidth;
    }
  },

  created: function created() {
    this.filterPanels = {};
  },
  mounted: function mounted() {
    var _this2 = this;

    if (this.defaultSort.prop) {
      (function () {
        var states = _this2.store.states;
        states.sortProp = _this2.defaultSort.prop;
        states.sortOrder = _this2.defaultSort.order || 'ascending';
        _this2.$nextTick(function (_) {
          for (var i = 0, length = _this2.columns.length; i < length; i++) {
            var column = _this2.columns[i];
            if (column.property === states.sortProp) {
              column.order = states.sortOrder;
              states.sortingColumn = column;
              break;
            }
          }

          if (states.sortingColumn) {
            _this2.store.commit('changeSortCondition');
          }
        });
      })();
    }
  },
  beforeDestroy: function beforeDestroy() {
    var panels = this.filterPanels;
    for (var prop in panels) {
      if (panels.hasOwnProperty(prop) && panels[prop]) {
        panels[prop].$destroy(true);
      }
    }
  },


  methods: {
    isCellHidden: function isCellHidden(index, columns) {
      var start = 0;
      for (var i = 0; i < index; i++) {
        start += columns[i].colSpan;
      }
      var after = start + columns[index].colSpan - 1;
      if (this.fixed === true || this.fixed === 'left') {
        return after >= this.leftFixedLeafCount;
      } else if (this.fixed === 'right') {
        return start < this.columnsCount - this.rightFixedLeafCount;
      } else {
        return after < this.leftFixedLeafCount || start >= this.columnsCount - this.rightFixedLeafCount;
      }
    },
    getHeaderRowStyle: function getHeaderRowStyle(rowIndex) {
      var headerRowStyle = this.table.headerRowStyle;
      if (typeof headerRowStyle === 'function') {
        return headerRowStyle.call(null, { rowIndex: rowIndex });
      }
      return headerRowStyle;
    },
    getHeaderRowClass: function getHeaderRowClass(rowIndex) {
      var classes = [];

      var headerRowClassName = this.table.headerRowClassName;
      if (typeof headerRowClassName === 'string') {
        classes.push(headerRowClassName);
      } else if (typeof headerRowClassName === 'function') {
        classes.push(headerRowClassName.call(null, { rowIndex: rowIndex }));
      }

      return classes.join(' ');
    },
    getHeaderCellStyle: function getHeaderCellStyle(rowIndex, columnIndex, row, column) {
      var headerCellStyle = this.table.headerCellStyle;
      if (typeof headerCellStyle === 'function') {
        return headerCellStyle.call(null, {
          rowIndex: rowIndex,
          columnIndex: columnIndex,
          row: row,
          column: column
        });
      }
      return headerCellStyle;
    },
    getHeaderCellClass: function getHeaderCellClass(rowIndex, columnIndex, row, column) {
      var classes = [column.id, column.order, column.headerAlign, column.className, column.labelClassName];

      if (rowIndex === 0 && this.isCellHidden(columnIndex, row)) {
        classes.push('is-hidden');
      }

      if (!column.children) {
        classes.push('is-leaf');
      }

      if (column.sortable) {
        classes.push('is-sortable');
      }

      var headerCellClassName = this.table.headerCellClassName;
      if (typeof headerCellClassName === 'string') {
        classes.push(headerCellClassName);
      } else if (typeof headerCellClassName === 'function') {
        classes.push(headerCellClassName.call(null, {
          rowIndex: rowIndex,
          columnIndex: columnIndex,
          row: row,
          column: column
        }));
      }

      return classes.join(' ');
    },
    toggleAllSelection: function toggleAllSelection() {
      this.store.commit('toggleAllSelection');
    },
    handleFilterClick: function handleFilterClick(event, column) {
      event.stopPropagation();
      var target = event.target;
      var cell = target.parentNode;
      var table = this.$parent;

      var filterPanel = this.filterPanels[column.id];

      if (filterPanel && column.filterOpened) {
        filterPanel.showPopper = false;
        return;
      }

      if (!filterPanel) {
        filterPanel = new _vue2.default(_filterPanel2.default);
        this.filterPanels[column.id] = filterPanel;
        if (column.filterPlacement) {
          filterPanel.placement = column.filterPlacement;
        }
        filterPanel.table = table;
        filterPanel.cell = cell;
        filterPanel.column = column;
        !this.$isServer && filterPanel.$mount(document.createElement('div'));
      }

      setTimeout(function () {
        filterPanel.showPopper = true;
      }, 16);
    },
    handleHeaderClick: function handleHeaderClick(event, column) {
      if (!column.filters && column.sortable) {
        this.handleSortClick(event, column);
      } else if (column.filters && !column.sortable) {
        this.handleFilterClick(event, column);
      }

      this.$parent.$emit('header-click', column, event);
    },
    handleMouseDown: function handleMouseDown(event, column) {
      var _this3 = this;

      if (this.$isServer) return;
      if (column.children && column.children.length > 0) return;
      /* istanbul ignore if */
      if (this.draggingColumn && this.border) {
        (function () {
          _this3.dragging = true;

          _this3.$parent.resizeProxyVisible = true;

          var table = _this3.$parent;
          var tableEl = table.$el;
          var tableLeft = tableEl.getBoundingClientRect().left;
          var columnEl = _this3.$el.querySelector('th.' + column.id);
          var columnRect = columnEl.getBoundingClientRect();
          var minLeft = columnRect.left - tableLeft + 30;

          (0, _dom.addClass)(columnEl, 'noclick');

          _this3.dragState = {
            startMouseLeft: event.clientX,
            startLeft: columnRect.right - tableLeft,
            startColumnLeft: columnRect.left - tableLeft,
            tableLeft: tableLeft
          };

          var resizeProxy = table.$refs.resizeProxy;
          resizeProxy.style.left = _this3.dragState.startLeft + 'px';

          document.onselectstart = function () {
            return false;
          };
          document.ondragstart = function () {
            return false;
          };

          var handleMouseMove = function handleMouseMove(event) {
            var deltaLeft = event.clientX - _this3.dragState.startMouseLeft;
            var proxyLeft = _this3.dragState.startLeft + deltaLeft;

            resizeProxy.style.left = Math.max(minLeft, proxyLeft) + 'px';
          };

          var handleMouseUp = function handleMouseUp() {
            if (_this3.dragging) {
              var _dragState = _this3.dragState,
                  startColumnLeft = _dragState.startColumnLeft,
                  startLeft = _dragState.startLeft;

              var finalLeft = parseInt(resizeProxy.style.left, 10);
              var columnWidth = finalLeft - startColumnLeft;
              column.width = column.realWidth = columnWidth;
              table.$emit('header-dragend', column.width, startLeft - startColumnLeft, column, event);

              _this3.store.scheduleLayout();

              document.body.style.cursor = '';
              _this3.dragging = false;
              _this3.draggingColumn = null;
              _this3.dragState = {};

              table.resizeProxyVisible = false;
            }

            document.removeEventListener('mousemove', handleMouseMove);
            document.removeEventListener('mouseup', handleMouseUp);
            document.onselectstart = null;
            document.ondragstart = null;

            setTimeout(function () {
              (0, _dom.removeClass)(columnEl, 'noclick');
            }, 0);
          };

          document.addEventListener('mousemove', handleMouseMove);
          document.addEventListener('mouseup', handleMouseUp);
        })();
      }
    },
    handleMouseMove: function handleMouseMove(event, column) {
      if (column.children && column.children.length > 0) return;
      var target = event.target;
      while (target && target.tagName !== 'TH') {
        target = target.parentNode;
      }

      if (!column || !column.resizable) return;

      if (!this.dragging && this.border) {
        var rect = target.getBoundingClientRect();

        var bodyStyle = document.body.style;
        if (rect.width > 12 && rect.right - event.pageX < 8) {
          bodyStyle.cursor = 'col-resize';
          if ((0, _dom.hasClass)(target, 'is-sortable')) {
            target.style.cursor = 'col-resize';
          }
          this.draggingColumn = column;
        } else if (!this.dragging) {
          bodyStyle.cursor = '';
          if ((0, _dom.hasClass)(target, 'is-sortable')) {
            target.style.cursor = 'pointer';
          }
          this.draggingColumn = null;
        }
      }
    },
    handleMouseOut: function handleMouseOut() {
      if (this.$isServer) return;
      document.body.style.cursor = '';
    },
    toggleOrder: function toggleOrder(order) {
      return !order ? 'ascending' : order === 'ascending' ? 'descending' : null;
    },
    handleSortClick: function handleSortClick(event, column, givenOrder) {
      event.stopPropagation();
      var order = givenOrder || this.toggleOrder(column.order);

      var target = event.target;
      while (target && target.tagName !== 'TH') {
        target = target.parentNode;
      }

      if (target && target.tagName === 'TH') {
        if ((0, _dom.hasClass)(target, 'noclick')) {
          (0, _dom.removeClass)(target, 'noclick');
          return;
        }
      }

      if (!column.sortable) return;

      var states = this.store.states;
      var sortProp = states.sortProp;
      var sortOrder = void 0;
      var sortingColumn = states.sortingColumn;

      if (sortingColumn !== column) {
        if (sortingColumn) {
          sortingColumn.order = null;
        }
        states.sortingColumn = column;
        sortProp = column.property;
      }

      if (!order) {
        sortOrder = column.order = null;
        states.sortingColumn = null;
        sortProp = null;
      } else {
        sortOrder = column.order = order;
      }

      states.sortProp = sortProp;
      states.sortOrder = sortOrder;

      this.store.commit('changeSortCondition');
    }
  },

  data: function data() {
    return {
      draggingColumn: null,
      dragging: false,
      dragState: {}
    };
  }
};

/***/ }),

/***/ 191:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_filter_panel_vue__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_filter_panel_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_filter_panel_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a82ec7a0_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_filter_panel_vue__ = __webpack_require__(194);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_filter_panel_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a82ec7a0_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_filter_panel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 192:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _vuePopper = __webpack_require__(8);

var _vuePopper2 = _interopRequireDefault(_vuePopper);

var _popup = __webpack_require__(17);

var _locale = __webpack_require__(4);

var _locale2 = _interopRequireDefault(_locale);

var _clickoutside = __webpack_require__(10);

var _clickoutside2 = _interopRequireDefault(_clickoutside);

var _dropdown = __webpack_require__(193);

var _dropdown2 = _interopRequireDefault(_dropdown);

var _checkbox = __webpack_require__(16);

var _checkbox2 = _interopRequireDefault(_checkbox);

var _checkboxGroup = __webpack_require__(39);

var _checkboxGroup2 = _interopRequireDefault(_checkboxGroup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'ElTableFilterPanel',

  mixins: [_vuePopper2.default, _locale2.default],

  directives: {
    Clickoutside: _clickoutside2.default
  },

  components: {
    ElCheckbox: _checkbox2.default,
    ElCheckboxGroup: _checkboxGroup2.default
  },

  props: {
    placement: {
      type: String,
      default: 'bottom-end'
    }
  },

  customRender: function customRender(h) {
    return h(
      'div',
      { 'class': 'el-table-filter' },
      [h(
        'div',
        { 'class': 'el-table-filter__content' },
        []
      ), h(
        'div',
        { 'class': 'el-table-filter__bottom' },
        [h(
          'button',
          {
            on: {
              'click': this.handleConfirm
            }
          },
          [this.t('el.table.confirmFilter')]
        ), h(
          'button',
          {
            on: {
              'click': this.handleReset
            }
          },
          [this.t('el.table.resetFilter')]
        )]
      )]
    );
  },


  methods: {
    isActive: function isActive(filter) {
      return filter.value === this.filterValue;
    },
    handleOutsideClick: function handleOutsideClick() {
      this.showPopper = false;
    },
    handleConfirm: function handleConfirm() {
      this.confirmFilter(this.filteredValue);
      this.handleOutsideClick();
    },
    handleReset: function handleReset() {
      this.filteredValue = [];
      this.confirmFilter(this.filteredValue);
      this.handleOutsideClick();
    },
    handleSelect: function handleSelect(filterValue) {
      this.filterValue = filterValue;

      if (typeof filterValue !== 'undefined' && filterValue !== null) {
        this.confirmFilter(this.filteredValue);
      } else {
        this.confirmFilter([]);
      }

      this.handleOutsideClick();
    },
    confirmFilter: function confirmFilter(filteredValue) {
      this.table.store.commit('filterChange', {
        column: this.column,
        values: filteredValue
      });
    }
  },

  data: function data() {
    return {
      table: null,
      cell: null,
      column: null
    };
  },


  computed: {
    filters: function filters() {
      return this.column && this.column.filters;
    },


    filterValue: {
      get: function get() {
        return (this.column.filteredValue || [])[0];
      },
      set: function set(value) {
        if (this.filteredValue) {
          if (typeof value !== 'undefined' && value !== null) {
            this.filteredValue.splice(0, 1, value);
          } else {
            this.filteredValue.splice(0, 1);
          }
        }
      }
    },

    filteredValue: {
      get: function get() {
        if (this.column) {
          return this.column.filteredValue || [];
        }
        return [];
      },
      set: function set(value) {
        if (this.column) {
          this.column.filteredValue = value;
        }
      }
    },

    multiple: function multiple() {
      if (this.column) {
        return this.column.filterMultiple;
      }
      return true;
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.popperElm = this.$el;
    this.referenceElm = this.cell;
    this.table.bodyWrapper.addEventListener('scroll', function () {
      _this.updatePopper();
    });

    this.$watch('showPopper', function (value) {
      if (_this.column) _this.column.filterOpened = value;
      if (value) {
        _dropdown2.default.open(_this);
      } else {
        _dropdown2.default.close(_this);
      }
    });
  },

  watch: {
    showPopper: function showPopper(val) {
      if (val === true && parseInt(this.popperJS._popper.style.zIndex, 10) < _popup.PopupManager.zIndex) {
        this.popperJS._popper.style.zIndex = _popup.PopupManager.nextZIndex();
      }
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ 193:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _vue = __webpack_require__(5);

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var dropdowns = [];

!_vue2.default.prototype.$isServer && document.addEventListener('click', function (event) {
  dropdowns.forEach(function (dropdown) {
    var target = event.target;
    if (!dropdown || !dropdown.$el) return;
    if (target === dropdown.$el || dropdown.$el.contains(target)) {
      return;
    }
    dropdown.handleOutsideClick && dropdown.handleOutsideClick(event);
  });
});

exports.default = {
  open: function open(instance) {
    if (instance) {
      dropdowns.push(instance);
    }
  },
  close: function close(instance) {
    var index = dropdowns.indexOf(instance);
    if (index !== -1) {
      dropdowns.splice(instance, 1);
    }
  }
};

/***/ }),

/***/ 194:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"el-zoom-in-top"}},[(_vm.multiple)?_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showPopper),expression:"showPopper"}],staticClass:"el-table-filter"},[_c('div',{staticClass:"el-table-filter__content"},[_c('el-checkbox-group',{staticClass:"el-table-filter__checkbox-group",model:{value:(_vm.filteredValue),callback:function ($$v) {_vm.filteredValue=$$v},expression:"filteredValue"}},_vm._l((_vm.filters),function(filter){return _c('el-checkbox',{key:filter.value,attrs:{"label":filter.value}},[_vm._v(_vm._s(filter.text))])}))],1),_c('div',{staticClass:"el-table-filter__bottom"},[_c('button',{class:{ 'is-disabled': _vm.filteredValue.length === 0 },attrs:{"disabled":_vm.filteredValue.length === 0},on:{"click":_vm.handleConfirm}},[_vm._v(_vm._s(_vm.t('el.table.confirmFilter')))]),_c('button',{on:{"click":_vm.handleReset}},[_vm._v(_vm._s(_vm.t('el.table.resetFilter')))])])]):_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showPopper),expression:"showPopper"}],staticClass:"el-table-filter"},[_c('ul',{staticClass:"el-table-filter__list"},[_c('li',{staticClass:"el-table-filter__list-item",class:{ 'is-active': _vm.filterValue === undefined || _vm.filterValue === null },on:{"click":function($event){_vm.handleSelect(null)}}},[_vm._v(_vm._s(_vm.t('el.table.clearFilter')))]),_vm._l((_vm.filters),function(filter){return _c('li',{key:filter.value,staticClass:"el-table-filter__list-item",class:{ 'is-active': _vm.isActive(filter) },attrs:{"label":filter.value},on:{"click":function($event){_vm.handleSelect(filter.value)}}},[_vm._v(_vm._s(filter.text))])})],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 195:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = {
  name: 'ElTableFooter',

  render: function render(h) {
    var _this = this;

    var sums = [];
    this.columns.forEach(function (column, index) {
      if (index === 0) {
        sums[index] = _this.sumText;
        return;
      }
      var values = _this.store.states.data.map(function (item) {
        return Number(item[column.property]);
      });
      var precisions = [];
      var notNumber = true;
      values.forEach(function (value) {
        if (!isNaN(value)) {
          notNumber = false;
          var decimal = ('' + value).split('.')[1];
          precisions.push(decimal ? decimal.length : 0);
        }
      });
      var precision = Math.max.apply(null, precisions);
      if (!notNumber) {
        sums[index] = values.reduce(function (prev, curr) {
          var value = Number(curr);
          if (!isNaN(value)) {
            return parseFloat((prev + curr).toFixed(Math.min(precision, 20)));
          } else {
            return prev;
          }
        }, 0);
      } else {
        sums[index] = '';
      }
    });

    return h(
      'table',
      {
        'class': 'el-table__footer',
        attrs: { cellspacing: '0',
          cellpadding: '0',
          border: '0' }
      },
      [h(
        'colgroup',
        null,
        [this._l(this.columns, function (column) {
          return h(
            'col',
            {
              attrs: {
                name: column.id,
                width: column.realWidth || column.width
              }
            },
            []
          );
        }), !this.fixed && this.layout.gutterWidth ? h(
          'col',
          {
            attrs: { name: 'gutter', width: this.layout.scrollY ? this.layout.gutterWidth : '' }
          },
          []
        ) : '']
      ), h(
        'tbody',
        { 'class': [{ 'has-gutter': this.hasGutter }] },
        [h(
          'tr',
          null,
          [this._l(this.columns, function (column, cellIndex) {
            return h(
              'td',
              {
                attrs: {
                  colspan: column.colSpan,
                  rowspan: column.rowSpan
                },
                'class': [column.id, column.headerAlign, column.className || '', _this.isCellHidden(cellIndex, _this.columns) ? 'is-hidden' : '', !column.children ? 'is-leaf' : '', column.labelClassName] },
              [h(
                'div',
                { 'class': ['cell', column.labelClassName] },
                [_this.summaryMethod ? _this.summaryMethod({ columns: _this.columns, data: _this.store.states.data })[cellIndex] : sums[cellIndex]]
              )]
            );
          }), this.hasGutter ? h(
            'td',
            { 'class': 'gutter', style: { width: this.layout.scrollY ? this.layout.gutterWidth + 'px' : '0' } },
            []
          ) : '']
        )]
      )]
    );
  },


  props: {
    fixed: String,
    store: {
      required: true
    },
    layout: {
      required: true
    },
    summaryMethod: Function,
    sumText: String,
    border: Boolean,
    defaultSort: {
      type: Object,
      default: function _default() {
        return {
          prop: '',
          order: ''
        };
      }
    }
  },

  computed: {
    isAllSelected: function isAllSelected() {
      return this.store.states.isAllSelected;
    },
    columnsCount: function columnsCount() {
      return this.store.states.columns.length;
    },
    leftFixedCount: function leftFixedCount() {
      return this.store.states.fixedColumns.length;
    },
    rightFixedCount: function rightFixedCount() {
      return this.store.states.rightFixedColumns.length;
    },
    columns: function columns() {
      return this.store.states.columns;
    },
    hasGutter: function hasGutter() {
      return !this.fixed && this.layout.gutterWidth;
    }
  },

  methods: {
    isCellHidden: function isCellHidden(index, columns) {
      if (this.fixed === true || this.fixed === 'left') {
        return index >= this.leftFixedCount;
      } else if (this.fixed === 'right') {
        var before = 0;
        for (var i = 0; i < index; i++) {
          before += columns[i].colSpan;
        }
        return before < this.columnsCount - this.rightFixedCount;
      } else {
        return index < this.leftFixedCount || index >= this.columnsCount - this.rightFixedCount;
      }
    }
  }
};

/***/ }),

/***/ 196:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"el-table",class:[{
    'el-table--fit': _vm.fit,
    'el-table--striped': _vm.stripe,
    'el-table--border': _vm.border || _vm.isGroup,
    'el-table--hidden': _vm.isHidden,
    'el-table--group': _vm.isGroup,
    'el-table--fluid-height': _vm.maxHeight,
    'el-table--enable-row-hover': !_vm.store.states.isComplex,
    'el-table--enable-row-transition': (_vm.store.states.data || []).length !== 0 && (_vm.store.states.data || []).length < 100
  }, _vm.tableSize ? ("el-table--" + _vm.tableSize) : ''],on:{"mouseleave":function($event){_vm.handleMouseLeave($event)}}},[_c('div',{ref:"hiddenColumns",staticClass:"hidden-columns"},[_vm._t("default")],2),(_vm.showHeader)?_c('div',{ref:"headerWrapper",staticClass:"el-table__header-wrapper"},[_c('table-header',{ref:"tableHeader",style:({ width: _vm.layout.bodyWidth ? _vm.layout.bodyWidth + 'px' : '' }),attrs:{"store":_vm.store,"layout":_vm.layout,"border":_vm.border,"default-sort":_vm.defaultSort}})],1):_vm._e(),_c('div',{ref:"bodyWrapper",staticClass:"el-table__body-wrapper",class:[("is-scroll-" + _vm.scrollPosition)],style:([_vm.bodyHeight])},[_c('table-body',{style:({ width: _vm.bodyWidth }),attrs:{"context":_vm.context,"store":_vm.store,"stripe":_vm.stripe,"layout":_vm.layout,"row-class-name":_vm.rowClassName,"row-style":_vm.rowStyle,"highlight":_vm.highlightCurrentRow}}),(!_vm.data || _vm.data.length === 0)?_c('div',{staticClass:"el-table__empty-block",style:({ width: _vm.bodyWidth })},[_c('span',{staticClass:"el-table__empty-text"},[_vm._t("empty",[_vm._v(_vm._s(_vm.emptyText || _vm.t('el.table.emptyText')))])],2)]):_vm._e(),(_vm.$slots.append)?_c('div',{ref:"appendWrapper",staticClass:"el-table__append-wrapper"},[_vm._t("append")],2):_vm._e()],1),(_vm.showSummary)?_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.data && _vm.data.length > 0),expression:"data && data.length > 0"}],ref:"footerWrapper",staticClass:"el-table__footer-wrapper"},[_c('table-footer',{style:({ width: _vm.layout.bodyWidth ? _vm.layout.bodyWidth + 'px' : '' }),attrs:{"store":_vm.store,"layout":_vm.layout,"border":_vm.border,"sum-text":_vm.sumText || _vm.t('el.table.sumText'),"summary-method":_vm.summaryMethod,"default-sort":_vm.defaultSort}})],1):_vm._e(),(_vm.fixedColumns.length > 0)?_c('div',{ref:"fixedWrapper",staticClass:"el-table__fixed",style:([
      { width: _vm.layout.fixedWidth ? _vm.layout.fixedWidth + 'px' : '' },
      _vm.fixedHeight
    ])},[(_vm.showHeader)?_c('div',{ref:"fixedHeaderWrapper",staticClass:"el-table__fixed-header-wrapper"},[_c('table-header',{ref:"fixedTableHeader",style:({ width: _vm.layout.fixedWidth ? _vm.layout.fixedWidth + 'px' : '' }),attrs:{"fixed":"left","border":_vm.border,"store":_vm.store,"layout":_vm.layout}})],1):_vm._e(),_c('div',{ref:"fixedBodyWrapper",staticClass:"el-table__fixed-body-wrapper",style:([
        { top: _vm.layout.headerHeight + 'px' },
        _vm.fixedBodyHeight
      ])},[_c('table-body',{style:({ width: _vm.layout.fixedWidth ? _vm.layout.fixedWidth + 'px' : '' }),attrs:{"fixed":"left","store":_vm.store,"stripe":_vm.stripe,"layout":_vm.layout,"highlight":_vm.highlightCurrentRow,"row-class-name":_vm.rowClassName,"row-style":_vm.rowStyle}}),(_vm.$slots.append)?_c('div',{staticClass:"el-table__append-gutter",style:({ height: _vm.layout.appendHeight + 'px' })}):_vm._e()],1),(_vm.showSummary)?_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.data && _vm.data.length > 0),expression:"data && data.length > 0"}],ref:"fixedFooterWrapper",staticClass:"el-table__fixed-footer-wrapper"},[_c('table-footer',{style:({ width: _vm.layout.fixedWidth ? _vm.layout.fixedWidth + 'px' : '' }),attrs:{"fixed":"left","border":_vm.border,"sum-text":_vm.sumText || _vm.t('el.table.sumText'),"summary-method":_vm.summaryMethod,"store":_vm.store,"layout":_vm.layout}})],1):_vm._e()]):_vm._e(),(_vm.rightFixedColumns.length > 0)?_c('div',{ref:"rightFixedWrapper",staticClass:"el-table__fixed-right",style:([
      { width: _vm.layout.rightFixedWidth ? _vm.layout.rightFixedWidth + 'px' : '' },
      { right: _vm.layout.scrollY ? (_vm.border ? _vm.layout.gutterWidth : (_vm.layout.gutterWidth || 0)) + 'px' : '' },
      _vm.fixedHeight
    ])},[(_vm.showHeader)?_c('div',{ref:"rightFixedHeaderWrapper",staticClass:"el-table__fixed-header-wrapper"},[_c('table-header',{ref:"rightFixedTableHeader",style:({ width: _vm.layout.rightFixedWidth ? _vm.layout.rightFixedWidth + 'px' : '' }),attrs:{"fixed":"right","border":_vm.border,"store":_vm.store,"layout":_vm.layout}})],1):_vm._e(),_c('div',{ref:"rightFixedBodyWrapper",staticClass:"el-table__fixed-body-wrapper",style:([
        { top: _vm.layout.headerHeight + 'px' },
        _vm.fixedBodyHeight
      ])},[_c('table-body',{style:({ width: _vm.layout.rightFixedWidth ? _vm.layout.rightFixedWidth + 'px' : '' }),attrs:{"fixed":"right","store":_vm.store,"stripe":_vm.stripe,"layout":_vm.layout,"row-class-name":_vm.rowClassName,"row-style":_vm.rowStyle,"highlight":_vm.highlightCurrentRow}})],1),(_vm.showSummary)?_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.data && _vm.data.length > 0),expression:"data && data.length > 0"}],ref:"rightFixedFooterWrapper",staticClass:"el-table__fixed-footer-wrapper"},[_c('table-footer',{style:({ width: _vm.layout.rightFixedWidth ? _vm.layout.rightFixedWidth + 'px' : '' }),attrs:{"fixed":"right","border":_vm.border,"sum-text":_vm.sumText || _vm.t('el.table.sumText'),"summary-method":_vm.summaryMethod,"store":_vm.store,"layout":_vm.layout}})],1):_vm._e()]):_vm._e(),(_vm.rightFixedColumns.length > 0)?_c('div',{staticClass:"el-table__fixed-right-patch",style:({ width: _vm.layout.scrollY ? _vm.layout.gutterWidth + 'px' : '0', height: _vm.layout.headerHeight + 'px' })}):_vm._e(),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.resizeProxyVisible),expression:"resizeProxyVisible"}],ref:"resizeProxy",staticClass:"el-table__column-resize-proxy"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = __webpack_require__(11);

/***/ }),

/***/ 22:
/***/ (function(module, exports) {

module.exports = __webpack_require__(104);

/***/ }),

/***/ 24:
/***/ (function(module, exports) {

module.exports = __webpack_require__(100);

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = __webpack_require__(14);

/***/ }),

/***/ 36:
/***/ (function(module, exports) {

module.exports = __webpack_require__(184);

/***/ }),

/***/ 37:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.getRowIdentity = exports.mousewheel = exports.getColumnByCell = exports.getColumnById = exports.orderBy = exports.getCell = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _util = __webpack_require__(3);

var getCell = exports.getCell = function getCell(event) {
  var cell = event.target;

  while (cell && cell.tagName.toUpperCase() !== 'HTML') {
    if (cell.tagName.toUpperCase() === 'TD') {
      return cell;
    }
    cell = cell.parentNode;
  }

  return null;
};

var isObject = function isObject(obj) {
  return obj !== null && (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object';
};

var orderBy = exports.orderBy = function orderBy(array, sortKey, reverse, sortMethod, sortBy) {
  if (!sortKey && !sortMethod && (!sortBy || Array.isArray(sortBy) && !sortBy.length)) {
    return array;
  }
  if (typeof reverse === 'string') {
    reverse = reverse === 'descending' ? -1 : 1;
  } else {
    reverse = reverse && reverse < 0 ? -1 : 1;
  }
  var getKey = sortMethod ? null : function (value, index) {
    if (sortBy) {
      if (!Array.isArray(sortBy)) {
        sortBy = [sortBy];
      }
      return sortBy.map(function (by) {
        if (typeof by === 'string') {
          return (0, _util.getValueByPath)(value, by);
        } else {
          return by(value, index, array);
        }
      });
    }
    if (sortKey !== '$key') {
      if (isObject(value) && '$value' in value) value = value.$value;
    }
    return [isObject(value) ? (0, _util.getValueByPath)(value, sortKey) : value];
  };
  var compare = function compare(a, b) {
    if (sortMethod) {
      return sortMethod(a.value, b.value);
    }
    for (var i = 0, len = a.key.length; i < len; i++) {
      if (a.key[i] < b.key[i]) {
        return -1;
      }
      if (a.key[i] > b.key[i]) {
        return 1;
      }
    }
    return 0;
  };
  return array.map(function (value, index) {
    return {
      value: value,
      index: index,
      key: getKey ? getKey(value, index) : null
    };
  }).sort(function (a, b) {
    var order = compare(a, b);
    if (!order) {
      // make stable https://en.wikipedia.org/wiki/Sorting_algorithm#Stability
      order = a.index - b.index;
    }
    return order * reverse;
  }).map(function (item) {
    return item.value;
  });
};

var getColumnById = exports.getColumnById = function getColumnById(table, columnId) {
  var column = null;
  table.columns.forEach(function (item) {
    if (item.id === columnId) {
      column = item;
    }
  });
  return column;
};

var getColumnByCell = exports.getColumnByCell = function getColumnByCell(table, cell) {
  var matches = (cell.className || '').match(/el-table_[^\s]+/gm);
  if (matches) {
    return getColumnById(table, matches[0]);
  }
  return null;
};

var isFirefox = typeof navigator !== 'undefined' && navigator.userAgent.toLowerCase().indexOf('firefox') > -1;

var mousewheel = exports.mousewheel = function mousewheel(element, callback) {
  if (element && element.addEventListener) {
    element.addEventListener(isFirefox ? 'DOMMouseScroll' : 'mousewheel', callback, { passive: true });
  }
};

var getRowIdentity = exports.getRowIdentity = function getRowIdentity(row, rowKey) {
  if (!row) throw new Error('row is required when get row identity');
  if (typeof rowKey === 'string') {
    if (rowKey.indexOf('.') < 0) {
      return row[rowKey];
    }
    var key = rowKey.split('.');
    var current = row;
    for (var i = 0; i < key.length; i++) {
      current = current[key[i]];
    }
    return current;
  } else if (typeof rowKey === 'function') {
    return rowKey.call(null, row);
  }
};

/***/ }),

/***/ 38:
/***/ (function(module, exports) {

module.exports = __webpack_require__(103);

/***/ }),

/***/ 39:
/***/ (function(module, exports) {

module.exports = __webpack_require__(185);

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = __webpack_require__(101);

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

module.exports = __webpack_require__(0);

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

module.exports = __webpack_require__(42);

/***/ }),

/***/ 8:
/***/ (function(module, exports) {

module.exports = __webpack_require__(52);

/***/ }),

/***/ 9:
/***/ (function(module, exports) {

module.exports = __webpack_require__(41);

/***/ })

/******/ });

/***/ }),

/***/ 552:
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 197);
/******/ })
/************************************************************************/
/******/ ({

/***/ 16:
/***/ (function(module, exports) {

module.exports = __webpack_require__(181);

/***/ }),

/***/ 197:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(198);


/***/ }),

/***/ 198:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _tableColumn = __webpack_require__(199);

var _tableColumn2 = _interopRequireDefault(_tableColumn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
_tableColumn2.default.install = function (Vue) {
  Vue.component(_tableColumn2.default.name, _tableColumn2.default);
};

exports.default = _tableColumn2.default;

/***/ }),

/***/ 199:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _checkbox = __webpack_require__(16);

var _checkbox2 = _interopRequireDefault(_checkbox);

var _tag = __webpack_require__(24);

var _tag2 = _interopRequireDefault(_tag);

var _merge = __webpack_require__(9);

var _merge2 = _interopRequireDefault(_merge);

var _util = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var columnIdSeed = 1;

var defaults = {
  default: {
    order: ''
  },
  selection: {
    width: 48,
    minWidth: 48,
    realWidth: 48,
    order: '',
    className: 'el-table-column--selection'
  },
  expand: {
    width: 48,
    minWidth: 48,
    realWidth: 48,
    order: ''
  },
  index: {
    width: 48,
    minWidth: 48,
    realWidth: 48,
    order: ''
  }
};

var forced = {
  selection: {
    renderHeader: function renderHeader(h) {
      return h(
        'el-checkbox',
        {
          nativeOn: {
            'click': this.toggleAllSelection
          },
          attrs: {
            value: this.isAllSelected }
        },
        []
      );
    },
    renderCell: function renderCell(h, _ref) {
      var row = _ref.row,
          column = _ref.column,
          store = _ref.store,
          $index = _ref.$index;

      return h(
        'el-checkbox',
        {
          attrs: {
            value: store.isSelected(row),
            disabled: column.selectable ? !column.selectable.call(null, row, $index) : false
          },
          on: {
            'input': function input() {
              store.commit('rowSelectedChanged', row);
            }
          }
        },
        []
      );
    },
    sortable: false,
    resizable: false
  },
  index: {
    renderHeader: function renderHeader(h, _ref2) {
      var column = _ref2.column;

      return column.label || '#';
    },
    renderCell: function renderCell(h, _ref3) {
      var $index = _ref3.$index,
          column = _ref3.column;

      var i = $index + 1;
      var index = column.index;

      if (typeof index === 'number') {
        i = $index + index;
      } else if (typeof index === 'function') {
        i = index($index);
      }

      return h(
        'div',
        null,
        [i]
      );
    },
    sortable: false
  },
  expand: {
    renderHeader: function renderHeader(h, _ref4) {
      var column = _ref4.column;

      return column.label || '';
    },
    renderCell: function renderCell(h, _ref5, proxy) {
      var row = _ref5.row,
          store = _ref5.store;

      var expanded = store.states.expandRows.indexOf(row) > -1;
      return h(
        'div',
        { 'class': 'el-table__expand-icon ' + (expanded ? 'el-table__expand-icon--expanded' : ''),
          on: {
            'click': function click() {
              return proxy.handleExpandClick(row);
            }
          }
        },
        [h(
          'i',
          { 'class': 'el-icon el-icon-arrow-right' },
          []
        )]
      );
    },
    sortable: false,
    resizable: false,
    className: 'el-table__expand-column'
  }
};

var getDefaultColumn = function getDefaultColumn(type, options) {
  var column = {};

  (0, _merge2.default)(column, defaults[type || 'default']);

  for (var name in options) {
    if (options.hasOwnProperty(name)) {
      var value = options[name];
      if (typeof value !== 'undefined') {
        column[name] = value;
      }
    }
  }

  if (!column.minWidth) {
    column.minWidth = 80;
  }

  column.realWidth = column.width === undefined ? column.minWidth : column.width;

  return column;
};

var DEFAULT_RENDER_CELL = function DEFAULT_RENDER_CELL(h, _ref6) {
  var row = _ref6.row,
      column = _ref6.column;

  var property = column.property;
  var value = property && (0, _util.getPropByPath)(row, property).v;
  if (column && column.formatter) {
    return column.formatter(row, column, value);
  }
  return value;
};

exports.default = {
  name: 'ElTableColumn',

  props: {
    type: {
      type: String,
      default: 'default'
    },
    label: String,
    className: String,
    labelClassName: String,
    property: String,
    prop: String,
    width: {},
    minWidth: {},
    renderHeader: Function,
    sortable: {
      type: [String, Boolean],
      default: false
    },
    sortMethod: Function,
    sortBy: [String, Function, Array],
    resizable: {
      type: Boolean,
      default: true
    },
    context: {},
    columnKey: String,
    align: String,
    headerAlign: String,
    showTooltipWhenOverflow: Boolean,
    showOverflowTooltip: Boolean,
    fixed: [Boolean, String],
    formatter: Function,
    selectable: Function,
    reserveSelection: Boolean,
    filterMethod: Function,
    filteredValue: Array,
    filters: Array,
    filterPlacement: String,
    filterMultiple: {
      type: Boolean,
      default: true
    },
    index: [Number, Function]
  },

  data: function data() {
    return {
      isSubColumn: false,
      columns: []
    };
  },
  beforeCreate: function beforeCreate() {
    this.row = {};
    this.column = {};
    this.$index = 0;
  },


  components: {
    ElCheckbox: _checkbox2.default,
    ElTag: _tag2.default
  },

  computed: {
    owner: function owner() {
      var parent = this.$parent;
      while (parent && !parent.tableId) {
        parent = parent.$parent;
      }
      return parent;
    },
    columnOrTableParent: function columnOrTableParent() {
      var parent = this.$parent;
      while (parent && !parent.tableId && !parent.columnId) {
        parent = parent.$parent;
      }
      return parent;
    }
  },

  created: function created() {
    var _this = this;

    this.customRender = this.$options.render;
    this.$options.render = function (h) {
      return h('div', _this.$slots.default);
    };

    var parent = this.columnOrTableParent;
    var owner = this.owner;
    this.isSubColumn = owner !== parent;
    this.columnId = (parent.tableId || parent.columnId + '_') + 'column_' + columnIdSeed++;

    var type = this.type;

    var width = this.width;
    if (width !== undefined) {
      width = parseInt(width, 10);
      if (isNaN(width)) {
        width = null;
      }
    }

    var minWidth = this.minWidth;
    if (minWidth !== undefined) {
      minWidth = parseInt(minWidth, 10);
      if (isNaN(minWidth)) {
        minWidth = 80;
      }
    }

    var isColumnGroup = false;

    var column = getDefaultColumn(type, {
      id: this.columnId,
      columnKey: this.columnKey,
      label: this.label,
      className: this.className,
      labelClassName: this.labelClassName,
      property: this.prop || this.property,
      type: type,
      renderCell: null,
      renderHeader: this.renderHeader,
      minWidth: minWidth,
      width: width,
      isColumnGroup: isColumnGroup,
      context: this.context,
      align: this.align ? 'is-' + this.align : null,
      headerAlign: this.headerAlign ? 'is-' + this.headerAlign : this.align ? 'is-' + this.align : null,
      sortable: this.sortable === '' ? true : this.sortable,
      sortMethod: this.sortMethod,
      sortBy: this.sortBy,
      resizable: this.resizable,
      showOverflowTooltip: this.showOverflowTooltip || this.showTooltipWhenOverflow,
      formatter: this.formatter,
      selectable: this.selectable,
      reserveSelection: this.reserveSelection,
      fixed: this.fixed === '' ? true : this.fixed,
      filterMethod: this.filterMethod,
      filters: this.filters,
      filterable: this.filters || this.filterMethod,
      filterMultiple: this.filterMultiple,
      filterOpened: false,
      filteredValue: this.filteredValue || [],
      filterPlacement: this.filterPlacement || '',
      index: this.index
    });

    (0, _merge2.default)(column, forced[type] || {});

    this.columnConfig = column;

    var renderCell = column.renderCell;
    var _self = this;

    if (type === 'expand') {
      owner.renderExpanded = function (h, data) {
        return _self.$scopedSlots.default ? _self.$scopedSlots.default(data) : _self.$slots.default;
      };

      column.renderCell = function (h, data) {
        return h(
          'div',
          { 'class': 'cell' },
          [renderCell(h, data, this._renderProxy)]
        );
      };

      return;
    }

    column.renderCell = function (h, data) {
      if (_self.$scopedSlots.default) {
        renderCell = function renderCell() {
          return _self.$scopedSlots.default(data);
        };
      }

      if (!renderCell) {
        renderCell = DEFAULT_RENDER_CELL;
      }

      return _self.showOverflowTooltip || _self.showTooltipWhenOverflow ? h(
        'div',
        { 'class': 'cell el-tooltip', style: 'width:' + (data.column.realWidth || data.column.width) + 'px' },
        [renderCell(h, data)]
      ) : h(
        'div',
        { 'class': 'cell' },
        [renderCell(h, data)]
      );
    };
  },
  destroyed: function destroyed() {
    if (!this.$parent) return;
    this.owner.store.commit('removeColumn', this.columnConfig);
  },


  watch: {
    label: function label(newVal) {
      if (this.columnConfig) {
        this.columnConfig.label = newVal;
      }
    },
    prop: function prop(newVal) {
      if (this.columnConfig) {
        this.columnConfig.property = newVal;
      }
    },
    property: function property(newVal) {
      if (this.columnConfig) {
        this.columnConfig.property = newVal;
      }
    },
    filters: function filters(newVal) {
      if (this.columnConfig) {
        this.columnConfig.filters = newVal;
      }
    },
    filterMultiple: function filterMultiple(newVal) {
      if (this.columnConfig) {
        this.columnConfig.filterMultiple = newVal;
      }
    },
    align: function align(newVal) {
      if (this.columnConfig) {
        this.columnConfig.align = newVal ? 'is-' + newVal : null;

        if (!this.headerAlign) {
          this.columnConfig.headerAlign = newVal ? 'is-' + newVal : null;
        }
      }
    },
    headerAlign: function headerAlign(newVal) {
      if (this.columnConfig) {
        this.columnConfig.headerAlign = 'is-' + (newVal ? newVal : this.align);
      }
    },
    width: function width(newVal) {
      if (this.columnConfig) {
        this.columnConfig.width = newVal;
        this.owner.store.scheduleLayout();
      }
    },
    minWidth: function minWidth(newVal) {
      if (this.columnConfig) {
        this.columnConfig.minWidth = newVal;
        this.owner.store.scheduleLayout();
      }
    },
    fixed: function fixed(newVal) {
      if (this.columnConfig) {
        this.columnConfig.fixed = newVal;
        this.owner.store.scheduleLayout();
      }
    },
    sortable: function sortable(newVal) {
      if (this.columnConfig) {
        this.columnConfig.sortable = newVal;
      }
    },
    index: function index(newVal) {
      if (this.columnConfig) {
        this.columnConfig.index = newVal;
      }
    }
  },

  mounted: function mounted() {
    var owner = this.owner;
    var parent = this.columnOrTableParent;
    var columnIndex = void 0;

    if (!this.isSubColumn) {
      columnIndex = [].indexOf.call(parent.$refs.hiddenColumns.children, this.$el);
    } else {
      columnIndex = [].indexOf.call(parent.$el.children, this.$el);
    }

    owner.store.commit('insertColumn', this.columnConfig, columnIndex, this.isSubColumn ? parent.columnConfig : null);
  }
};

/***/ }),

/***/ 24:
/***/ (function(module, exports) {

module.exports = __webpack_require__(100);

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = __webpack_require__(14);

/***/ }),

/***/ 9:
/***/ (function(module, exports) {

module.exports = __webpack_require__(41);

/***/ })

/******/ });

/***/ }),

/***/ 553:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return COLLABORATOR_ROLES; });
// eslint-disable-next-line import/prefer-default-export
var COLLABORATOR_ROLES = ['Director', 'Assistant Director', 'Executive Producer', 'Producer', 'Writer', 'Director of Photography', 'Editor', 'Art Director', 'Animator', 'Cast', 'Crew', 'Script Supervisor', 'Camera Assistant', 'Gaffer', 'Grip', 'Art Assistant', 'Wardrobe', 'Hair & Makeup', 'Sound Recordist', 'Production Manager', 'Production Assistant', 'Offline Editor', 'Online Editor', 'Colourist', 'Visual Effects', 'Audio Post Production', 'Sound Design', 'Music Composer'];

/***/ }),

/***/ 554:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditView_vue__ = __webpack_require__(557);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_644260e9_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditView_vue__ = __webpack_require__(558);
function injectStyle (ssrContext) {
  __webpack_require__(555)
}
var normalizeComponent = __webpack_require__(7)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-644260e9"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditView_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_644260e9_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditView_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 555:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(556);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(512)("0ecb37f3", content, true);

/***/ }),

/***/ 556:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(511)(true);
// imports


// module
exports.push([module.i, ".edit-view .el-form-item[data-v-644260e9]{margin-bottom:0}", "", {"version":3,"sources":["/app/src/components/Submission/steps/CollaboratorDetails/CollaboratorItem/EditView.vue"],"names":[],"mappings":"AACA,0CACE,eAAiB,CAClB","file":"EditView.vue","sourcesContent":["\n.edit-view .el-form-item[data-v-644260e9] {\n  margin-bottom: 0;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 557:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'EditView',
  props: ['value', 'editable', 'placeholder'],
  computed: {
    data: function data() {
      return this.value;
    }
  },
  methods: {
    updateParent: function updateParent(value) {
      this.$emit('input', value);
    }
  },
  mounted: function mounted() {}
});

/***/ }),

/***/ 558:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"edit-view"},[(_vm.editable)?_vm._t("default",[_c('el-form-item',[_c('el-input',{attrs:{"value":_vm.data,"placeholder":_vm.placeholder},on:{"input":_vm.updateParent}})],1)]):_c('span',[_vm._v("\n    "+_vm._s(_vm.data)+"\n  ")])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 559:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-form',{staticClass:"collaborator-table"},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.humans,"show-header":_vm.showHeader}},[(!_vm.defaultRole)?_c('el-table-column',{attrs:{"prop":"role","label":"Role","min-width":"150"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('EditView',{staticStyle:{"text-transform":"capitalize"},attrs:{"editable":scope.row.editable},on:{"input":_vm.updateUnsavedStatus},model:{value:(scope.row.role),callback:function ($$v) {_vm.$set(scope.row, "role", $$v)},expression:"scope.row.role"}},[_c('el-select',{attrs:{"placeholder":"Pick a role","filterable":_vm.enableTyping,"allow-create":_vm.enableTyping,"width":"100"},model:{value:(scope.row.role),callback:function ($$v) {_vm.$set(scope.row, "role", $$v)},expression:"scope.row.role"}},_vm._l((_vm.roles),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}))],1)]}}])}):_vm._e(),_vm._v(" "),_c('el-table-column',{attrs:{"label":"First name","min-width":"150"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('EditView',{attrs:{"editable":scope.row.editable,"placeholder":_vm.showHeader ? undefined : 'First name'},on:{"input":_vm.updateUnsavedStatus},model:{value:(scope.row.first_name),callback:function ($$v) {_vm.$set(scope.row, "first_name", $$v)},expression:"scope.row.first_name"}})]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Last name","min-width":"150"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('EditView',{attrs:{"editable":scope.row.editable,"placeholder":_vm.showHeader ? undefined : 'Last name'},on:{"input":_vm.updateUnsavedStatus},model:{value:(scope.row.last_name),callback:function ($$v) {_vm.$set(scope.row, "last_name", $$v)},expression:"scope.row.last_name"}})]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Email","min-width":"250"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('EditView',{attrs:{"editable":scope.row.editable,"placeholder":_vm.showHeader ? undefined : 'Email'},on:{"input":_vm.updateUnsavedStatus},model:{value:(scope.row.email),callback:function ($$v) {_vm.$set(scope.row, "email", $$v)},expression:"scope.row.email"}})]}}])}),_vm._v(" "),(_vm.showAction && !_vm.disabled)?_c('el-table-column',{attrs:{"fixed":"right","label":"Action","width":_vm.isTemporary ? 40 : 80},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(_vm.isTemporary)?[_c('el-button',{attrs:{"type":"text","size":"small","icon":"el-icon-delete"},on:{"click":function($event){_vm.removeCollaborator(scope.$index)}}})]:[(scope.row.editable)?_c('span',[_c('el-button',{attrs:{"type":"text","size":"small"},on:{"click":function($event){_vm.saveCollaborator(scope.$index)}}},[_vm._v("Save")]),_vm._v(" "),_c('el-button',{attrs:{"type":"text","size":"small","icon":"el-icon-close"},on:{"click":function($event){_vm.cancelEdit(scope.$index)}}})],1):_c('span',[_c('el-button',{attrs:{"type":"text","size":"small"},on:{"click":function($event){_vm.editCollaborator(scope.$index)}}},[_vm._v("Edit")]),_vm._v(" "),(scope.row.id != null)?_c('el-button',{attrs:{"type":"text","size":"small","icon":"el-icon-delete"},on:{"click":function($event){_vm.removeCollaborator(scope.$index)}}}):_c('el-button',{attrs:{"type":"text","size":"small","icon":"el-icon-loading"}})],1)]]}}])}):_vm._e(),_vm._v(" "),_c('template',{attrs:{"slot":"empty"},slot:"empty"})],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 563:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LicenseRenderer_vue__ = __webpack_require__(569);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_47672ee6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LicenseRenderer_vue__ = __webpack_require__(642);
function injectStyle (ssrContext) {
  __webpack_require__(567)
}
var normalizeComponent = __webpack_require__(7)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-47672ee6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LicenseRenderer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_47672ee6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LicenseRenderer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 567:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(568);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(512)("ea6d3efa", content, true);

/***/ }),

/***/ 568:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(511)(true);
// imports


// module
exports.push([module.i, ".license-renderer[data-v-47672ee6]{margin-bottom:48px}.license-renderer__common-license-components[data-v-47672ee6]{margin-top:8px;margin-bottom:8px}", "", {"version":3,"sources":["/app/src/components/Licenses/CommonLicenseComponents/LicenseRenderer.vue"],"names":[],"mappings":"AAoHA,mCACE,kBAAoB,CACrB,AACD,8DACE,eAAgB,AAChB,iBAAmB,CACpB","file":"LicenseRenderer.vue","sourcesContent":["/* Transition\n-------------------------- */\n/* Colors\n-------------------------- */\n/* Font\n-------------------------- */\n/* Element Chalk Variables */\n/* Transition\n-------------------------- */\n/* Colors\n-------------------------- */\n/* 53a8ff */\n/* 66b1ff */\n/* 79bbff */\n/* 8cc5ff */\n/* a0cfff */\n/* b3d8ff */\n/* c6e2ff */\n/* d9ecff */\n/* ecf5ff */\n/* Link\n-------------------------- */\n/* Background\n-------------------------- */\n/* Border\n-------------------------- */\n/* Box-shadow\n-------------------------- */\n/* Fill\n-------------------------- */\n/* Font\n-------------------------- */\n/* Size\n-------------------------- */\n/* z-index\n-------------------------- */\n/* Disable base\n-------------------------- */\n/* Icon\n-------------------------- */\n/* Checkbox\n-------------------------- */\n/* Radio\n-------------------------- */\n/* Select\n-------------------------- */\n/* Alert\n-------------------------- */\n/* Message Box\n-------------------------- */\n/* Message\n-------------------------- */\n/* Notification\n-------------------------- */\n/* Input\n-------------------------- */\n/* Cascader\n-------------------------- */\n/* Group\n-------------------------- */\n/* Tab\n-------------------------- */\n/* Button\n-------------------------- */\n/* cascader\n-------------------------- */\n/* Switch\n-------------------------- */\n/* Dialog\n-------------------------- */\n/* Table\n-------------------------- */\n/* Pagination\n-------------------------- */\n/* Popover\n-------------------------- */\n/* Tooltip\n-------------------------- */\n/* Tag\n-------------------------- */\n/* Tree\n-------------------------- */\n/* Dropdown\n-------------------------- */\n/* Badge\n-------------------------- */\n/* Card\n--------------------------*/\n/* Slider\n--------------------------*/\n/* Steps\n--------------------------*/\n/* Menu\n--------------------------*/\n/* Rate\n--------------------------*/\n/* DatePicker\n--------------------------*/\n/* Loading\n--------------------------*/\n/* Scrollbar\n--------------------------*/\n/* Carousel\n--------------------------*/\n/* Collapse\n--------------------------*/\n/* Transfer\n--------------------------*/\n/* Header\n  --------------------------*/\n/* Footer\n--------------------------*/\n/* Main\n--------------------------*/\n/* Break-point\n--------------------------*/\n.license-renderer[data-v-47672ee6] {\n  margin-bottom: 48px;\n}\n.license-renderer__common-license-components[data-v-47672ee6] {\n  margin-top: 8px;\n  margin-bottom: 8px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 569:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0____ = __webpack_require__(570);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    CommonLicenseComponents: __WEBPACK_IMPORTED_MODULE_0____["a" /* default */]
  },
  props: {
    licenseName: {
      type: String,
      required: true
    },
    form: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      thisComponent: this,
      componentReference: {},
      licenseRendererHideFlag: {}
    };
  },

  computed: {
    agreement: function agreement() {
      return this.$store.state.agreement;
    },
    license: function license() {
      return this.agreement.specification[this.licenseName] || null;
    },
    licenseSpecification: function licenseSpecification() {
      var _this = this;

      if (!this.license) return null;

      return this.license.sequence.map(function (licenseItemName) {
        var agreementItem = _this.agreement.action[licenseItemName] || _this.agreement.license[licenseItemName] || null;

        if (agreementItem) agreementItem.id = licenseItemName;
        return agreementItem;
      }).filter(function (item) {
        return item != null;
      });
    }
  },
  methods: {
    addReference: function addReference(name, vm) {
      this.$set(this.componentReference, name, vm);
    },
    hideLicenseRenderer: function hideLicenseRenderer(specificationId, shouldHide) {
      this.$set(this.licenseRendererHideFlag, specificationId, shouldHide);
    }
  }
});

/***/ }),

/***/ 570:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(573);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9690b598_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(641);
function injectStyle (ssrContext) {
  __webpack_require__(571)
}
var normalizeComponent = __webpack_require__(7)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9690b598_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 571:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(572);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(512)("a47651e2", content, true);

/***/ }),

/***/ 572:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(511)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"index.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 573:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__LicenseAction__ = __webpack_require__(574);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__LicenseContent__ = __webpack_require__(579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LicenseComponent__ = __webpack_require__(584);
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    LicenseAction: __WEBPACK_IMPORTED_MODULE_0__LicenseAction__["a" /* default */],
    LicenseContent: __WEBPACK_IMPORTED_MODULE_1__LicenseContent__["a" /* default */],
    LicenseComponent: __WEBPACK_IMPORTED_MODULE_2__LicenseComponent__["a" /* default */]
  },
  props: {
    licenseRendererVm: {
      type: Object,
      required: true
    },
    licenseWrapper: {
      type: Object
    },
    licenseItem: {
      type: Object
    },
    value: {}
  },
  computed: {
    componentType: function componentType() {
      var licenseItem = this.licenseItem || {};
      var itemType = licenseItem.itemType;

      switch (itemType) {
        case 'action':
          return __WEBPACK_IMPORTED_MODULE_0__LicenseAction__["a" /* default */];
        case 'content':
          return __WEBPACK_IMPORTED_MODULE_1__LicenseContent__["a" /* default */];
        case 'component':
          return __WEBPACK_IMPORTED_MODULE_2__LicenseComponent__["a" /* default */];
        default:
          return licenseItem.component || 'div';
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      _this.component = _this.$refs.component;
    });
  }
});

/***/ }),

/***/ 574:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LicenseAction_vue__ = __webpack_require__(577);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_015b4199_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LicenseAction_vue__ = __webpack_require__(578);
function injectStyle (ssrContext) {
  __webpack_require__(575)
}
var normalizeComponent = __webpack_require__(7)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LicenseAction_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_015b4199_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LicenseAction_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 575:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(576);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(512)("070550a5", content, true);

/***/ }),

/***/ 576:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(511)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"LicenseAction.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 577:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  inheritAttrs: false,
  name: 'LicenseAction',
  props: {
    licenseWrapper: {
      type: Object,
      required: true
    },
    licenseItem: {
      type: Object,
      required: true
    },
    value: {}
  },
  computed: {
    itemType: function itemType() {
      return this.licenseItem.itemType;
    },
    itemHTML: function itemHTML() {
      return this.licenseItem.itemHTML;
    },
    itemFormName: function itemFormName() {
      return this.licenseWrapper.itemFormName;
    },
    inputType: function inputType() {
      return this.licenseItem.itemAction.inputType || 'checkbox';
    },
    inputValue: function inputValue() {
      return this.licenseItem.itemAction.inputValue != null ? this.licenseItem.itemAction.inputValue : true;
    },
    inputValueDeselect: function inputValueDeselect() {
      return this.licenseItem.itemAction.inputValueDeselect != null ? this.licenseItem.itemAction.inputValueDeselect : false;
    },
    componentValue: function componentValue() {
      switch (this.inputType) {
        case 'radio':
          {
            return this.value;
          }
        case 'checkbox':
        default:
          {
            return this.value === this.inputValue;
          }
      }
    }
  },
  methods: {
    updateValue: function updateValue(newValue) {
      var updatedValue = newValue ? this.inputValue : this.inputValueDeselect;
      this.$emit('input', [this.itemFormName, updatedValue]);
    }
  }
});

/***/ }),

/***/ 578:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c(("el-" + _vm.inputType),_vm._b({tag:"component",staticClass:"license-action__checkbox",attrs:{"value":_vm.componentValue,"label":_vm.inputValue},on:{"input":_vm.updateValue}},'component',_vm.$attrs,false),[_c('div',{staticStyle:{"display":"inline","line-height":"1.25"},domProps:{"innerHTML":_vm._s(_vm.itemHTML)}})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 579:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LicenseContent_vue__ = __webpack_require__(582);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_91d53fb4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LicenseContent_vue__ = __webpack_require__(583);
function injectStyle (ssrContext) {
  __webpack_require__(580)
}
var normalizeComponent = __webpack_require__(7)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LicenseContent_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_91d53fb4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LicenseContent_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 580:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(581);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(512)("d86170ba", content, true);

/***/ }),

/***/ 581:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(511)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"LicenseContent.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 582:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'LicenseAction',
  props: {
    licenseItem: {
      type: Object,
      required: true
    }
  }
});

/***/ }),

/***/ 583:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{domProps:{"innerHTML":_vm._s(_vm.licenseItem.itemHTML)}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 584:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LicenseComponent_vue__ = __webpack_require__(587);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0147552c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LicenseComponent_vue__ = __webpack_require__(640);
function injectStyle (ssrContext) {
  __webpack_require__(585)
}
var normalizeComponent = __webpack_require__(7)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LicenseComponent_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0147552c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LicenseComponent_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 585:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(586);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(512)("5e969d66", content, true);

/***/ }),

/***/ 586:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(511)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"LicenseComponent.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 587:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_camelCase__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_camelCase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_camelCase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AppSpecificLicenseComponent_AppYourFilm__ = __webpack_require__(588);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AppSpecificLicenseComponent_AppYourDetails__ = __webpack_require__(596);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AppSpecificLicenseComponent_AppAdditionalAgreements__ = __webpack_require__(599);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__AppSpecificLicenseComponent_AppAdditionalAgreementsFastTrack__ = __webpack_require__(608);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__AppSpecificLicenseComponent_AppYourLicenseRenewalMedia__ = __webpack_require__(616);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__AppSpecificLicenseComponent_AppYourLicenseRenewalLabs__ = __webpack_require__(624);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__AppSpecificLicenseComponent_AppyourLicenseRenewalMonetization__ = __webpack_require__(632);
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'LicenseAction',
  components: {
    AppYourFilm: __WEBPACK_IMPORTED_MODULE_1__AppSpecificLicenseComponent_AppYourFilm__["a" /* default */],
    AppYourDetails: __WEBPACK_IMPORTED_MODULE_2__AppSpecificLicenseComponent_AppYourDetails__["a" /* default */],
    AppAdditionalAgreements: __WEBPACK_IMPORTED_MODULE_3__AppSpecificLicenseComponent_AppAdditionalAgreements__["a" /* default */],
    AppAdditionalAgreementsFastTrack: __WEBPACK_IMPORTED_MODULE_4__AppSpecificLicenseComponent_AppAdditionalAgreementsFastTrack__["a" /* default */],
    AppYourLicenseRenewalLabs: __WEBPACK_IMPORTED_MODULE_6__AppSpecificLicenseComponent_AppYourLicenseRenewalLabs__["a" /* default */],
    AppYourLicenseRenewalMedia: __WEBPACK_IMPORTED_MODULE_5__AppSpecificLicenseComponent_AppYourLicenseRenewalMedia__["a" /* default */],
    AppYourLicenseRenewalMonetization: __WEBPACK_IMPORTED_MODULE_7__AppSpecificLicenseComponent_AppyourLicenseRenewalMonetization__["a" /* default */]
  },
  props: {
    licenseRendererVm: {
      type: Object,
      required: true
    },
    licenseWrapper: {
      type: Object,
      required: true
    },
    licenseItem: {
      type: Object,
      required: true
    },
    value: {}
  },
  computed: {
    itemType: function itemType() {
      return this.licenseItem.itemType;
    },
    itemFormName: function itemFormName() {
      return this.licenseWrapper.itemFormName;
    },
    componentName: function componentName() {
      var componentName = this.licenseItem.itemComponent.componentName || '';
      var camelledName = __WEBPACK_IMPORTED_MODULE_0_lodash_camelCase___default()(componentName);
      var pascalledName = camelledName.charAt(0).toUpperCase() + camelledName.slice(1);
      return pascalledName;
    },
    component: function component() {
      return this.$options.components[this.componentName];
    }
  },
  methods: {
    updateValue: function updateValue(newValue) {
      this.$emit('input', [this.itemFormName, newValue]);
    }
  },
  mounted: function mounted() {
    var isRequestedComponentRegistered = !!this.component;

    if (!isRequestedComponentRegistered) {
      /* eslint no-console: 0 */
      console.error('The requested component is not available. Make sure creator is running on the latest version.');
    }
  }
});

/***/ }),

/***/ 588:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppYourFilm_vue__ = __webpack_require__(589);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d19907a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppYourFilm_vue__ = __webpack_require__(595);
var normalizeComponent = __webpack_require__(7)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppYourFilm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d19907a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppYourFilm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 589:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Licenses_Others_FilmsForm__ = __webpack_require__(590);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  inheritAttrs: false,
  components: {
    FilmsForm: __WEBPACK_IMPORTED_MODULE_0__components_Licenses_Others_FilmsForm__["a" /* default */]
  },
  props: {
    licenseRendererVm: {
      type: Object,
      required: true
    },
    value: {
      type: Array,
      required: true
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      _this.licenseRendererVm.addReference('formFilms', _this.$refs.formFilms);
    });
  }
});

/***/ }),

/***/ 590:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FilmsForm_vue__ = __webpack_require__(593);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d84bd72_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FilmsForm_vue__ = __webpack_require__(594);
function injectStyle (ssrContext) {
  __webpack_require__(591)
}
var normalizeComponent = __webpack_require__(7)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FilmsForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d84bd72_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FilmsForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 591:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(592);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(512)("3f7003e4", content, true);

/***/ }),

/***/ 592:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(511)(true);
// imports


// module
exports.push([module.i, ".fla--fast-track__films .el-tabs.el-tabs--top .el-tabs__header{display:none}.fla--fast-track__films .el-tabs.el-tabs--top.multiple .el-tabs__header{display:block}.add-more-contributor-button{opacity:.9;margin-bottom:22px;text-align:right}.el-form-item__label{position:relative;z-index:1}.film-form__collaborator--director .collaborator-table.has-actions .el-table__row:first-child:last-child td:last-child{cursor:not-allowed}.film-form__collaborator--director .collaborator-table.has-actions .el-table__row:first-child:last-child td:last-child .el-button{cursor:not-allowed;color:#d3d3d3}.film-form__collaborator{-webkit-transition:padding .5s,margin .5s,background-color .5s;transition:padding .5s,margin .5s,background-color .5s;border:1px solid transparent}.film-form__collaborator .collaborator-table{-webkit-box-shadow:none;box-shadow:none}.film-form__collaborator.has-contributor-option{padding:22px;padding-bottom:0;margin-bottom:0;border-left:1px solid rgba(0,0,0,.05);border-right:1px solid rgba(0,0,0,.05)}.film-form__collaborator.has-contributor-option:nth-of-type(2){border-top:1px solid rgba(0,0,0,.05);border-top-left-radius:4px;border-top-right-radius:4px}.film-form__collaborator.has-contributor-option:nth-last-of-type(2){padding-bottom:22px;border-bottom:1px solid rgba(0,0,0,.05);margin-bottom:22px;border-bottom-right-radius:4px;border-bottom-left-radius:4px}@-webkit-keyframes fadeInScrollTrack{0%{overflow-x:hidden}to{overflow-x:auto}}@keyframes fadeInScrollTrack{0%{overflow-x:hidden}to{overflow-x:auto}}.film-form__collaborator.has-contributor-option .el-table__body-wrapper{-webkit-animation-name:fadeInScrollTrack;animation-name:fadeInScrollTrack;-webkit-animation-duration:2s;animation-duration:2s;-webkit-animation-timing-function:steps-end;animation-timing-function:steps-end}.film-form__collaborator.has-contributor-option,.film-form__collaborator.has-contributor-option .collaborator-table.has-actions .el-table__row td:last-child{background-color:#f9f9f9}.film-form__collaborator.has-contributor-option .collaborator-table .el-table,.film-form__collaborator.has-contributor-option .collaborator-table .el-table tr{background-color:transparent}.collaborator-table .el-table:before{display:none}.collaborator-table .el-table__row td{border-bottom:0}.collaborator-table .el-table__row td:first-child .cell{padding-left:0}.collaborator-table .el-table__row td:last-child .cell{padding-right:0}", "", {"version":3,"sources":["/app/src/components/Licenses/Others/FilmsForm.vue"],"names":[],"mappings":"AAoHA,+DACE,YAAc,CACf,AACD,wEACE,aAAe,CAChB,AACD,6BACE,WAAa,AACb,mBAAoB,AACpB,gBAAkB,CACnB,AACD,qBACE,kBAAmB,AACnB,SAAW,CACZ,AACD,uHACE,kBAAoB,CACrB,AACD,kIACI,mBAAoB,AACpB,aAAiB,CACpB,AACD,yBACE,+DAAqE,AACrE,uDAA6D,AAC7D,4BAA8B,CAC/B,AACD,6CACI,wBAAyB,AACjB,eAAiB,CAC5B,AACD,gDACE,aAAc,AACd,iBAAkB,AAClB,gBAAiB,AACjB,sCAA2C,AAC3C,sCAA4C,CAC7C,AACD,+DACI,qCAA0C,AAC1C,2BAA4B,AAC5B,2BAA6B,CAChC,AACD,oEACI,oBAAqB,AACrB,wCAA6C,AAC7C,mBAAoB,AACpB,+BAAgC,AAChC,6BAA+B,CAClC,AACD,qCACA,GACI,iBAAmB,CACtB,AACD,GACI,eAAiB,CACpB,CACA,AACD,6BACA,GACI,iBAAmB,CACtB,AACD,GACI,eAAiB,CACpB,CACA,AACD,wEACI,yCAA0C,AAClC,iCAAkC,AAC1C,8BAA+B,AACvB,sBAAuB,AAC/B,4CAA6C,AACrC,mCAAqC,CAChD,AACD,6JAEI,wBAA0B,CAC7B,AACD,+JAEI,4BAA8B,CACjC,AACD,qCACE,YAAc,CACf,AACD,sCACE,eAAiB,CAClB,AACD,wDACE,cAAgB,CACjB,AACD,uDACE,eAAiB,CAClB","file":"FilmsForm.vue","sourcesContent":["/* Transition\n-------------------------- */\n/* Colors\n-------------------------- */\n/* Font\n-------------------------- */\n/* Element Chalk Variables */\n/* Transition\n-------------------------- */\n/* Colors\n-------------------------- */\n/* 53a8ff */\n/* 66b1ff */\n/* 79bbff */\n/* 8cc5ff */\n/* a0cfff */\n/* b3d8ff */\n/* c6e2ff */\n/* d9ecff */\n/* ecf5ff */\n/* Link\n-------------------------- */\n/* Background\n-------------------------- */\n/* Border\n-------------------------- */\n/* Box-shadow\n-------------------------- */\n/* Fill\n-------------------------- */\n/* Font\n-------------------------- */\n/* Size\n-------------------------- */\n/* z-index\n-------------------------- */\n/* Disable base\n-------------------------- */\n/* Icon\n-------------------------- */\n/* Checkbox\n-------------------------- */\n/* Radio\n-------------------------- */\n/* Select\n-------------------------- */\n/* Alert\n-------------------------- */\n/* Message Box\n-------------------------- */\n/* Message\n-------------------------- */\n/* Notification\n-------------------------- */\n/* Input\n-------------------------- */\n/* Cascader\n-------------------------- */\n/* Group\n-------------------------- */\n/* Tab\n-------------------------- */\n/* Button\n-------------------------- */\n/* cascader\n-------------------------- */\n/* Switch\n-------------------------- */\n/* Dialog\n-------------------------- */\n/* Table\n-------------------------- */\n/* Pagination\n-------------------------- */\n/* Popover\n-------------------------- */\n/* Tooltip\n-------------------------- */\n/* Tag\n-------------------------- */\n/* Tree\n-------------------------- */\n/* Dropdown\n-------------------------- */\n/* Badge\n-------------------------- */\n/* Card\n--------------------------*/\n/* Slider\n--------------------------*/\n/* Steps\n--------------------------*/\n/* Menu\n--------------------------*/\n/* Rate\n--------------------------*/\n/* DatePicker\n--------------------------*/\n/* Loading\n--------------------------*/\n/* Scrollbar\n--------------------------*/\n/* Carousel\n--------------------------*/\n/* Collapse\n--------------------------*/\n/* Transfer\n--------------------------*/\n/* Header\n  --------------------------*/\n/* Footer\n--------------------------*/\n/* Main\n--------------------------*/\n/* Break-point\n--------------------------*/\n.fla--fast-track__films .el-tabs.el-tabs--top .el-tabs__header {\n  display: none;\n}\n.fla--fast-track__films .el-tabs.el-tabs--top.multiple .el-tabs__header {\n  display: block;\n}\n.add-more-contributor-button {\n  opacity: 0.9;\n  margin-bottom: 22px;\n  text-align: right;\n}\n.el-form-item__label {\n  position: relative;\n  z-index: 1;\n}\n.film-form__collaborator--director .collaborator-table.has-actions .el-table__row:first-child:last-child td:last-child {\n  cursor: not-allowed;\n}\n.film-form__collaborator--director .collaborator-table.has-actions .el-table__row:first-child:last-child td:last-child .el-button {\n    cursor: not-allowed;\n    color: lightgray;\n}\n.film-form__collaborator {\n  -webkit-transition: padding 0.5s, margin 0.5s, background-color 0.5s;\n  transition: padding 0.5s, margin 0.5s, background-color 0.5s;\n  border: 1px solid transparent;\n}\n.film-form__collaborator .collaborator-table {\n    -webkit-box-shadow: none;\n            box-shadow: none;\n}\n.film-form__collaborator.has-contributor-option {\n  padding: 22px;\n  padding-bottom: 0;\n  margin-bottom: 0;\n  border-left: 1px solid rgba(0, 0, 0, 0.05);\n  border-right: 1px solid rgba(0, 0, 0, 0.05);\n}\n.film-form__collaborator.has-contributor-option:nth-of-type(2) {\n    border-top: 1px solid rgba(0, 0, 0, 0.05);\n    border-top-left-radius: 4px;\n    border-top-right-radius: 4px;\n}\n.film-form__collaborator.has-contributor-option:nth-last-of-type(2) {\n    padding-bottom: 22px;\n    border-bottom: 1px solid rgba(0, 0, 0, 0.05);\n    margin-bottom: 22px;\n    border-bottom-right-radius: 4px;\n    border-bottom-left-radius: 4px;\n}\n@-webkit-keyframes fadeInScrollTrack {\n0% {\n    overflow-x: hidden;\n}\n100% {\n    overflow-x: auto;\n}\n}\n@keyframes fadeInScrollTrack {\n0% {\n    overflow-x: hidden;\n}\n100% {\n    overflow-x: auto;\n}\n}\n.film-form__collaborator.has-contributor-option .el-table__body-wrapper {\n    -webkit-animation-name: fadeInScrollTrack;\n            animation-name: fadeInScrollTrack;\n    -webkit-animation-duration: 2s;\n            animation-duration: 2s;\n    -webkit-animation-timing-function: steps-end;\n            animation-timing-function: steps-end;\n}\n.film-form__collaborator.has-contributor-option,\n  .film-form__collaborator.has-contributor-option .collaborator-table.has-actions .el-table__row td:last-child {\n    background-color: #f9f9f9;\n}\n.film-form__collaborator.has-contributor-option .collaborator-table .el-table,\n  .film-form__collaborator.has-contributor-option .collaborator-table .el-table tr {\n    background-color: transparent;\n}\n.collaborator-table .el-table::before {\n  display: none;\n}\n.collaborator-table .el-table__row td {\n  border-bottom: 0;\n}\n.collaborator-table .el-table__row td:first-child .cell {\n  padding-left: 0;\n}\n.collaborator-table .el-table__row td:last-child .cell {\n  padding-right: 0;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 593:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_selectorDataMaker__ = __webpack_require__(530);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_data_countries__ = __webpack_require__(531);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_formValidationMixin__ = __webpack_require__(532);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Submission_steps_CollaboratorDetails_CollaboratorItem_CollaboratorTable__ = __webpack_require__(538);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Libraries and static data


// Components



// TODO: Need to extract this function out so that collaborator details can make use of this implementation
var ERROR = {
  IS_EMPTY: new Error('This field cannot be empty'),
  NO_FIRST_NAME: new Error('First name is required'),
  NO_LAST_NAME: new Error('Last name is required'),
  NO_ROLE: new Error('Contributor\'s role is required'),
  NO_EMAIL: new Error('Email is required'),
  INVALID_EMAIL: new Error('Email is not valid')
};
var hasValidEmail = function hasValidEmail(emailString) {
  return (emailString || '').split('@').length === 2;
};

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_formValidationMixin__["a" /* default */]],
  components: {
    CollaboratorTable: __WEBPACK_IMPORTED_MODULE_4__components_Submission_steps_CollaboratorDetails_CollaboratorItem_CollaboratorTable__["a" /* default */]
  },
  props: {
    value: {
      type: Array,
      required: true
    }
  },
  data: function data() {
    return {
      tabIndex: 1,
      fastTrackTabName: '1',
      films: this.value
    };
  },


  computed: {
    showContributorOption: function showContributorOption() {
      // Show contributor option only when there are more than 1 collaborator.
      // This case will happen when there are > 1 director or at least one contributor
      return this.films.map(function (film) {
        return film.directors.length > 1 || film.contributors.length > 0;
      });
    }
  },

  created: function created() {
    this.countries = [{
      label: 'Type to add new country',
      options: __WEBPACK_IMPORTED_MODULE_1__utils_selectorDataMaker__["a" /* default */].make(__WEBPACK_IMPORTED_MODULE_2__assets_data_countries__["a" /* default */])
    }];
  },


  filters: {
    unwrap: function unwrap(value) {
      return value ? value.split(',') : [];
    }
  },

  methods: {
    addTab: function addTab() {
      this.$_addTab();
    },
    removeTab: function removeTab(targetName) {
      var _this = this;

      // Find the related film to generate film name
      var filmIndex = this.films.findIndex(function (film) {
        return film.name === targetName;
      });
      var filmToBeDeleted = this.films[filmIndex];
      var filmTitle = filmToBeDeleted && filmToBeDeleted.title ? '' + filmToBeDeleted.title : 'Film ' + (filmIndex + 1);

      // Prompt user to for confirmation
      this.$confirm('Are you sure you want to delete "' + filmTitle + '"?', 'Delete film?', {
        confirmButtonText: 'Delete',
        type: 'warning'
      }).then(function () {
        _this.$_removeTab(targetName);
      }).catch(function () {});
    },


    // Component form methods
    $_updateSelectorData: function $_updateSelectorData(value, filmObject, prop) {
      this.$set(filmObject, prop, value.join(','));
    },


    // Tabs manipulation
    $_addTab: function $_addTab() {
      var newTabName = '' + (this.tabIndex += 1);
      this.films.push({
        title: '',
        name: newTabName,
        directors: [{
          editable: true,
          role: 'director'
        }],
        contributors: []
      });
      this.fastTrackTabName = newTabName;
    },
    $_removeTab: function $_removeTab(targetName) {
      var tabs = this.films;
      var activeName = this.fastTrackTabName;

      // Prepare to switch to next tab
      if (activeName === targetName) {
        tabs.forEach(function (tab, index) {
          if (tab.name === targetName) {
            var nextTab = tabs[index + 1] || tabs[index - 1];
            if (nextTab) {
              activeName = nextTab.name;
            }
          }
        });
      }
      this.$_switchTab(activeName);

      // Remove the tab and its data
      this.films = tabs.filter(function (tab) {
        return tab.name !== targetName;
      });
      this.$emit('input', this.films);
    },
    $_switchTab: function $_switchTab(targetName) {
      this.fastTrackTabName = targetName;
    },


    // Collaborator update methods
    $_collaboratorTable_addNewDirector: function $_collaboratorTable_addNewDirector(filmObject) {
      filmObject.directors.push({
        editable: true,
        role: 'director'
      });
    },
    $_collaboratorTable_addNewContributor: function $_collaboratorTable_addNewContributor(filmObject) {
      filmObject.contributors.push({
        editable: true
      });
    },
    $_collaboratorTable_removeFn: function $_collaboratorTable_removeFn(humanId, humans) {
      var _this2 = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        if (humans.length > 1) {
          return resolve();
        } else {
          _this2.$notify.info({
            title: 'Info',
            message: 'At least 1 director is required per film'
          });
          return reject();
        }
      });
    },


    // TODO: Need to extract this function out so that collaborator details can make use of this implementation
    $_contributorValidator: function $_contributorValidator(rule, contributors, callback) {
      if (rule.required && contributors.length < 1) {
        return callback(new Error('Please add in at least 1 row'));
      }

      var error = void 0; // undefined
      contributors.every(function (contributor) {
        if (!contributor.first_name) {
          error = ERROR.NO_FIRST_NAME;
        } else if (!contributor.last_name) {
          error = ERROR.NO_LAST_NAME;
        } else if (!contributor.role) {
          error = ERROR.NO_ROLE;
        } else if (contributor.role === 'director') {
          if (!contributor.email) {
            error = ERROR.NO_EMAIL;
          } else if (!hasValidEmail(contributor.email)) {
            error = ERROR.INVALID_EMAIL;
          }
        }
        // If no error, return true and continue next checking
        return !error;
      });

      if (error) this.$_switchTab(rule.tabName);
      // If all field are valid, error willl be undefined
      return callback(error);
    },
    $_isEmptyValidator: function $_isEmptyValidator(rule, value, callback) {
      var trimmedValue = (value || '').trim();
      if (!trimmedValue) {
        this.$_switchTab(rule.tabName);
        callback(ERROR.IS_EMPTY);
      }
      callback();
    }
  }
});

/***/ }),

/***/ 594:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fla--fast-track__films"},[_c('el-tabs',{class:(_vm.films.length > 1) ? 'multiple' : '',attrs:{"closable":_vm.films.length > 1,"type":"card"},on:{"tab-remove":_vm.removeTab},model:{value:(_vm.fastTrackTabName),callback:function ($$v) {_vm.fastTrackTabName=$$v},expression:"fastTrackTabName"}},_vm._l((_vm.films),function(item,index){return _c('el-tab-pane',{key:index,attrs:{"label":item.title || 'Film ' + (index + 1),"name":item.name}},[_c('el-form',{ref:"form",refInFor:true,attrs:{"model":_vm.films[index]}},[_c('el-form-item',{attrs:{"label":"Film title","prop":"title","rules":{
            required: true, validator: _vm.$_isEmptyValidator, trigger: 'blur', tabName: _vm.films[index].name,
          }}},[_c('el-input',{model:{value:(_vm.films[index].title),callback:function ($$v) {_vm.$set(_vm.films[index], "title", $$v)},expression:"films[index].title"}})],1),_vm._v(" "),_c('el-form-item',{staticClass:"film-form__collaborator film-form__collaborator--director",class:_vm.showContributorOption[index] ? 'has-contributor-option' : '',attrs:{"label":"Director","prop":"directors","rules":{
            required: true, validator: _vm.$_contributorValidator, trigger: 'editing', tabName: _vm.films[index].name,
          }}},[(_vm.showContributorOption[index])?_c('span',{attrs:{"slot":"label"},slot:"label"},[_vm._v("\n            Director"),(_vm.films[index].directors.length > 1)?_c('span',[_vm._v("s")]):_vm._e(),_vm._v("\n             \n            "),_c('el-button',{attrs:{"icon":"el-icon-circle-plus","type":"text"},on:{"click":function($event){_vm.$_collaboratorTable_addNewDirector(_vm.films[index])}}},[_vm._v("Add")])],1):_vm._e(),_vm._v(" "),_c('CollaboratorTable',{class:_vm.showContributorOption[index] ? 'has-actions' : '',attrs:{"defaultRole":"director","showAction":_vm.showContributorOption[index],"isTemporary":true,"showHeader":false,"removeFn":_vm.$_collaboratorTable_removeFn},model:{value:(_vm.films[index].directors),callback:function ($$v) {_vm.$set(_vm.films[index], "directors", $$v)},expression:"films[index].directors"}})],1),_vm._v(" "),(_vm.showContributorOption[index])?_c('el-form-item',{staticClass:"film-form__collaborator film-form__collaborator--contributors",class:_vm.showContributorOption[index] ? 'has-contributor-option' : '',attrs:{"prop":"contributors","rules":{
            validator: _vm.$_contributorValidator, trigger: 'editing', tabName: _vm.films[index].name,
          }}},[_c('span',{attrs:{"slot":"label"},slot:"label"},[_vm._v("\n            Contributor"),(_vm.films[index].contributors.length > 1)?_c('span',[_vm._v("s")]):_vm._e(),_vm._v("\n             \n            "),_c('el-button',{attrs:{"icon":"el-icon-circle-plus","type":"text"},on:{"click":function($event){_vm.$_collaboratorTable_addNewContributor(_vm.films[index])}}},[_vm._v("Add")])],1),_vm._v(" "),_c('CollaboratorTable',{staticClass:"has-actions",attrs:{"showAction":true,"isTemporary":true,"showHeader":false},model:{value:(_vm.films[index].contributors),callback:function ($$v) {_vm.$set(_vm.films[index], "contributors", $$v)},expression:"films[index].contributors"}})],1):_vm._e(),_vm._v(" "),(!_vm.showContributorOption[index])?_c('div',{staticClass:"add-more-contributor-button"},[_c('el-button',{attrs:{"size":"small"},on:{"click":function($event){_vm.$_collaboratorTable_addNewContributor(_vm.films[index])}}},[_c('i',{staticClass:"el-icon-edit-outline"}),_vm._v(" Click here to add additional contributors\n          ")])],1):_vm._e(),_vm._v(" "),_c('el-form-item',{attrs:{"prop":"country","label":("Countr" + ((_vm.films[index].country && _vm.films[index].country.split(',').length > 1)
              ? 'ies'
              : 'y')),"rules":{
            required: true, validator: _vm.$_isEmptyValidator, trigger: 'blur', tabName: _vm.films[index].name,
          }}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"value":_vm._f("unwrap")(_vm.films[index].country),"multiple":"","allow-create":"","filterable":"","default-first-option":"","placeholder":"Choose the country"},on:{"change":function($event){_vm.$_updateSelectorData($event, _vm.films[index], 'country')}}},_vm._l((_vm.countries),function(group){return _c('el-option-group',{key:group.label,attrs:{"label":group.label}},_vm._l((group.options),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}))}))],1)],1)],1)}))],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 595:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-card',{staticClass:"fla__card"},[_c('h2',[_vm._v("Film"+_vm._s((_vm.value.length > 1) ? 's' : '')+"\n    "),_c('el-button',{attrs:{"type":"text","icon":"el-icon-circle-plus"},on:{"click":function($event){_vm.$refs.formFilms.addTab()}}},[_vm._v("\n      Add more films\n    ")])],1),_vm._v(" "),_c('FilmsForm',_vm._b({ref:"formFilms",attrs:{"value":_vm.value},on:{"input":function (newValue) { return _vm.$emit('input', newValue); }}},'FilmsForm',_vm.$attrs,false))],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 596:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppYourDetails_vue__ = __webpack_require__(597);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a65e4bc_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppYourDetails_vue__ = __webpack_require__(598);
var normalizeComponent = __webpack_require__(7)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppYourDetails_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a65e4bc_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppYourDetails_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 597:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Profile_FilmmakerDetailsForm__ = __webpack_require__(539);
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  inheritAttrs: false,
  components: {
    FilmmakerDetailsForm: __WEBPACK_IMPORTED_MODULE_0__components_Profile_FilmmakerDetailsForm__["a" /* default */]
  },
  props: {
    licenseRendererVm: {
      type: Object,
      required: true
    },
    value: {
      type: Object,
      required: true
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      _this.licenseRendererVm.addReference('formFilmmakerDetails', _this.$refs.formFilmmakerDetails);
    });
  }
});

/***/ }),

/***/ 598:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-card',{staticClass:"fla__card"},[_c('FilmmakerDetailsForm',_vm._b({ref:"formFilmmakerDetails",attrs:{"value":_vm.value,"showEmail":""},on:{"input":function (newValue) { return _vm.$emit('input', newValue); }}},'FilmmakerDetailsForm',_vm.$attrs,false))],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 599:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppAdditionalAgreements_vue__ = __webpack_require__(600);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34a87a53_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppAdditionalAgreements_vue__ = __webpack_require__(607);
var normalizeComponent = __webpack_require__(7)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppAdditionalAgreements_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34a87a53_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppAdditionalAgreements_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 600:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__libs_webcall__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__classes_agreement__ = __webpack_require__(544);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__AppAdditionalAgreements_AgreementRenderer__ = __webpack_require__(602);


//
//
//
//
//
//
//
//
//
//
//
//

// @ts-check




/**
 * @typedef {Record<string, Record<string, string[]>>} AdditionalAgreementsValue
 */
/**
 * @type {() => AdditionalAgreementsValue}
 */
var AdditionalAgreementsValueType = Object;

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    AgreementRenderer: __WEBPACK_IMPORTED_MODULE_4__AppAdditionalAgreements_AgreementRenderer__["a" /* default */]
  },
  props: {
    licenseRendererVm: {
      type: Object,
      required: true
    },
    value: {
      type: AdditionalAgreementsValueType,
      required: true
    }
  },

  data: function data() {
    return {
      error: null,
      isLoading: false,
      agreements: []
    };
  },
  mounted: function mounted() {
    this.fetchAdditionalAgreements();
  },


  methods: {
    /**
     * @param {{
     *   agreement: Agreement;
     *   payload: Record<string, string[]>
     * }} data
     *
     * @fires #input
     */
    updateValue: function updateValue(data) {
      var agreement = data.agreement,
          payload = data.payload;


      var eventPayload = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.value, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, agreement.code, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, payload)));

      /**
       * @event #input
       * @type {AdditionalAgreementsValue}
       */
      this.$emit('input', eventPayload);
    },


    /**
     * @param {Agreement} agreement
     */
    getAgreementValue: function getAgreementValue(agreement) {
      return this.value[agreement.code] || {};
    },
    fetchAdditionalAgreements: function fetchAdditionalAgreements() {
      var _this = this;

      this.isLoading = true;
      this.error = null;

      __WEBPACK_IMPORTED_MODULE_2__libs_webcall__["a" /* default */].submission.additionalAgreements(this.$route.params.videoId).then(function (_ref) {
        var data = _ref.data;

        _this.agreements = data.agreements.map(function (agreement) {
          return new __WEBPACK_IMPORTED_MODULE_3__classes_agreement__["a" /* Agreement */](agreement);
        });
        _this.isLoading = false;
      }).catch(function (error) {
        _this.error = error;
        _this.isLoading = false;
      });
    }
  }
});

/***/ }),

/***/ 601:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ClauseNode; });
/* unused harmony export ClauseHtmlNode */
/* unused harmony export ClauseTitleNode */
/* unused harmony export ClauseInputNode */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__);






// @ts-check

/**
 * @typedef {import('./clauseRenderNode').ClauseNodeRenderFunction} ClauseNodeRenderFunction
 */

/**
 *
 */
var ClauseNodeComponentStyle = {
  marginTop: '8px',
  marginBottom: '8px'
};

/**
 * @param {import('vue').CreateElement} h
 * @param {string} html
 * @param {import('vue').VNodeData=} options
 * @returns {import('vue').VNode}
 */
var renderHtml = function renderHtml(h, html) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return h('div', __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, options, {
    domProps: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({
      innerHTML: html
    }, options.domProps)
  }));
};

var ClauseNode = function () {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(ClauseNode, null, [{
    key: 'create',
    value: function create(node, clause) {
      switch (node.is) {
        case 'html':
          return new ClauseHtmlNode(node, clause);
        case 'clause_title':
          return new ClauseTitleNode(node, clause);
        case 'input':
          return new ClauseInputNode(node, clause);
        default:
          return new ClauseNode(node, clause);
      }
    }

    /**
     * @param {{ is: string; content: string; }} node
     * @param {import('./agreement').Clause} clause
     */

  }]);

  function ClauseNode(node, clause) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, ClauseNode);

    this.is = node.is;
    this.content = node.content;
    this.parent = clause;
  }

  /**
   * @param {Parameters<ClauseNodeRenderFunction>[0]} h
   * @param {Parameters<ClauseNodeRenderFunction>[1]} context
   * @returns {ReturnType<ClauseNodeRenderFunction>}
   */


  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(ClauseNode, [{
    key: 'render',
    value: function render(h, context) {
      return renderHtml(h, this.content);
    }
  }]);

  return ClauseNode;
}();

var ClauseHtmlNode = function (_ClauseNode) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(ClauseHtmlNode, _ClauseNode);

  function ClauseHtmlNode() {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, ClauseHtmlNode);

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ClauseHtmlNode.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(ClauseHtmlNode)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(ClauseHtmlNode, [{
    key: 'render',

    /**
     * @param {Parameters<ClauseNodeRenderFunction>[0]} h
     * @param {Parameters<ClauseNodeRenderFunction>[1]} context
     * @returns {ReturnType<ClauseNodeRenderFunction>}
     */
    value: function render(h, context) {
      return renderHtml(h, this.content, {
        staticStyle: ClauseNodeComponentStyle
      });
    }
  }]);

  return ClauseHtmlNode;
}(ClauseNode);

/**
 *
 * @param {import('./agreement').Clause} clause
 * @returns {(option: any) => import('./clauseRenderNode').ClauseInputNodeOption}
 */
var createOption = function createOption(clause) {
  return function (option) {
    return {
      label: option.label,
      value: option.value,
      selected: clause.initialValues.includes(option.value)
    };
  };
};

var ClauseTitleNode = function (_ClauseNode2) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(ClauseTitleNode, _ClauseNode2);

  function ClauseTitleNode() {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, ClauseTitleNode);

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ClauseTitleNode.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(ClauseTitleNode)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(ClauseTitleNode, [{
    key: 'render',

    /**
     * @param {Parameters<ClauseNodeRenderFunction>[0]} h
     * @param {Parameters<ClauseNodeRenderFunction>[1]} context
     * @returns {ReturnType<ClauseNodeRenderFunction>}
     */
    value: function render(h, context) {
      return h('h2', null, [this.content, this.parent.isRequired ? null : h('small', [h('span', ' '), '(Optional)'])]);
    }
  }]);

  return ClauseTitleNode;
}(ClauseNode);

/**
 *
 * @param {'radio' | 'checkbox' | 'text'} type
 */
var createWrapUnwrapper = function createWrapUnwrapper(type) {
  var passthrough = function passthrough(x) {
    return x;
  };
  var unwrap = function unwrap(arrayValue) {
    return arrayValue[0];
  };
  var wrap = function wrap(singleValue) {
    return [singleValue];
  };

  switch (type) {
    case 'radio':
      {
        return {
          wrap: wrap,
          unwrap: unwrap
        };
      }
    case 'checkbox':
    default:
      {
        return {
          wrap: passthrough,
          unwrap: passthrough
        };
      }
  }
};

var ClauseInputNode = function (_ClauseNode3) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(ClauseInputNode, _ClauseNode3);

  function ClauseInputNode(node, clause) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, ClauseInputNode);

    var _this3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ClauseInputNode.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(ClauseInputNode)).call(this, node, clause));

    _this3.options = (node.options || []).map(createOption(clause));
    return _this3;
  }

  /**
   * @param {Parameters<ClauseNodeRenderFunction>[0]} h
   * @param {Parameters<ClauseNodeRenderFunction>[1]} context
   * @returns {ReturnType<ClauseNodeRenderFunction>}
   */


  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(ClauseInputNode, [{
    key: 'render',
    value: function render(h, context) {
      var _this4 = this;

      var _createWrapUnwrapper = createWrapUnwrapper(this.parent.type),
          wrap = _createWrapUnwrapper.wrap,
          unwrap = _createWrapUnwrapper.unwrap;

      return h('el-' + this.parent.type + '-group', {
        props: {
          value: unwrap(context.props.value)
        },
        on: {
          /**
           * @param {string | string[]} data if radio, return single string, if checkbox return array of string
           */
          input: function input(data) {
            context.on.input(wrap(data));
          }
        }
      }, this.options.map(function (option) {
        return _this4.renderOption(h, option, context);
      }));
    }

    /**
     * @param {Parameters<ClauseNodeRenderFunction>[0]} h
     * @param {import('./clauseRenderNode').ClauseInputNodeOption} option
     * @param {Parameters<ClauseNodeRenderFunction>[1]} context
     * @returns {import('vue').VNode}
     */

  }, {
    key: 'renderOption',
    value: function renderOption(h, option, context) {
      var children = renderHtml(h, option.label, {
        style: 'display: inline; line-height: 1.25;'
      });

      var optionNode = h('el-' + this.parent.type, {
        props: {
          label: option.value
        }
      }, [children]);

      return h('div', {
        staticStyle: ClauseNodeComponentStyle
      }, [optionNode]);
    }
  }]);

  return ClauseInputNode;
}(ClauseNode);

/***/ }),

/***/ 602:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AgreementRenderer_vue__ = __webpack_require__(605);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_418dc311_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AgreementRenderer_vue__ = __webpack_require__(606);
function injectStyle (ssrContext) {
  __webpack_require__(603)
}
var normalizeComponent = __webpack_require__(7)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-418dc311"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AgreementRenderer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_418dc311_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AgreementRenderer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 603:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(604);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(512)("81245198", content, true);

/***/ }),

/***/ 604:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(511)(true);
// imports


// module
exports.push([module.i, ".license-renderer[data-v-418dc311]{margin-bottom:48px}", "", {"version":3,"sources":["/app/src/components/Licenses/CommonLicenseComponents/AppSpecificLicenseComponent/AppAdditionalAgreements/AgreementRenderer.vue"],"names":[],"mappings":"AACA,mCACE,kBAAoB,CACrB","file":"AgreementRenderer.vue","sourcesContent":["\n.license-renderer[data-v-418dc311] {\n  margin-bottom: 48px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 605:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ClauseRenderer__ = __webpack_require__(545);


//
//
//
//
//
//
//
//
//
//
//
//
//

// @ts-check


/**
 * @type {() => import('@/classes/agreement').Agreement}
 */
var AgreementPropType = Object;

/**
 * @typedef {string[]} ClauseValue
 */
/**
 * @typedef {Record<string, ClauseValue>} ClauseRecordValue
 */
/**
 * @type {() => ClauseRecordValue}
 */
var ValuePropType = Object;

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    ClauseRenderer: __WEBPACK_IMPORTED_MODULE_2__ClauseRenderer__["a" /* default */]
  },
  props: {
    agreement: {
      type: AgreementPropType,
      required: true
    },

    value: {
      type: ValuePropType,
      required: true
    }
  },

  methods: {
    /**
     * @param {import('@/classes/agreement').Clause} clause
     * @return {ClauseValue}
     */
    getClauseValue: function getClauseValue(clause) {
      return this.value[clause.code] || [];
    },


    /**
     * @param {{
     *   clause: import('@/classes/agreement').Clause;
     *   payload: ClauseValue
     * }} data
     *
     * @fires #input
     */
    updateValue: function updateValue(data) {
      var clause = data.clause,
          payload = data.payload;

      /**
       * @event #input
       * @type {ClauseRecordValue}
       */

      this.$emit('input', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.value, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, clause.code, payload)));
    }
  }
});

/***/ }),

/***/ 606:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.agreement.clauses),function(clause){return _c('ClauseRenderer',{key:clause.id,staticClass:"license-renderer",attrs:{"clause":clause,"value":_vm.getClauseValue(clause)},on:{"input":function ($event) { return _vm.updateValue({ clause: clause, payload: $event }); }}})}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 607:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.agreements),function(agreement){return _c('AgreementRenderer',{key:agreement.id,attrs:{"agreement":agreement,"value":_vm.getAgreementValue(agreement)},on:{"input":function ($event) { return _vm.updateValue({ agreement: agreement, payload: $event }); }}})}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 608:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppAdditionalAgreementsFastTrack_vue__ = __webpack_require__(609);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_402bdfec_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppAdditionalAgreementsFastTrack_vue__ = __webpack_require__(615);
var normalizeComponent = __webpack_require__(7)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppAdditionalAgreementsFastTrack_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_402bdfec_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppAdditionalAgreementsFastTrack_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 609:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__libs_webcall__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__classes_agreement__ = __webpack_require__(544);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__AppAdditionalAgreementsFastTrack_FastTrackAgreementRenderer__ = __webpack_require__(610);


//
//
//
//
//
//
//
//
//
//
//
//

// @ts-check




/**
 * @typedef {Record<string, Record<string, string[]>>} AdditionalAgreementsValue
 */
/**
 * @type {() => AdditionalAgreementsValue}
 */
var AdditionalAgreementsValueType = Object;

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    FastTrackAgreementRenderer: __WEBPACK_IMPORTED_MODULE_4__AppAdditionalAgreementsFastTrack_FastTrackAgreementRenderer__["a" /* default */]
  },
  props: {
    licenseRendererVm: {
      type: Object,
      required: true
    },
    value: {
      type: AdditionalAgreementsValueType,
      required: true
    }
  },

  data: function data() {
    return {
      error: null,
      isLoading: false,
      agreements: []
    };
  },
  mounted: function mounted() {
    this.fetchAdditionalAgreements();
  },


  methods: {
    /**
     * @param {{
     *   agreement: Agreement;
     *   payload: Record<string, string[]>
     * }} data
     *
     * @fires #input
     */
    updateValue: function updateValue(data) {
      var agreement = data.agreement,
          payload = data.payload;

      var eventPayload = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.value, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, agreement.code, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, payload)));
      /**
       * @event #input
       * @type {AdditionalAgreementsValue}
       */
      this.$emit('input', eventPayload);
    },
    fetchAdditionalAgreements: function fetchAdditionalAgreements() {
      var _this = this;

      this.isLoading = true;
      this.error = null;

      __WEBPACK_IMPORTED_MODULE_2__libs_webcall__["a" /* default */].submission.fastTrackAdditionalAgreements().then(function (_ref) {
        var data = _ref.data;

        _this.agreements = data.agreements.map(function (agreement) {
          return new __WEBPACK_IMPORTED_MODULE_3__classes_agreement__["a" /* Agreement */](agreement);
        });
        _this.isLoading = false;
      }).catch(function (error) {
        _this.error = error;
        _this.isLoading = false;
      });
    }
  }
});

/***/ }),

/***/ 610:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FastTrackAgreementRenderer_vue__ = __webpack_require__(613);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21415431_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FastTrackAgreementRenderer_vue__ = __webpack_require__(614);
function injectStyle (ssrContext) {
  __webpack_require__(611)
}
var normalizeComponent = __webpack_require__(7)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-21415431"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FastTrackAgreementRenderer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21415431_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FastTrackAgreementRenderer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 611:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(612);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(512)("51ef2755", content, true);

/***/ }),

/***/ 612:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(511)(true);
// imports


// module
exports.push([module.i, ".license-renderer[data-v-21415431]{margin-bottom:48px}", "", {"version":3,"sources":["/app/src/components/Licenses/CommonLicenseComponents/AppSpecificLicenseComponent/AppAdditionalAgreementsFastTrack/FastTrackAgreementRenderer.vue"],"names":[],"mappings":"AACA,mCACE,kBAAoB,CACrB","file":"FastTrackAgreementRenderer.vue","sourcesContent":["\n.license-renderer[data-v-21415431] {\n  margin-bottom: 48px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 613:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AppAdditionalAgreements_ClauseRenderer__ = __webpack_require__(545);


//
//
//
//
//
//
//
//
//
//
//
//
//

// @ts-check


/**
 * @type {() => import('@/classes/agreement').Agreement}
 */
var AgreementPropType = Object;

/**
 * @typedef {string[]} ClauseValue
 */
/**
 * @typedef {Record<string, ClauseValue>} ClauseRecordValue
 */
/**
 * @type {() => ClauseRecordValue}
 */
var ValuePropType = Object;

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    ClauseRenderer: __WEBPACK_IMPORTED_MODULE_2__AppAdditionalAgreements_ClauseRenderer__["a" /* default */]
  },
  props: {
    agreement: {
      type: AgreementPropType,
      required: true
    },

    value: {
      type: ValuePropType,
      required: true
    }
  },

  methods: {
    /**
     * @param {import('@/classes/agreement').Clause} clause
     * @return {ClauseValue}
     */
    getClauseValue: function getClauseValue(clause) {
      if (this.value[this.agreement.code]) {
        return this.value[this.agreement.code][clause.code] || [];
      } else {
        return [];
      }
    },


    /**
     * @param {{
     *   clause: import('@/classes/agreement').Clause;
     *   payload: ClauseValue
     * }} data
     *
     * @fires #input
     */
    updateValue: function updateValue(data) {
      var clause = data.clause,
          payload = data.payload;
      /**
       * @event #input
       * @type {ClauseRecordValue}
       */

      this.$emit('input', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.value[this.agreement.code], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, clause.code, payload)));
    }
  }
});

/***/ }),

/***/ 614:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.agreement.clauses),function(clause){return _c('ClauseRenderer',{key:clause.id,staticClass:"license-renderer",attrs:{"clause":clause,"value":_vm.getClauseValue(clause)},on:{"input":function ($event) { return _vm.updateValue({ clause: clause, payload: $event }); }}})}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 615:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.agreements),function(agreement){return _c('FastTrackAgreementRenderer',{key:agreement.id,attrs:{"agreement":agreement,"value":_vm.value ? _vm.value : {}},on:{"input":function ($event) { return _vm.updateValue({ agreement: agreement, payload: $event }); }}})}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 616:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(617);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_47cc916a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(623);
var normalizeComponent = __webpack_require__(7)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_47cc916a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 617:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__libs_webcall__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MediaSubmissionTable__ = __webpack_require__(618);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var AGREEMENT_FORM_CONSTANT = {
  RIGHTS_MEDIA: {
    MEDIA_ALL: 'MEDIA_ALL',
    MEDIA_EXCLUDE_BROADCAST_TV: 'MEDIA_EXCLUDE_BROADCAST_TV'
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    MediaSubmissionTable: __WEBPACK_IMPORTED_MODULE_4__MediaSubmissionTable__["a" /* default */]
  },
  props: {
    licenseRendererVm: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      showCustomisationForEachFilm: false,
      upgradableLicenseSubmissions: [],
      originalLicenseSubmissions: []
    };
  },

  computed: {
    selectedMediaRights: function selectedMediaRights() {
      return this.licenseRendererVm.form.mediaRights.value;
    }
  },
  watch: {
    selectedMediaRights: function selectedMediaRights(newValue) {
      if (newValue) {
        this.upgradableLicenseSubmissions.forEach(function (submission) {
          submission.rights_media = newValue;
        });
        this.updateValue(this.upgradableLicenseSubmissions);
      }
    },
    showCustomisationForEachFilm: function showCustomisationForEachFilm(newValue) {
      if (!newValue) {
        this.enableMediaRightGlobalRadio();
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.getUpgradableLicense().then(function (upgradableLicenseSubmissions) {
      // Hide mediaRights component if user does not have existing upgradable submission
      if (upgradableLicenseSubmissions.length <= 0) {
        _this.licenseRendererVm.hideLicenseRenderer('mediaRights', true);
        return upgradableLicenseSubmissions;
      }
      // Prepare submission for display
      var processedSubmissions = _this.prefillSubmissionProperties(upgradableLicenseSubmissions, {
        rights_media: AGREEMENT_FORM_CONSTANT.RIGHTS_MEDIA.MEDIA_ALL
      });

      // Initialize UI based on display configuration
      _this.initializeExternalUI(_this.getDisplayConfiguration(processedSubmissions));
      return processedSubmissions;
    }).then(function (submissions) {
      // Update parent and self
      _this.upgradableLicenseSubmissions = submissions;
      _this.updateValue(submissions);
    });
  },

  methods: {
    submissionTableChange: function submissionTableChange(_ref) {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref, 3),
          item = _ref2[0],
          property = _ref2[1],
          value = _ref2[2];

      this.disableMediaRightGlobalRadio();
      this.updateValue(this.upgradableLicenseSubmissions);
    },
    disableMediaRightGlobalRadio: function disableMediaRightGlobalRadio() {
      this.licenseRendererVm.$parent.form.rights_media = '';
    },
    enableMediaRightGlobalRadio: function enableMediaRightGlobalRadio() {
      if (!this.licenseRendererVm.$parent.form.rights_media) {
        this.licenseRendererVm.$parent.form.rights_media = AGREEMENT_FORM_CONSTANT.RIGHTS_MEDIA.MEDIA_ALL;
      }
    },
    getUpgradableLicense: function getUpgradableLicense() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_3__libs_webcall__["a" /* default */].agreement.getUpgradableLicense({
        params: {
          per_page: 999,
          current_page: 0
        }
      }).then(function (_ref3) {
        var data = _ref3.data;

        _this2.originalLicenseSubmissions = data.videos;
        return data.videos;
      });
    },
    prefillSubmissionProperties: function prefillSubmissionProperties(submissions) {
      var prefillOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return submissions.map(function (submission) {
        var prefillObjects = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(prefillOptions).map(function (prefillKey) {
          var prefillValue = prefillOptions[prefillKey];
          var originalValue = submission[prefillKey];
          return [prefillKey, originalValue, prefillValue];
        }).reduce(function (acc, _ref4) {
          var _ref5 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref4, 3),
              prefillKey = _ref5[0],
              originalValue = _ref5[1],
              prefillValue = _ref5[2];

          if (!originalValue) {
            acc[prefillKey] = prefillValue;
          }
          return acc;
        }, {});

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, submission, prefillObjects);
      });
    },


    /**
     * Compute display configuration for the given submissions array
     */
    getDisplayConfiguration: function getDisplayConfiguration(submissions) {
      var displayConfiguration = submissions.reduce(function (collector, submission) {
        /* eslint camelcase: 0 */
        collector.isEveryAll = collector.isEveryAll && submission.rights_media === AGREEMENT_FORM_CONSTANT.RIGHTS_MEDIA.MEDIA_ALL;
        collector.isEveryExclude = collector.isEveryExclude && submission.rights_media === AGREEMENT_FORM_CONSTANT.RIGHTS_MEDIA.MEDIA_EXCLUDE_BROADCAST_TV;
        return collector;
      }, { isEveryAll: true, isEveryExclude: true });

      return displayConfiguration;
    },
    initializeExternalUI: function initializeExternalUI(displayConfiguration) {
      if (displayConfiguration.isEveryAll) {
        this.licenseRendererVm.$parent.form.rights_media = AGREEMENT_FORM_CONSTANT.RIGHTS_MEDIA.MEDIA_ALL;
      } else if (displayConfiguration.isEveryExclude) {
        this.licenseRendererVm.$parent.form.rights_media = AGREEMENT_FORM_CONSTANT.RIGHTS_MEDIA.MEDIA_EXCLUDE_BROADCAST_TV;
      } else {
        this.disableMediaRightGlobalRadio();
        this.showCustomisationForEachFilm = true;
      }
    },
    updateValue: function updateValue(submissionsToBeUpdated) {
      var allSubmissionIdMap = this.originalLicenseSubmissions.reduce(function (acc, submission) {
        acc[submission.id] = submission;
        return acc;
      }, {});

      // Update payload
      submissionsToBeUpdated.forEach(function (submission) {
        allSubmissionIdMap[submission.id] = submission;
      });

      var payload = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(allSubmissionIdMap).map(function (submissionId) {
        return allSubmissionIdMap[submissionId];
      });

      this.$emit('input', payload);
    }
  }
});

/***/ }),

/***/ 618:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MediaSubmissionTable_vue__ = __webpack_require__(621);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0da1ec16_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MediaSubmissionTable_vue__ = __webpack_require__(622);
function injectStyle (ssrContext) {
  __webpack_require__(619)
}
var normalizeComponent = __webpack_require__(7)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MediaSubmissionTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0da1ec16_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MediaSubmissionTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 619:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(620);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(512)("67faf994", content, true);

/***/ }),

/***/ 620:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(511)(true);
// imports


// module
exports.push([module.i, ".submission-table .el-table .cell{word-break:break-word}.el-table td.el-table_1_column_2,.el-table td.el-table_1_column_2 .cell,.el-table td.el-table_1_column_3,.el-table td.el-table_1_column_3 .cell{padding:0}.el-table td.el-table_1_column_2 .cell .el-radio,.el-table td.el-table_1_column_3 .cell .el-radio{height:100%;width:calc(100% - 40px);padding:20px}", "", {"version":3,"sources":["/app/src/components/Licenses/CommonLicenseComponents/AppSpecificLicenseComponent/AppYourLicenseRenewalMedia/MediaSubmissionTable.vue"],"names":[],"mappings":"AACA,kCACE,qBAAuB,CACxB,AAKD,gJAEE,SAAW,CACZ,AACD,kGAEE,YAAa,AACb,wBAAyB,AACzB,YAAc,CACf","file":"MediaSubmissionTable.vue","sourcesContent":["\n.submission-table .el-table .cell {\n  word-break: break-word;\n}\n.el-table td.el-table_1_column_2,\n.el-table td.el-table_1_column_3 {\n  padding: 0;\n}\n.el-table td.el-table_1_column_2 .cell,\n.el-table td.el-table_1_column_3 .cell {\n  padding: 0;\n}\n.el-table td.el-table_1_column_2 .cell .el-radio,\n.el-table td.el-table_1_column_3 .cell .el-radio {\n  height: 100%;\n  width: calc(100% - 40px);\n  padding: 20px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 621:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    submissions: {
      type: Array,
      required: true
    }
  }
});

/***/ }),

/***/ 622:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"submission-table"},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.submissions}},[_c('el-table-column',{attrs:{"type":"expand"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var row = ref.row;
return [_c('p',[_vm._v("Submitted on: "+_vm._s(new Date(row.submission_date).toLocaleString()))]),_vm._v(" "),_c('p',[_vm._v("Description: “"+_vm._s(row.description_long)+"”")]),_vm._v(" "),_c('p',[_vm._v("Film year: "+_vm._s(row.year))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"title","label":"Film Title","min-width":"200px"}}),_vm._v(" "),_c('el-table-column',{attrs:{"fixed":"right","label":"(1)","width":"60px","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var row = ref.row;
var column = ref.column;
var $index = ref.$index;
return [_c('el-radio',{attrs:{"label":"MEDIA_ALL"},on:{"change":function (newValue) { return _vm.$emit('change', [row, 'rights_media', newValue]); }},model:{value:(row.rights_media),callback:function ($$v) {_vm.$set(row, "rights_media", $$v)},expression:"row.rights_media"}},[_vm._v(" ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"fixed":"right","label":"(2)","width":"60px","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var row = ref.row;
var column = ref.column;
var $index = ref.$index;
return [_c('el-radio',{attrs:{"label":"MEDIA_EXCLUDE_BROADCAST_TV"},on:{"change":function (newValue) { return _vm.$emit('change', [row, 'rights_media', newValue]); }},model:{value:(row.rights_media),callback:function ($$v) {_vm.$set(row, "rights_media", $$v)},expression:"row.rights_media"}},[_vm._v(" ")])]}}])})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 623:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.upgradableLicenseSubmissions.length > 0)?_c('div',[_c('div',{staticStyle:{"margin-bottom":"12px"}},[_vm._v("\n    Alternatively, you may also customize media rights for each of your existing films.\n  ")]),_vm._v(" "),_c('el-card',{staticClass:"fla__card"},[_c('h3',[_vm._v("Media Rights")]),_vm._v(" "),_c('MediaSubmissionTable',{attrs:{"submissions":_vm.upgradableLicenseSubmissions},on:{"change":_vm.submissionTableChange}})],1)],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 624:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(625);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d45b154_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(631);
var normalizeComponent = __webpack_require__(7)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d45b154_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 625:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__libs_webcall__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__LabsSubmissionTable__ = __webpack_require__(626);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var AGREEMENT_FORM_CONSTANT = {
  RIGHTS_LABS: {
    LABS_INTERESTED: 'LABS_INTERESTED',
    LABS_EXCLUDED: 'LABS_EXCLUDED'
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    LabsSubmissionTable: __WEBPACK_IMPORTED_MODULE_4__LabsSubmissionTable__["a" /* default */]
  },
  props: {
    licenseRendererVm: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      showCustomisationForEachFilm: false,
      upgradableLicenseSubmissions: [],
      originalLicenseSubmissions: []
    };
  },

  computed: {
    selectedLabsRights: function selectedLabsRights() {
      return this.licenseRendererVm.form.labs.value;
    }
  },
  watch: {
    selectedLabsRights: function selectedLabsRights(newValue) {
      if (newValue) {
        this.upgradableLicenseSubmissions.forEach(function (submission) {
          submission.rights_labs = newValue;
        });
        this.updateValue(this.upgradableLicenseSubmissions);
      }
    },
    showCustomisationForEachFilm: function showCustomisationForEachFilm(newValue) {
      if (!newValue) {
        this.enableLabsGlobalRadio();
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.getUpgradableLicense().then(function (upgradableLicenseSubmissions) {
      // Hide mediaRights component if user does not have existing upgradable submission
      if (upgradableLicenseSubmissions.length <= 0) {
        _this.licenseRendererVm.hideLicenseRenderer('labs', true);
        return upgradableLicenseSubmissions;
      }
      // Prepare submission for display
      var processedSubmissions = _this.prefillSubmissionProperties(upgradableLicenseSubmissions, {
        rights_labs: AGREEMENT_FORM_CONSTANT.RIGHTS_LABS.LABS_INTERESTED
      });

      // Initialize UI based on display configuration
      _this.initializeExternalUI(_this.getDisplayConfiguration(processedSubmissions));
      return processedSubmissions;
    }).then(function (submissions) {
      // Update parent and self
      _this.upgradableLicenseSubmissions = submissions;
      _this.updateValue(submissions);
    });
  },

  methods: {
    submissionTableChange: function submissionTableChange(_ref) {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref, 3),
          item = _ref2[0],
          property = _ref2[1],
          value = _ref2[2];

      this.disableLabsGlobalRadio();
      this.updateValue(this.upgradableLicenseSubmissions);
    },
    disableLabsGlobalRadio: function disableLabsGlobalRadio() {
      this.licenseRendererVm.$parent.form.rights_labs = '';
    },
    enableLabsGlobalRadio: function enableLabsGlobalRadio() {
      if (!this.licenseRendererVm.$parent.form.rights_labs) {
        this.licenseRendererVm.$parent.form.rights_labs = AGREEMENT_FORM_CONSTANT.RIGHTS_LABS.LABS_INTERESTED;
      }
    },
    getUpgradableLicense: function getUpgradableLicense() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_3__libs_webcall__["a" /* default */].agreement.getUpgradableLicense({
        params: {
          per_page: 999,
          current_page: 0
        }
      }).then(function (_ref3) {
        var data = _ref3.data;

        _this2.originalLicenseSubmissions = data.videos;
        return data.videos;
      });
    },
    prefillSubmissionProperties: function prefillSubmissionProperties(submissions) {
      var prefillOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return submissions.map(function (submission) {
        var prefillObjects = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(prefillOptions).map(function (prefillKey) {
          var prefillValue = prefillOptions[prefillKey];
          var originalValue = submission[prefillKey];
          return [prefillKey, originalValue, prefillValue];
        }).reduce(function (acc, _ref4) {
          var _ref5 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref4, 3),
              prefillKey = _ref5[0],
              originalValue = _ref5[1],
              prefillValue = _ref5[2];

          if (!originalValue) {
            acc[prefillKey] = prefillValue;
          }
          return acc;
        }, {});

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, submission, prefillObjects);
      });
    },


    /**
     * Compute display configuration for the given submissions array
     */
    getDisplayConfiguration: function getDisplayConfiguration(submissions) {
      var displayConfiguration = submissions.reduce(function (collector, submission) {
        /* eslint camelcase: 0 */
        collector.isEveryAll = collector.isEveryAll && submission.rights_labs === AGREEMENT_FORM_CONSTANT.RIGHTS_LABS.LABS_INTERESTED;
        collector.isEveryExclude = collector.isEveryExclude && submission.rights_labs === AGREEMENT_FORM_CONSTANT.RIGHTS_LABS.LABS_INTERESTED;
        return collector;
      }, { isEveryAll: true, isEveryExclude: true });

      return displayConfiguration;
    },
    initializeExternalUI: function initializeExternalUI(displayConfiguration) {
      if (displayConfiguration.isEveryAll) {
        this.licenseRendererVm.$parent.form.rights_labs = AGREEMENT_FORM_CONSTANT.RIGHTS_LABS.LABS_INTERESTED;
      } else if (displayConfiguration.isEveryExclude) {
        this.licenseRendererVm.$parent.form.rights_labs = AGREEMENT_FORM_CONSTANT.RIGHTS_LABS.LABS_INTERESTED;
      } else {
        this.disableLabsGlobalRadio();
        this.showCustomisationForEachFilm = true;
      }
    },
    updateValue: function updateValue(submissionsToBeUpdated) {
      var allSubmissionIdMap = this.originalLicenseSubmissions.reduce(function (acc, submission) {
        acc[submission.id] = submission;
        return acc;
      }, {});

      // Update payload
      submissionsToBeUpdated.forEach(function (submission) {
        allSubmissionIdMap[submission.id] = submission;
      });

      var payload = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(allSubmissionIdMap).map(function (submissionId) {
        return allSubmissionIdMap[submissionId];
      });

      this.$emit('input', payload);
    }
  }
});

/***/ }),

/***/ 626:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LabsSubmissionTable_vue__ = __webpack_require__(629);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4fc52240_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LabsSubmissionTable_vue__ = __webpack_require__(630);
function injectStyle (ssrContext) {
  __webpack_require__(627)
}
var normalizeComponent = __webpack_require__(7)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LabsSubmissionTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4fc52240_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LabsSubmissionTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 627:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(628);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(512)("68ad97aa", content, true);

/***/ }),

/***/ 628:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(511)(true);
// imports


// module
exports.push([module.i, ".submission-table .el-table .cell{word-break:break-word}.el-table td.el-table_1_column_2,.el-table td.el-table_1_column_2 .cell,.el-table td.el-table_1_column_3,.el-table td.el-table_1_column_3 .cell{padding:0}.el-table td.el-table_1_column_2 .cell .el-radio,.el-table td.el-table_1_column_3 .cell .el-radio{height:100%;width:calc(100% - 40px);padding:20px}", "", {"version":3,"sources":["/app/src/components/Licenses/CommonLicenseComponents/AppSpecificLicenseComponent/AppYourLicenseRenewalLabs/LabsSubmissionTable.vue"],"names":[],"mappings":"AACA,kCACE,qBAAuB,CACxB,AAKD,gJAEE,SAAW,CACZ,AACD,kGAEE,YAAa,AACb,wBAAyB,AACzB,YAAc,CACf","file":"LabsSubmissionTable.vue","sourcesContent":["\n.submission-table .el-table .cell {\n  word-break: break-word;\n}\n.el-table td.el-table_1_column_2,\n.el-table td.el-table_1_column_3 {\n  padding: 0;\n}\n.el-table td.el-table_1_column_2 .cell,\n.el-table td.el-table_1_column_3 .cell {\n  padding: 0;\n}\n.el-table td.el-table_1_column_2 .cell .el-radio,\n.el-table td.el-table_1_column_3 .cell .el-radio {\n  height: 100%;\n  width: calc(100% - 40px);\n  padding: 20px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 629:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    submissions: {
      type: Array,
      required: true
    }
  }
});

/***/ }),

/***/ 630:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"labs-submission-table"},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.submissions}},[_c('el-table-column',{attrs:{"type":"expand"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var row = ref.row;
return [_c('p',[_vm._v("Submitted on: "+_vm._s(new Date(row.submission_date).toLocaleString()))]),_vm._v(" "),_c('p',[_vm._v("Description: “"+_vm._s(row.description_long)+"”")]),_vm._v(" "),_c('p',[_vm._v("Film year: "+_vm._s(row.year))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"title","label":"Film Title","min-width":"200px"}}),_vm._v(" "),_c('el-table-column',{attrs:{"fixed":"right","label":"(1)","width":"60px","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var row = ref.row;
var column = ref.column;
var $index = ref.$index;
return [_c('el-radio',{attrs:{"label":"LABS_INTERESTED"},on:{"change":function (newValue) { return _vm.$emit('change', [row, 'rights_labs', newValue]); }},model:{value:(row.rights_labs),callback:function ($$v) {_vm.$set(row, "rights_labs", $$v)},expression:"row.rights_labs"}},[_vm._v(" ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"fixed":"right","label":"(2)","width":"60px","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var row = ref.row;
var column = ref.column;
var $index = ref.$index;
return [_c('el-radio',{attrs:{"label":"LABS_EXCLUDED"},on:{"change":function (newValue) { return _vm.$emit('change', [row, 'rights_labs', newValue]); }},model:{value:(row.rights_labs),callback:function ($$v) {_vm.$set(row, "rights_labs", $$v)},expression:"row.rights_labs"}},[_vm._v(" ")])]}}])})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 631:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.upgradableLicenseSubmissions.length > 0)?_c('div',[_c('div',{staticStyle:{"margin-bottom":"12px"}},[_vm._v("\n    Alternatively, you may also customize labs rights for each of your existing films.\n  ")]),_vm._v(" "),_c('el-card',{staticClass:"fla__card"},[_c('h3',[_vm._v("Labs Rights")]),_vm._v(" "),_c('LabsSubmissionTable',{attrs:{"submissions":_vm.upgradableLicenseSubmissions},on:{"change":_vm.submissionTableChange}})],1)],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 632:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(633);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_78827d8e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(639);
var normalizeComponent = __webpack_require__(7)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_78827d8e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 633:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__libs_webcall__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MonetizationSubmissionTable__ = __webpack_require__(634);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var AGREEMENT_FORM_CONSTANT = {
  RIGHTS_THIRD_PARTY_AND_MONETIZATION: {
    THIRD_PARTY_AND_MONETIZATION: 'THIRD_PARTY_AND_MONETIZATION',
    THIRD_PARTY_ONLY: 'THIRD_PARTY_ONLY'
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    MonetizationSubmissionTable: __WEBPACK_IMPORTED_MODULE_4__MonetizationSubmissionTable__["a" /* default */]
  },
  props: {
    licenseRendererVm: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      showCustomisationForEachFilm: false,
      upgradableLicenseSubmissions: [],
      originalLicenseSubmissions: []
    };
  },

  computed: {
    selectedMonetizationRights: function selectedMonetizationRights() {
      return this.licenseRendererVm.form.monetisation.value;
    }
  },
  watch: {
    selectedMonetizationRights: function selectedMonetizationRights(newValue) {
      if (newValue) {
        this.upgradableLicenseSubmissions.forEach(function (submission) {
          submission.rights_third_party_and_monetization = newValue;
        });
        this.updateValue(this.upgradableLicenseSubmissions);
      }
    },
    showCustomisationForEachFilm: function showCustomisationForEachFilm(newValue) {
      if (!newValue) {
        this.enableMonetisationGlobalRadio();
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.getUpgradableLicense().then(function (upgradableLicenseSubmissions) {
      // Hide mediaRights component if user does not have existing upgradable submission
      if (upgradableLicenseSubmissions.length <= 0) {
        _this.licenseRendererVm.hideLicenseRenderer('monetisation', true);
        return upgradableLicenseSubmissions;
      }
      // Prepare submission for display
      var processedSubmissions = _this.prefillSubmissionProperties(upgradableLicenseSubmissions, {
        rights_third_party_and_monetization: AGREEMENT_FORM_CONSTANT.RIGHTS_THIRD_PARTY_AND_MONETIZATION.THIRD_PARTY_AND_MONETIZATION
      });

      // Initialize UI based on display configuration
      _this.initializeExternalUI(_this.getDisplayConfiguration(processedSubmissions));
      return processedSubmissions;
    }).then(function (submissions) {
      // Update parent and self
      _this.upgradableLicenseSubmissions = submissions;
      _this.updateValue(submissions);
    });
  },

  methods: {
    submissionTableChange: function submissionTableChange(_ref) {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref, 3),
          item = _ref2[0],
          property = _ref2[1],
          value = _ref2[2];

      this.disableMonetisationGlobalRadio();
      this.updateValue(this.upgradableLicenseSubmissions);
    },
    disableMonetisationGlobalRadio: function disableMonetisationGlobalRadio() {
      this.licenseRendererVm.$parent.form.rights_third_party_and_monetization = '';
    },
    enableMonetisationGlobalRadio: function enableMonetisationGlobalRadio() {
      if (!this.licenseRendererVm.$parent.form.rights_third_party_and_monetization) {
        this.licenseRendererVm.$parent.form.rights_third_party_and_monetization = AGREEMENT_FORM_CONSTANT.RIGHTS_THIRD_PARTY_AND_MONETIZATION.THIRD_PARTY_AND_MONETIZATION;
      }
    },
    getUpgradableLicense: function getUpgradableLicense() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_3__libs_webcall__["a" /* default */].agreement.getUpgradableLicense({
        params: {
          per_page: 999,
          current_page: 0
        }
      }).then(function (_ref3) {
        var data = _ref3.data;

        _this2.originalLicenseSubmissions = data.videos;
        return data.videos;
      });
    },
    prefillSubmissionProperties: function prefillSubmissionProperties(submissions) {
      var prefillOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return submissions.map(function (submission) {
        var prefillObjects = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(prefillOptions).map(function (prefillKey) {
          var prefillValue = prefillOptions[prefillKey];
          var originalValue = submission[prefillKey];
          return [prefillKey, originalValue, prefillValue];
        }).reduce(function (acc, _ref4) {
          var _ref5 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref4, 3),
              prefillKey = _ref5[0],
              originalValue = _ref5[1],
              prefillValue = _ref5[2];

          if (!originalValue) {
            acc[prefillKey] = prefillValue;
          }
          return acc;
        }, {});

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, submission, prefillObjects);
      });
    },


    /**
     * Compute display configuration for the given submissions array
     */
    getDisplayConfiguration: function getDisplayConfiguration(submissions) {
      var displayConfiguration = submissions.reduce(function (collector, submission) {
        /* eslint camelcase: 0 */
        collector.isEveryAll = collector.isEveryAll && submission.rights_third_party_and_monetization === AGREEMENT_FORM_CONSTANT.RIGHTS_THIRD_PARTY_AND_MONETIZATION.THIRD_PARTY_AND_MONETIZATION;
        collector.isEveryExclude = collector.isEveryExclude && submission.rights_third_party_and_monetization === AGREEMENT_FORM_CONSTANT.RIGHTS_THIRD_PARTY_AND_MONETIZATION.THIRD_PARTY_AND_MONETIZATION;
        return collector;
      }, { isEveryAll: true, isEveryExclude: true });

      return displayConfiguration;
    },
    initializeExternalUI: function initializeExternalUI(displayConfiguration) {
      if (displayConfiguration.isEveryAll) {
        this.licenseRendererVm.$parent.form.rights_third_party_and_monetization = AGREEMENT_FORM_CONSTANT.RIGHTS_THIRD_PARTY_AND_MONETIZATION.THIRD_PARTY_AND_MONETIZATION;
      } else if (displayConfiguration.isEveryExclude) {
        this.licenseRendererVm.$parent.form.rights_third_party_and_monetization = AGREEMENT_FORM_CONSTANT.RIGHTS_THIRD_PARTY_AND_MONETIZATION.THIRD_PARTY_AND_MONETIZATION;
      } else {
        this.disableMonetisationGlobalRadio();
        this.showCustomisationForEachFilm = true;
      }
    },
    updateValue: function updateValue(submissionsToBeUpdated) {
      var allSubmissionIdMap = this.originalLicenseSubmissions.reduce(function (acc, submission) {
        acc[submission.id] = submission;
        return acc;
      }, {});

      // Update payload
      submissionsToBeUpdated.forEach(function (submission) {
        allSubmissionIdMap[submission.id] = submission;
      });

      var payload = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(allSubmissionIdMap).map(function (submissionId) {
        return allSubmissionIdMap[submissionId];
      });

      this.$emit('input', payload);
    }
  }
});

/***/ }),

/***/ 634:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MonetizationSubmissionTable_vue__ = __webpack_require__(637);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fb9a5e40_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MonetizationSubmissionTable_vue__ = __webpack_require__(638);
function injectStyle (ssrContext) {
  __webpack_require__(635)
}
var normalizeComponent = __webpack_require__(7)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MonetizationSubmissionTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fb9a5e40_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MonetizationSubmissionTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 635:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(636);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(512)("1a096d84", content, true);

/***/ }),

/***/ 636:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(511)(true);
// imports


// module
exports.push([module.i, ".submission-table .el-table .cell{word-break:break-word}.el-table td.el-table_1_column_2,.el-table td.el-table_1_column_2 .cell,.el-table td.el-table_1_column_3,.el-table td.el-table_1_column_3 .cell{padding:0}.el-table td.el-table_1_column_2 .cell .el-radio,.el-table td.el-table_1_column_3 .cell .el-radio{height:100%;width:calc(100% - 40px);padding:20px}", "", {"version":3,"sources":["/app/src/components/Licenses/CommonLicenseComponents/AppSpecificLicenseComponent/AppyourLicenseRenewalMonetization/MonetizationSubmissionTable.vue"],"names":[],"mappings":"AACA,kCACE,qBAAuB,CACxB,AAKD,gJAEE,SAAW,CACZ,AACD,kGAEE,YAAa,AACb,wBAAyB,AACzB,YAAc,CACf","file":"MonetizationSubmissionTable.vue","sourcesContent":["\n.submission-table .el-table .cell {\n  word-break: break-word;\n}\n.el-table td.el-table_1_column_2,\n.el-table td.el-table_1_column_3 {\n  padding: 0;\n}\n.el-table td.el-table_1_column_2 .cell,\n.el-table td.el-table_1_column_3 .cell {\n  padding: 0;\n}\n.el-table td.el-table_1_column_2 .cell .el-radio,\n.el-table td.el-table_1_column_3 .cell .el-radio {\n  height: 100%;\n  width: calc(100% - 40px);\n  padding: 20px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 637:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    submissions: {
      type: Array,
      required: true
    }
  }
});

/***/ }),

/***/ 638:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"submission-table"},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.submissions}},[_c('el-table-column',{attrs:{"type":"expand"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var row = ref.row;
return [_c('p',[_vm._v("Submitted on: "+_vm._s(new Date(row.submission_date).toLocaleString()))]),_vm._v(" "),_c('p',[_vm._v("Description: “"+_vm._s(row.description_long)+"”")]),_vm._v(" "),_c('p',[_vm._v("Film year: "+_vm._s(row.year))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"title","label":"Film Title","min-width":"200px"}}),_vm._v(" "),_c('el-table-column',{attrs:{"fixed":"right","label":"(1)","width":"60px","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var row = ref.row;
var column = ref.column;
var $index = ref.$index;
return [_c('el-radio',{attrs:{"label":"THIRD_PARTY_AND_MONETIZATION"},on:{"change":function (newValue) { return _vm.$emit('change', [row, 'rights_third_party_and_monetization', newValue]); }},model:{value:(row.rights_third_party_and_monetization),callback:function ($$v) {_vm.$set(row, "rights_third_party_and_monetization", $$v)},expression:"row.rights_third_party_and_monetization"}},[_vm._v(" ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"fixed":"right","label":"(2)","width":"60px","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var row = ref.row;
var column = ref.column;
var $index = ref.$index;
return [_c('el-radio',{attrs:{"label":"THIRD_PARTY_ONLY"},on:{"change":function (newValue) { return _vm.$emit('change', [row, 'rights_third_party_and_monetization', newValue]); }},model:{value:(row.rights_third_party_and_monetization),callback:function ($$v) {_vm.$set(row, "rights_third_party_and_monetization", $$v)},expression:"row.rights_third_party_and_monetization"}},[_vm._v(" ")])]}}])})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 639:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.upgradableLicenseSubmissions.length > 0)?_c('div',[_c('div',{staticStyle:{"margin-bottom":"12px"}},[_vm._v("\n    Alternatively, you may also customize third party and monetisation rights for each of your existing films.\n  ")]),_vm._v(" "),_c('el-card',{staticClass:"fla__card"},[_c('h3',[_vm._v("Monetisation Rights")]),_vm._v(" "),_c('MonetizationSubmissionTable',{attrs:{"submissions":_vm.upgradableLicenseSubmissions},on:{"change":_vm.submissionTableChange}})],1)],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 640:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.component)?_c(_vm.component,{tag:"component",attrs:{"value":_vm.value,"licenseRendererVm":_vm.licenseRendererVm},on:{"input":_vm.updateValue}}):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 641:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.componentType,_vm._b({ref:"component",tag:"component",attrs:{"licenseRendererVm":_vm.licenseRendererVm,"licenseWrapper":_vm.licenseWrapper,"licenseItem":_vm.licenseItem,"value":_vm.value},on:{"input":function (ref) {
	var fieldName = ref[0];
	var fieldValue = ref[1];

	return _vm.$emit('input', [fieldName, fieldValue]);
}}},'component',_vm.$attrs,false))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 642:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.licenseSpecification)?_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(!_vm.licenseSpecification),expression:"!licenseSpecification"}]},[_c('h1',{staticClass:"fla__title"},[_vm._v(_vm._s(_vm.license.title))]),_vm._v(" "),_c('div',{staticClass:"fla__body"},_vm._l((_vm.licenseSpecification),function(specification){return (!_vm.licenseRendererHideFlag[specification.id])?_c('div',{key:specification.id,staticClass:"license-renderer",attrs:{"id":specification.id}},[(specification.title)?_c('h2',[_vm._v(_vm._s(specification.title)),(specification.optional)?_c('small',[_vm._v(" (Optional)")]):_vm._e()]):_vm._e(),_vm._v(" "),_vm._l((specification.items),function(item,itemIndex){return _c('CommonLicenseComponents',_vm._b({key:((specification.id) + "-" + itemIndex),ref:"CommonLicenseComponents",refInFor:true,staticClass:"license-renderer__common-license-components",attrs:{"licenseRendererVm":_vm.thisComponent,"licenseWrapper":specification,"licenseItem":item},on:{"input":function (ref) {
	var fieldName = ref[0];
	var fieldValue = ref[1];

	return _vm.$emit('input', [fieldName, fieldValue]);
}}},'CommonLicenseComponents',_vm.form[specification.id],false))})],2):_vm._e()}))]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 659:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_debugLogger__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Others_AgreementFallback__ = __webpack_require__(660);






var licenseActionMixin = {
  components: {
    Fallback: __WEBPACK_IMPORTED_MODULE_4__Others_AgreementFallback__["a" /* default */]
  },
  computed: {
    hasErrorInAgreement: function hasErrorInAgreement() {
      return this.$store.state.agreement.hasError;
    }
  },
  mounted: function mounted() {
    this.checkForPendingServiceWorker().then(function (hasPendingUpdate) {
      if (hasPendingUpdate) {
        setTimeout(function () {
          /* eslint no-alert: 0 */
          __WEBPACK_IMPORTED_MODULE_3__utils_debugLogger__["a" /* default */].track.error('User is forced to update application due to viewing license with outdated app.');
          alert(['A critical update is required to display the agreement. Your page will be reloaded.', '', '', 'If you see this message repeatedly, make sure Viddsee Creator is not opened on another tab.'].join('\n'));
        }, 0);
        location.reload();
      }
    });
  },

  methods: {
    /**
     * Check if a pending update exist
     * @return true if a pending update exist, otherwise false
     */
    checkForPendingServiceWorker: function checkForPendingServiceWorker() {
      if (window.userRefusedToUpdate) {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.resolve(true);
      }

      if ('serviceWorker' in navigator) {
        return navigator.serviceWorker.getRegistrations().then(function (registrations) {
          var hasPendingUpdate = registrations.some(function (_ref) {
            var installing = _ref.installing,
                waiting = _ref.waiting;
            return installing || waiting;
          });
          return hasPendingUpdate;
        });
      } else {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.resolve(false);
      }
    }
  },

  functionalMethods: {
    generateFormData: function generateFormData(formFieldProp) {
      var formDefaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // Make form data
      var formFieldPrefiller = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(formFieldProp).reduce(function (acc, formFieldName) {
        var formKeyValuePair = formFieldProp[formFieldName];
        acc[formKeyValuePair.key] = formKeyValuePair.value;
        return acc;
      }, {});

      var resolvedConflictedFormObject = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(formFieldPrefiller).reduce(function (acc, fieldName) {
        // if value for key is already defined, do nothing
        if (formDefaultValue[fieldName] !== undefined) return acc;
        // Otherwise, prefill with value from prefiller
        acc[fieldName] = formFieldPrefiller[fieldName];
        return acc;
      }, {});

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, formDefaultValue, resolvedConflictedFormObject);
    },
    generateFormDefinition: function generateFormDefinition(formFieldProp, vueInstance, propertyName) {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(formFieldProp).reduce(function (acc, formFiledName) {
        var formKeyValuePair = formFieldProp[formFiledName];
        acc[formFiledName] = {
          value: vueInstance[propertyName][formKeyValuePair.key]
        };
        return acc;
      }, {});
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (licenseActionMixin);

/***/ }),

/***/ 660:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AgreementFallback_vue__ = __webpack_require__(661);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_87b96faa_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AgreementFallback_vue__ = __webpack_require__(662);
var normalizeComponent = __webpack_require__(7)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AgreementFallback_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_87b96faa_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AgreementFallback_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 661:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    openSupport: function openSupport() {
      this.$store.commit('dialogue/open', 'support');
    }
  }
});

/***/ }),

/***/ 662:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-width"},[_vm._m(0),_vm._v(" "),_c('sh-spacer',{attrs:{"by":1}}),_vm._v(" "),_c('p',[_vm._v("\n    Please contact the support for any urgent matter.\n    "),_c('el-button',{on:{"click":_vm.openSupport}},[_vm._v("Contact support")])],1)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',[_c('i',{staticClass:"el-icon-error"}),_vm._v(" Sorry, we are unable to show the agreement")]),_vm._v(" "),_c('p',[_vm._v("The support team has been alerted and we will fix this issue immediately.")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 726:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Wrapper_vue__ = __webpack_require__(727);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ea455d5_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Wrapper_vue__ = __webpack_require__(728);
var normalizeComponent = __webpack_require__(7)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Wrapper_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ea455d5_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Wrapper_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 727:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    component: {
      type: Object,
      required: true
    },
    licenseName: {
      type: String,
      required: true
    }
  },
  computed: {
    agreement: function agreement() {
      return this.$store.state.agreement;
    },
    specification: function specification() {
      return this.agreement.specification;
    },
    readyToDisplayAgreement: function readyToDisplayAgreement() {
      return !!this.specification;
    },
    formField: function formField() {
      var _this = this;

      if (!this.readyToDisplayAgreement) return null;

      var license = this.agreement.specification[this.licenseName];
      var licenseActions = license.sequence.filter(function (sequenceName) {
        return _this.agreement.action[sequenceName];
      });

      return licenseActions.reduce(function (acc, actionName) {
        var action = _this.agreement.action[actionName];

        // Do nothing if itemFormName doesn't exist
        if (!action.itemFormName) return acc;

        // Fill itemForm with default value is necessary
        var prefilledValue = action.items.filter(function (_ref) {
          var itemAction = _ref.itemAction;
          return !!itemAction;
        }).reduce(function (existingPrefill, _ref2) {
          var itemAction = _ref2.itemAction;

          switch (itemAction.inputValuePrefilled) {
            case 'TRUE':
            case 'true':
              return true;
            case 'FALSE':
            case 'false':
              return false;
            case null:
            case undefined:
              return existingPrefill;
            default:
              return itemAction.inputValuePrefilled;
          }
        }, undefined);

        acc[actionName] = {
          key: action.itemFormName,
          value: prefilledValue
        };
        return acc;
      }, {});
    }
  }
});

/***/ }),

/***/ 728:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.readyToDisplayAgreement && _vm.formField)?_c('div',[_c(_vm.component,{tag:"component",attrs:{"formField":_vm.formField,"licenseName":_vm.licenseName,"specification":_vm.specification}})],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 844:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AgreementIntroPage__ = __webpack_require__(845);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CommonLicenseComponents_Wrapper__ = __webpack_require__(726);
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    CommonLicenseComponentsWrapper: __WEBPACK_IMPORTED_MODULE_1__CommonLicenseComponents_Wrapper__["a" /* default */]
  },
  data: function data() {
    return {
      component: __WEBPACK_IMPORTED_MODULE_0__AgreementIntroPage__["a" /* default */]
    };
  }
});

/***/ }),

/***/ 845:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AgreementIntroPage_vue__ = __webpack_require__(848);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_81044168_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AgreementIntroPage_vue__ = __webpack_require__(849);
function injectStyle (ssrContext) {
  __webpack_require__(846)
}
var normalizeComponent = __webpack_require__(7)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AgreementIntroPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_81044168_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AgreementIntroPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 846:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(847);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(512)("6b10e6f8", content, true);

/***/ }),

/***/ 847:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(511)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"AgreementIntroPage.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 848:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__libs_webcall__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_licenseParentMixin__ = __webpack_require__(659);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CommonLicenseComponents_LicenseRenderer__ = __webpack_require__(563);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_licenseParentMixin__["a" /* default */]],
  components: {
    LicenseRenderer: __WEBPACK_IMPORTED_MODULE_3__CommonLicenseComponents_LicenseRenderer__["a" /* default */]
  },
  props: {
    licenseName: {
      type: String,
      required: true
    },
    formField: {
      type: Object,
      required: true
    },
    specification: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      form: __WEBPACK_IMPORTED_MODULE_2__mixins_licenseParentMixin__["a" /* default */].functionalMethods.generateFormData(this.$options.propsData.formField),
      loading: false
    };
  },

  computed: {
    agreement: function agreement() {
      return this.$store.state.agreement;
    },
    formDefinition: function formDefinition() {
      return __WEBPACK_IMPORTED_MODULE_2__mixins_licenseParentMixin__["a" /* default */].functionalMethods.generateFormDefinition(this.$options.propsData.formField, this, 'form');
    }
  },
  methods: {
    handleLicenseUpdate: function handleLicenseUpdate(_ref) {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
          fieldname = _ref2[0],
          fieldValue = _ref2[1];

      // This will handle the update for primitive value
      // Complex object such as film details and filmmaker are handled by mutating inner properties of object
      // (This is not the best way, if you have time to implement a proper solution, consider doing it.)
      this.form[fieldname] = fieldValue;
    },
    submit: function submit() {
      var _this = this;

      this.loading = true;
      if (!this.form['terms-and-conditions']) {
        return;
      }
      __WEBPACK_IMPORTED_MODULE_1__libs_webcall__["a" /* default */].agreement.sign(this.form).then(function () {
        return _this.$store.dispatch('account/initialiseAccount');
      }).then(function () {
        _this.loading = false;
        _this.$router.push('/');
      }).catch(function (error) {
        _this.loading = false;
        throw error;
      });
    }
  }
});

/***/ }),

/***/ 849:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.hasErrorInAgreement)?_c('div',{staticClass:"content-width"},[_c('sh-spacer',{attrs:{"by":1}}),_vm._v(" "),_c('el-alert',{attrs:{"title":"Please read and agree to the terms and conditions","type":"info","show-icon":""}}),_vm._v(" "),_c('sh-spacer',{attrs:{"by":3}}),_vm._v(" "),_c('LicenseRenderer',{attrs:{"licenseName":_vm.licenseName,"form":_vm.formDefinition},on:{"input":_vm.handleLicenseUpdate}}),_vm._v(" "),_c('sh-spacer',{attrs:{"by":2}}),_vm._v(" "),_c('div',{staticStyle:{"text-align":"right"}},[_c('el-button',{attrs:{"disabled":!this.form['terms-and-conditions'],"loading":_vm.loading,"type":"primary"},on:{"click":_vm.submit}},[_vm._v("\n        Agree\n      ")])],1),_vm._v(" "),_c('sh-spacer',{attrs:{"by":4}})],1):_c('Fallback')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 850:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CommonLicenseComponentsWrapper',{attrs:{"component":_vm.component,"licenseName":"intro"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// js/3.6a475182a7841b2e61cf.js